import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const ReceiptSearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h7a2 2 0 0 1 2 2v7h3v2a3 3 0 0 1-3 3h-2.08c-.08-.2-.2-.4-.36-.56l-2-2A4.5 4.5 0 0 0 9.25 10h1.25a.5.5 0 0 0 0-1H8.33A4.5 4.5 0 0 0 3 8.76V5Zm11 11a2 2 0 0 0 2-2v-1h-2v3ZM6.5 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm1.1 9.3a3.48 3.48 0 0 1-4.27-.06 3.5 3.5 0 1 1 4.97-.64l2.56 2.54a.5.5 0 0 1-.71.71L7.6 15.3Zm-3.49-.72a2.5 2.5 0 1 0 2.78-4.16 2.5 2.5 0 0 0-2.78 4.16Z",
    fill: primaryFill
  }));
};

export const ReceiptSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptSearchFilledIcon, 'ReceiptSearchFilled');

const ReceiptSearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 8.76V5c0-.26.05-.52.16-.76.1-.23.24-.45.42-.64A1.9 1.9 0 0 1 4.96 3h7.08c.26 0 .52.05.76.16.23.11.44.26.62.44s.33.4.42.63c.1.25.16.5.16.77v7h3v2.06c0 .39-.08.77-.23 1.12-.31.7-.88 1.27-1.58 1.58-.36.15-.74.24-1.13.24h-2.14c-.08-.2-.2-.4-.36-.56l-.44-.44H13V5a.95.95 0 0 0-.08-.38 1.11 1.11 0 0 0-.2-.32A1.01 1.01 0 0 0 12 4H4.99a.97.97 0 0 0-.7.29c-.1.1-.17.2-.22.32A.86.86 0 0 0 4 5v3.26c-.35.12-.69.3-1 .5ZM14.04 16c.25 0 .5-.05.74-.16.47-.2.85-.58 1.06-1.05.1-.24.16-.5.16-.75V13h-2v3h.04Zm-4.8-6h1.26a.5.5 0 1 0 0-1H8.33c.36.29.67.62.92 1ZM6.5 7a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1h-4Zm1.1 8.3a3.48 3.48 0 0 1-4.27-.06 3.5 3.5 0 1 1 4.97-.64l2.56 2.54a.5.5 0 0 1-.71.71L7.6 15.3Zm-3.49-.72a2.5 2.5 0 1 0 2.78-4.16 2.5 2.5 0 0 0-2.78 4.16Z",
    fill: primaryFill
  }));
};

export const ReceiptSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptSearchRegularIcon, 'ReceiptSearchRegular');

const ReceiptSparklesFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.23 1.35 14.88.28a.42.42 0 0 0-.8 0l-.35 1.07a2.2 2.2 0 0 1-1.38 1.4l-1.07.35a.42.42 0 0 0 0 .8l1.07.34a2.2 2.2 0 0 1 1.4 1.4l.35 1.08a.42.42 0 0 0 .8 0l.35-1.07a2.2 2.2 0 0 1 1.4-1.4l1.07-.35a.42.42 0 0 0 0-.8h-.02l-1.08-.35a2.2 2.2 0 0 1-1.4-1.4Zm3.79 6.61.76.25h.02a.3.3 0 0 1 0 .58l-.77.25a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.58 1.58 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.57 1.57 0 0 0 1 1ZM14 8.5V12h2.5c.28 0 .5.22.5.5V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V5c0-1.1.9-2 2-2h5.1c-.06.16-.1.33-.1.5a1.42 1.42 0 0 0 1 1.34l1.1.36a1 1 0 0 1 .4.23l.06.06c.11.1.2.24.26.38L13.15 7c.09.26.25.49.46.66.12.09.25.15.39.2v.21a1.3 1.3 0 0 0 0 .43Zm0 7.5a2 2 0 0 0 2-2v-1h-2v3ZM6.5 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm0 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z",
    fill: primaryFill
  }));
};

export const ReceiptSparklesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptSparklesFilledIcon, 'ReceiptSparklesFilled');

const ReceiptSparklesRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.23 1.35 14.88.28a.42.42 0 0 0-.8 0l-.35 1.07a2.2 2.2 0 0 1-1.38 1.4l-1.07.35a.42.42 0 0 0 0 .8l1.07.34a2.2 2.2 0 0 1 1.4 1.4l.35 1.08a.42.42 0 0 0 .8 0l.35-1.07a2.2 2.2 0 0 1 1.4-1.4l1.07-.35a.42.42 0 0 0 0-.8h-.02l-1.08-.35a2.2 2.2 0 0 1-1.4-1.4Zm3.79 6.61.76.25h.02a.3.3 0 0 1 0 .58l-.77.25a1.58 1.58 0 0 0-1 1l-.24.76a.3.3 0 0 1-.58 0l-.24-.77a1.58 1.58 0 0 0-1-1l-.77-.25a.3.3 0 0 1 0-.57l.77-.25a1.58 1.58 0 0 0 .98-1l.25-.76a.3.3 0 0 1 .57 0l.25.77a1.57 1.57 0 0 0 1 1ZM14 8.5a1.3 1.3 0 0 1 0-.43v-.21c-.14-.05-.27-.11-.39-.2-.21-.17-.37-.4-.46-.66L13 6.49V16H6a2 2 0 0 1-2-2V5a1 1 0 0 1 1-1h5.1c-.06-.16-.1-.33-.1-.5 0-.17.04-.34.1-.5H5a2 2 0 0 0-2 2v9a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1.5a.5.5 0 0 0-.5-.5H14V8.5Zm0 4.5h2v1a2 2 0 0 1-2 2v-3ZM6 6.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm0 3c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm0 3c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ReceiptSparklesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReceiptSparklesRegularIcon, 'ReceiptSparklesRegular');

const RecordFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 4.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z",
    fill: primaryFill
  }));
};

export const RecordFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecordFilledIcon, 'RecordFilled');

const RecordRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z",
    fill: primaryFill
  }));
};

export const RecordRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecordRegularIcon, 'RecordRegular');

const RecordStopFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8 7h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Z",
    fill: primaryFill
  }));
};

export const RecordStopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecordStopFilledIcon, 'RecordStopFilled');

const RecordStopRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm5-2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8Z",
    fill: primaryFill
  }));
};

export const RecordStopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecordStopRegularIcon, 'RecordStopRegular');

const RectangleLandscapeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Z",
    fill: primaryFill
  }));
};

export const RectangleLandscapeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RectangleLandscapeFilledIcon, 'RectangleLandscapeFilled');

const RectangleLandscapeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5Z",
    fill: primaryFill
  }));
};

export const RectangleLandscapeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RectangleLandscapeRegularIcon, 'RectangleLandscapeRegular');

const RectanglePortraitLocationTargetFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h5.7a4.5 4.5 0 0 1-1.43-2.02 1.5 1.5 0 0 1 0-2.96 4.49 4.49 0 0 1 2.75-2.75 1.5 1.5 0 0 1 2.96 0H16V4a2 2 0 0 0-2-2H6Zm9.06 13.33a1 1 0 1 1-1.12-1.66 1 1 0 0 1 1.12 1.66ZM17.95 14h.55a.5.5 0 0 1 0 1h-.55A3.49 3.49 0 0 1 15 17.95v.55a.5.5 0 0 1-1 0v-.55A3.49 3.49 0 0 1 11.05 15h-.55a.5.5 0 0 1 0-1h.55A3.49 3.49 0 0 1 14 11.05v-.55a.5.5 0 0 1 1 0v.55A3.49 3.49 0 0 1 17.95 14Zm-3.2 2.99a2.5 2.5 0 1 0-.5-4.98 2.5 2.5 0 0 0 .5 4.98Z",
    fill: primaryFill
  }));
};

export const RectanglePortraitLocationTargetFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RectanglePortraitLocationTargetFilledIcon, 'RectanglePortraitLocationTargetFilled');

const RectanglePortraitLocationTargetRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v6.27h-.02A1.5 1.5 0 0 0 15 9.09V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4.78a4.5 4.5 0 0 0 .92 1H6a2 2 0 0 1-2-2V4Zm11.06 11.33a1 1 0 1 1-1.12-1.66 1 1 0 0 1 1.12 1.66ZM17.95 14h.55a.5.5 0 0 1 0 1h-.55A3.49 3.49 0 0 1 15 17.95v.55a.5.5 0 0 1-1 0v-.55A3.49 3.49 0 0 1 11.05 15h-.55a.5.5 0 0 1 0-1h.55A3.49 3.49 0 0 1 14 11.05v-.55a.5.5 0 0 1 1 0v.55A3.49 3.49 0 0 1 17.95 14Zm-3.2 2.99a2.5 2.5 0 1 0-.5-4.98 2.5 2.5 0 0 0 .5 4.98Z",
    fill: primaryFill
  }));
};

export const RectanglePortraitLocationTargetRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RectanglePortraitLocationTargetRegularIcon, 'RectanglePortraitLocationTargetRegular');

const RecycleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.9 3.04a1.25 1.25 0 0 1 2.2 0l1.66 3.1-1.02-.35a.75.75 0 0 0-.48 1.42l3 1a.75.75 0 0 0 .98-.59l.5-3a.75.75 0 1 0-1.48-.24l-.17 1.04-1.67-3.1a2.75 2.75 0 0 0-4.84 0L5.84 5.57a.75.75 0 0 0 1.33.7L8.9 3.05Zm8.04 10.87-1.91-3.56a.75.75 0 1 1 1.32-.71l1.91 3.56a2.75 2.75 0 0 1-2.42 4.05H12.3l.72.72a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 1 1 1.06 1.06l-.72.72h3.53c.94 0 1.55-1 1.1-1.84Zm-9.69 1.84a.75.75 0 0 1 0 1.5H4.16a2.75 2.75 0 0 1-2.42-4.05L3.6 9.76l-1.35.45a.75.75 0 1 1-.48-1.42l3-1a.75.75 0 0 1 .95.47l1 3a.75.75 0 1 1-1.42.48l-.4-1.22-1.83 3.39c-.44.83.16 1.84 1.1 1.84h3.09Z",
    fill: primaryFill
  }));
};

export const RecycleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecycleFilledIcon, 'RecycleFilled');

const RecycleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.32 2.92a1.5 1.5 0 0 0-2.64 0L6.83 6.37a.5.5 0 1 1-.88-.47L7.8 2.45a2.5 2.5 0 0 1 4.4 0l2.01 3.74.3-1.77a.5.5 0 0 1 .98.16l-.5 3a.5.5 0 0 1-.65.4l-3-1a.5.5 0 0 1 .32-.95l1.62.54-1.96-3.65Zm4.03 6.4a.5.5 0 0 0-.22.7l2.03 3.77c.54 1-.19 2.21-1.32 2.21H11.7l1.14-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L11.71 17h4.13a2.5 2.5 0 0 0 2.2-3.68l-2.03-3.78a.5.5 0 0 0-.66-.21ZM4.16 16H7.5a.5.5 0 0 1 0 1H4.16a2.5 2.5 0 0 1-2.2-3.68l2.15-4-1.95.65a.5.5 0 1 1-.32-.94l3-1a.5.5 0 0 1 .63.31l1 3a.5.5 0 0 1-.94.32l-.6-1.77-2.09 3.9A1.5 1.5 0 0 0 4.16 16Z",
    fill: primaryFill
  }));
};

export const RecycleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RecycleRegularIcon, 'RecycleRegular');

const RemoteFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.97 15.03a.75.75 0 1 0 1.06-1.06L12.56 8.5l5.47-5.47a.75.75 0 0 0-1.06-1.06l-6 6c-.3.3-.3.77 0 1.06l6 6ZM3.03 4.97a.75.75 0 0 0-1.06 1.06l5.47 5.47-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6c.3-.3.3-.77 0-1.06l-6-6Z",
    fill: primaryFill
  }));
};

export const RemoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RemoteFilledIcon, 'RemoteFilled');

const RemoteRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.15 14.85a.5.5 0 0 0 .7-.7L12.21 8.5l5.64-5.65a.5.5 0 0 0-.7-.7l-6 6a.5.5 0 0 0 0 .7l6 6Zm-14.3-9.7a.5.5 0 1 0-.7.7l5.64 5.65-5.64 5.65a.5.5 0 0 0 .7.7l6-6a.5.5 0 0 0 0-.7l-6-6Z",
    fill: primaryFill
  }));
};

export const RemoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RemoteRegularIcon, 'RemoteRegular');

const RenameFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2a.5.5 0 0 0 0 1h1v14h-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-1V3h1a.5.5 0 0 0 0-1h-3Zm-4 2h4v12h-4A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4Zm11 12h-4V4h4A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5Z",
    fill: primaryFill
  }));
};

export const RenameFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RenameFilledIcon, 'RenameFilled');

const RenameRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2a.5.5 0 0 0 0 1h1v14h-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-1V3h1a.5.5 0 0 0 0-1h-3Zm-4 2h4v1h-4C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h4v1h-4A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4Zm11 11h-4v1h4a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-4v1h4c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5Z",
    fill: primaryFill
  }));
};

export const RenameRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RenameRegularIcon, 'RenameRegular');

const ReorderFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 7.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75Zm0 3a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H2.75Z",
    fill: primaryFill
  }));
};

export const ReorderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReorderFilledIcon, 'ReorderFilled');

const ReorderRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 8a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Zm0 3a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z",
    fill: primaryFill
  }));
};

export const ReorderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReorderRegularIcon, 'ReorderRegular');

const ReplayFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.5v-3a.5.5 0 0 1 1 0v1.2a7.98 7.98 0 0 1 7.94-2.46A8 8 0 1 1 2 9.48a.5.5 0 1 1 1 .07A6.97 6.97 0 0 0 3 10a7 7 0 1 0 1.25-4H6a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1-.5-.5Zm4.5 1.47c0-.93.98-1.54 1.81-1.12l4.04 2.03c.92.47.92 1.77 0 2.24l-4.04 2.03a1.25 1.25 0 0 1-1.81-1.12V7.97Z",
    fill: primaryFill
  }));
};

export const ReplayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReplayFilledIcon, 'ReplayFilled');

const ReplayRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.5v-3a.5.5 0 0 1 1 0v1.2a7.98 7.98 0 0 1 7.94-2.46A8 8 0 1 1 2 9.48a.5.5 0 1 1 1 .07A6.97 6.97 0 0 0 3 10a7 7 0 1 0 1.25-4H6a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1-.5-.5Zm4.5 1.47c0-.93.98-1.54 1.81-1.12l4.04 2.03c.92.47.92 1.77 0 2.24l-4.04 2.03a1.25 1.25 0 0 1-1.81-1.12V7.97Zm1.36-.23a.25.25 0 0 0-.36.23v4.06c0 .19.2.31.36.23l4.04-2.04a.25.25 0 0 0 0-.44L8.86 7.74Z",
    fill: primaryFill
  }));
};

export const ReplayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ReplayRegularIcon, 'ReplayRegular');

const ResizeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 2A3.25 3.25 0 0 0 2 5.25v3a.75.75 0 0 0 1.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 0 0 0-1.5h-3Zm6.5 0a.75.75 0 0 0 0 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 0 0 1.5 0v-3C18 3.45 16.54 2 14.75 2h-3Zm-9 9c.41 0 .75.34.75.75v3c0 .97.78 1.75 1.75 1.75h3a.75.75 0 0 1 0 1.5h-3A3.25 3.25 0 0 1 2 14.75v-3c0-.41.34-.75.75-.75Zm15.25.75a.75.75 0 0 0-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 0 0 0 1.5h3c1.8 0 3.25-1.46 3.25-3.25v-3Z",
    fill: primaryFill
  }));
};

export const ResizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeFilledIcon, 'ResizeFilled');

const ResizeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a3 3 0 0 0-3 3v3.5a.5.5 0 0 0 1 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1H5Zm6.5 0a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3h-3.5Zm-9 9c.28 0 .5.22.5.5V15c0 1.1.9 2 2 2h3.5a.5.5 0 0 1 0 1H5a3 3 0 0 1-3-3v-3.5c0-.28.22-.5.5-.5Zm15.5.5a.5.5 0 0 0-1 0V15a2 2 0 0 1-2 2h-3.5a.5.5 0 0 0 0 1H15a3 3 0 0 0 3-3v-3.5Z",
    fill: primaryFill
  }));
};

export const ResizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeRegularIcon, 'ResizeRegular');

const ResizeImageFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 2A3.25 3.25 0 0 0 2 5.25v3a.75.75 0 0 0 1.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 0 0 0-1.5h-3Zm6.5 0a.75.75 0 0 0 0 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 0 0 1.5 0v-3C18 3.45 16.54 2 14.75 2h-3ZM18 11.75a.75.75 0 0 0-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 0 0 0 1.5h3c1.8 0 3.25-1.46 3.25-3.25v-3ZM1 12.5A2.5 2.5 0 0 1 3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0L1.4 17.88C1.15 17.48 1 17 1 16.5v-4Zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-5.88 5.84c.4.26.87.41 1.38.41h4c.51 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0L2.12 18.6Z",
    fill: primaryFill
  }));
};

export const ResizeImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeImageFilledIcon, 'ResizeImageFilled');

const ResizeImageRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a3 3 0 0 0-3 3v3.5a.5.5 0 0 0 1 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1H5Zm6.5 0a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3h-3.5Zm6.5 9.5a.5.5 0 0 0-1 0V15a2 2 0 0 1-2 2h-3.5a.5.5 0 0 0 0 1H15a3 3 0 0 0 3-3v-3.5Zm-17 1A2.5 2.5 0 0 1 3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0L1.4 17.88C1.15 17.48 1 17 1 16.5v-4Zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-5.88 5.84c.4.26.87.41 1.38.41h4c.51 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0L2.12 18.6Z",
    fill: primaryFill
  }));
};

export const ResizeImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeImageRegularIcon, 'ResizeImageRegular');

const ResizeLargeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-1Zm1 1C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7Zm8-1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 14.5 3h-1a.5.5 0 0 0 0 1h1Zm0 12c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1h1Zm-9 0A1.5 1.5 0 0 1 4 14.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 5.5 17h1.25a.5.5 0 0 0 0-1H5.5Z",
    fill: primaryFill
  }));
};

export const ResizeLargeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeLargeFilledIcon, 'ResizeLargeFilled');

const ResizeLargeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-1ZM16 5.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0v-1Zm0 9c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0v1Zm-12 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0v1.25ZM6.5 5C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7ZM6 6.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7Z",
    fill: primaryFill
  }));
};

export const ResizeLargeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeLargeRegularIcon, 'ResizeLargeRegular');

const ResizeSmallFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-1Zm3 3C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-3Zm6-3c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 0 1 0v-1A2.5 2.5 0 0 0 14.5 3h-1a.5.5 0 0 0 0 1h1Zm0 12c.83 0 1.5-.67 1.5-1.5v-1a.5.5 0 0 1 1 0v1a2.5 2.5 0 0 1-2.5 2.5h-1a.5.5 0 0 1 0-1h1Zm-9 0A1.5 1.5 0 0 1 4 14.5v-1.25a.5.5 0 0 0-1 0v1.25A2.5 2.5 0 0 0 5.5 17h1.25a.5.5 0 0 0 0-1H5.5Z",
    fill: primaryFill
  }));
};

export const ResizeSmallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeSmallFilledIcon, 'ResizeSmallFilled');

const ResizeSmallRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4C4.67 4 4 4.67 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-1ZM16 5.5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0v-1Zm0 9c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0v1Zm-12 0c0 .83.67 1.5 1.5 1.5h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0v1.25ZM8.5 7C7.67 7 7 7.67 7 8.5v3c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-3ZM8 8.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3Z",
    fill: primaryFill
  }));
};

export const ResizeSmallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeSmallRegularIcon, 'ResizeSmallRegular');

const ResizeTableFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a3 3 0 0 0-3 3v2.35c.29-.32.62-.6 1-.81V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1H5Zm10 16h-2.35c.32-.29.6-.62.81-1H15a2 2 0 0 0 2-2v-3.5a.5.5 0 0 1 1 0V15a3 3 0 0 1-3 3ZM11.5 2a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3h-3.5ZM5 7a3 3 0 0 0-3 3h3V7Zm0 4v3H2v-3h3Zm0 4H2a3 3 0 0 0 3 3v-3Zm1 0h3v3H6v-3Zm0-1h3v-3H6v3Zm4 1h3a3 3 0 0 1-3 3v-3Zm0-4v3h3v-3h-3Zm0-1V7a3 3 0 0 1 3 3h-3ZM6 7h3v3H6V7Z",
    fill: primaryFill
  }));
};

export const ResizeTableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeTableFilledIcon, 'ResizeTableFilled');

const ResizeTableRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a3 3 0 0 0-3 3v2.35c.29-.32.62-.6 1-.81V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1H5Zm10 16h-2.35c.32-.29.6-.62.81-1H15a2 2 0 0 0 2-2v-3.5a.5.5 0 0 1 1 0V15a3 3 0 0 1-3 3ZM11.5 2a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3h-3.5ZM5 7a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3H5Zm-2 3c0-1.1.9-2 2-2v2H3Zm3 0V8h3v2H6Zm4 0V8a2 2 0 0 1 2 2h-2Zm-4 1h3v3H6v-3Zm4 0h2v3h-2v-3Zm-4 4h3v2H6v-2Zm6 0a2 2 0 0 1-2 2v-2h2Zm-9-4h2v3H3v-3Zm0 4h2v2a2 2 0 0 1-2-2Z",
    fill: primaryFill
  }));
};

export const ResizeTableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeTableRegularIcon, 'ResizeTableRegular');

const ResizeVideoFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 2A3.25 3.25 0 0 0 2 5.25v3a.75.75 0 0 0 1.5 0v-3c0-.97.78-1.75 1.75-1.75h3a.75.75 0 0 0 0-1.5h-3Zm6.5 0a.75.75 0 0 0 0 1.5h3c.97 0 1.75.78 1.75 1.75v3a.75.75 0 0 0 1.5 0v-3C18 3.45 16.54 2 14.75 2h-3ZM18 11.75a.75.75 0 0 0-1.5 0v3c0 .97-.78 1.75-1.75 1.75h-3a.75.75 0 0 0 0 1.5h3c1.8 0 3.25-1.46 3.25-3.25v-3ZM3.5 10h4a2.5 2.5 0 0 1 2.5 2.5v4A2.5 2.5 0 0 1 7.5 19h-4A2.5 2.5 0 0 1 1 16.5v-4A2.5 2.5 0 0 1 3.5 10Zm.72 2.55a.5.5 0 0 0-.72.45v3a.5.5 0 0 0 .72.45l3-1.5a.5.5 0 0 0 0-.9l-3-1.5Z",
    fill: primaryFill
  }));
};

export const ResizeVideoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeVideoFilledIcon, 'ResizeVideoFilled');

const ResizeVideoRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a3 3 0 0 0-3 3v3.5a.5.5 0 0 0 1 0V5c0-1.1.9-2 2-2h3.5a.5.5 0 0 0 0-1H5Zm6.5 0a.5.5 0 0 0 0 1H15a2 2 0 0 1 2 2v3.5a.5.5 0 0 0 1 0V5a3 3 0 0 0-3-3h-3.5Zm6.5 9.5a.5.5 0 0 0-1 0V15a2 2 0 0 1-2 2h-3.5a.5.5 0 0 0 0 1H15a3 3 0 0 0 3-3v-3.5ZM3.5 10A2.5 2.5 0 0 0 1 12.5v4A2.5 2.5 0 0 0 3.5 19h4a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 7.5 10h-4Zm.72 2.55 3 1.5a.5.5 0 0 1 0 .9l-3 1.5A.5.5 0 0 1 3.5 16v-3a.5.5 0 0 1 .72-.45Z",
    fill: primaryFill
  }));
};

export const ResizeVideoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ResizeVideoRegularIcon, 'ResizeVideoRegular');

const RewardFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.53 3c.82 0 1.5.67 1.5 1.5v1.4c0 .93-.53 1.8-1.37 2.22l-4.19 2.14a3.54 3.54 0 1 1-2.92 0L4.36 8.12a2.5 2.5 0 0 1-1.35-2.04L3 5.9V4.5C3 3.67 3.67 3 4.5 3h11.03ZM10 10.95a2.54 2.54 0 1 0 0 5.07 2.54 2.54 0 0 0 0-5.07ZM12.61 4h-5.2v4.55l2.38 1.22a.5.5 0 0 0 .45 0l2.38-1.22V4Z",
    fill: primaryFill
  }));
};

export const RewardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RewardFilledIcon, 'RewardFilled');

const RewardRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.53 3c.83 0 1.5.67 1.5 1.5v1.4c0 .94-.53 1.8-1.36 2.22l-4.2 2.14a3.54 3.54 0 1 1-2.92 0L4.36 8.12a2.5 2.5 0 0 1-1.35-2.04V4.5C3 3.67 3.66 3 4.5 3h11.02ZM10 10.95a2.54 2.54 0 1 0 0 5.08 2.54 2.54 0 0 0 0-5.08ZM12.55 4H7.47V8.6L9.8 9.77a.5.5 0 0 0 .45 0l2.31-1.18V4ZM6.47 4H4.5a.5.5 0 0 0-.5.5v1.54c.06.5.36.96.82 1.2l1.65.84V4Zm9.06 0h-1.98v4.08l1.66-.85c.5-.25.82-.77.82-1.33V4.5a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const RewardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RewardRegularIcon, 'RewardRegular');

const RewindFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.49a1 1 0 0 0-1.6-.8l-5.87 4.3c-.68.5-.68 1.52 0 2.02l5.88 4.31a1 1 0 0 0 1.59-.8v-3.17l5.4 3.97a1 1 0 0 0 1.6-.8V5.48a1 1 0 0 0-1.6-.8L10 8.64V5.49Zm-1.6-.8.3.39Z",
    fill: primaryFill
  }));
};

export const RewindFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RewindFilledIcon, 'RewindFilled');

const RewindRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.49a1 1 0 0 0-1.6-.8l-5.87 4.3c-.68.5-.68 1.52 0 2.02l5.88 4.31a1 1 0 0 0 1.59-.8v-3.17l5.4 3.97a1 1 0 0 0 1.6-.8V5.48a1 1 0 0 0-1.6-.8L10 8.64V5.49Zm-6.88 4.3L9 5.5v9.02l-5.88-4.3a.25.25 0 0 1 0-.41Zm7 0L16 5.5v9.02l-5.88-4.3a.25.25 0 0 1 0-.41Z",
    fill: primaryFill
  }));
};

export const RewindRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RewindRegularIcon, 'RewindRegular');

const RhombusFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.89 4.3A2 2 0 0 1 6.76 3H17a2 2 0 0 1 1.87 2.7l-3.76 10a2 2 0 0 1-1.87 1.3H3a2 2 0 0 1-1.87-2.7l3.76-10Z",
    fill: primaryFill
  }));
};

export const RhombusFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RhombusFilledIcon, 'RhombusFilled');

const RhombusRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.89 4.3A2 2 0 0 1 6.76 3H17a2 2 0 0 1 1.87 2.7l-3.76 10a2 2 0 0 1-1.87 1.3H3a2 2 0 0 1-1.87-2.7l3.76-10ZM6.76 4a1 1 0 0 0-.93.65l-3.76 10A1 1 0 0 0 3 16h10.24a1 1 0 0 0 .93-.65l3.76-10A1 1 0 0 0 17 4H6.76Z",
    fill: primaryFill
  }));
};

export const RhombusRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RhombusRegularIcon, 'RhombusRegular');

const RibbonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 8A6 6 0 1 1 4 8a6 6 0 0 1 12 0Zm-6 7c1.49 0 2.87-.46 4-1.25v3.75a.5.5 0 0 1-.8.4L10 16l-3.2 1.9a.5.5 0 0 1-.8-.4v-3.75A6.97 6.97 0 0 0 10 15Z",
    fill: primaryFill
  }));
};

export const RibbonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonFilledIcon, 'RibbonFilled');

const RibbonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 8c0 1.78-.77 3.37-2 4.47v5.03a.5.5 0 0 1-.75.43L10 16.08l-3.25 1.85A.5.5 0 0 1 6 17.5v-5.03A5.98 5.98 0 0 1 10 2a6 6 0 0 1 6 6Zm-6 6c-1.1 0-2.12-.3-3-.8v3.44l2.75-1.57a.5.5 0 0 1 .5 0L13 16.64V13.2c-.88.5-1.9.8-3 .8Zm0-1a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: primaryFill
  }));
};

export const RibbonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonRegularIcon, 'RibbonRegular');

const RibbonAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15V3.5Zm-6 2c0-1.28.44-2.45 1.17-3.39A6 6 0 1 0 14.2 11 5.5 5.5 0 0 1 9 5.5ZM9 15c1.49 0 2.87-.46 4-1.25v3.75a.5.5 0 0 1-.8.4L9 16l-3.2 1.9a.5.5 0 0 1-.8-.4v-3.75A6.97 6.97 0 0 0 9 15Z",
    fill: primaryFill
  }));
};

export const RibbonAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonAddFilledIcon, 'RibbonAddFilled');

const RibbonAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15V3.5ZM9 2c.4 0 .79.04 1.17.11-.23.29-.42.6-.59.92a5 5 0 1 0 3.54 7.8c.35.09.71.14 1.08.16a6.03 6.03 0 0 1-1.2 1.48v5.03a.5.5 0 0 1-.75.43L9 16.08l-3.25 1.85A.5.5 0 0 1 5 17.5v-5.03A5.98 5.98 0 0 1 9 2Zm0 12c-1.1 0-2.12-.3-3-.8v3.44l2.75-1.57a.5.5 0 0 1 .5 0L12 16.64V13.2c-.88.5-1.9.8-3 .8Z",
    fill: primaryFill
  }));
};

export const RibbonAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonAddRegularIcon, 'RibbonAddRegular');

const RibbonOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.62 5.33a6 6 0 0 0 8.04 8.04l.75.75A6.97 6.97 0 0 1 6 13.75v3.75a.5.5 0 0 0 .8.4L10 16l3.2 1.9a.5.5 0 0 0 .8-.4v-2.8l3.15 3.15a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7l2.47 2.48Zm1.2-1.63 8.48 8.48A6 6 0 0 0 5.82 3.7Z",
    fill: primaryFill
  }));
};

export const RibbonOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonOffFilledIcon, 'RibbonOffFilled');

const RibbonOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.62 5.33 2.15 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7L14 14.71v2.79a.5.5 0 0 1-.75.43L10 16.08l-3.25 1.85A.5.5 0 0 1 6 17.5v-5.03a5.98 5.98 0 0 1-1.38-7.14Zm8.05 8.05A5.98 5.98 0 0 1 7 13.2v3.44l2.75-1.57a.5.5 0 0 1 .5 0L13 16.64V13.7l-.33-.33Zm-.76-.76L5.38 6.1A4.98 4.98 0 0 0 10 13c.68 0 1.32-.13 1.91-.38ZM15 8c0 1.35-.53 2.57-1.4 3.47l.7.71A6 6 0 0 0 5.82 3.7l.7.7A4.98 4.98 0 0 1 15 8Z",
    fill: primaryFill
  }));
};

export const RibbonOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonOffRegularIcon, 'RibbonOffRegular');

const RibbonStarFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 8A6 6 0 1 1 4 8a6 6 0 0 1 12 0ZM9.85 5.1l-.72 1.55a.18.18 0 0 1-.14.1l-1.7.2c-.14.02-.2.2-.1.3l1.26 1.17c.05.04.07.1.05.16l-.33 1.68c-.03.15.13.26.26.19l1.49-.84a.18.18 0 0 1 .17 0l1.5.84c.12.07.28-.04.25-.19l-.33-1.68a.17.17 0 0 1 .05-.16l1.26-1.16a.18.18 0 0 0-.1-.3l-1.7-.2a.17.17 0 0 1-.14-.1l-.72-1.56a.17.17 0 0 0-.31 0ZM10 15c1.49 0 2.87-.46 4-1.25v3.75a.5.5 0 0 1-.8.4L10 16l-3.2 1.9a.5.5 0 0 1-.8-.4v-3.75A6.97 6.97 0 0 0 10 15Z",
    fill: primaryFill
  }));
};

export const RibbonStarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonStarFilledIcon, 'RibbonStarFilled');

const RibbonStarRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.16 5.1a.18.18 0 0 0-.31 0l-.72 1.55a.18.18 0 0 1-.14.1l-1.7.2c-.15.02-.2.2-.1.3l1.26 1.17c.05.04.07.1.05.16l-.33 1.68c-.03.15.13.26.26.19l1.49-.84a.17.17 0 0 1 .17 0l1.5.84c.12.07.28-.04.25-.19l-.33-1.68a.18.18 0 0 1 .05-.16l1.26-1.16a.17.17 0 0 0-.1-.3l-1.7-.2a.18.18 0 0 1-.14-.1l-.72-1.56ZM16 8c0 1.78-.77 3.37-2 4.47v5.03a.5.5 0 0 1-.75.43L10 16.08l-3.25 1.85A.5.5 0 0 1 6 17.5v-5.03A5.98 5.98 0 0 1 10 2a6 6 0 0 1 6 6Zm-6 6c-1.1 0-2.12-.3-3-.8v3.44l2.75-1.57a.5.5 0 0 1 .5 0L13 16.64V13.2c-.88.5-1.9.8-3 .8Zm0-1a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: primaryFill
  }));
};

export const RibbonStarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RibbonStarRegularIcon, 'RibbonStarRegular');

const RoadConeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.42 2.76A1 1 0 0 1 9.4 2h1.23a1 1 0 0 1 .96.74L15.38 17h2.12a.5.5 0 0 1 0 1h-15a.5.5 0 0 1 0-1h2.11l.8-3h6.09a.5.5 0 0 0 0-1H5.69l.45-1.63.1-.37h4.26a.5.5 0 0 0 0-1H6.52c.68-2.48 1.35-4.96 1.9-7.24Z",
    fill: primaryFill
  }));
};

export const RoadConeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RoadConeFilledIcon, 'RoadConeFilled');

const RoadConeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.38 2a1 1 0 0 0-.96.74L4.62 17H2.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-2.12l-3.8-14.26a1 1 0 0 0-.96-.74H9.38ZM5.65 17l.8-3h5.05a.5.5 0 0 0 0-1H6.72l.53-2h3.25a.5.5 0 0 0 0-1H7.52l1.86-7h1.24l3.73 14h-8.7Z",
    fill: primaryFill
  }));
};

export const RoadConeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RoadConeRegularIcon, 'RoadConeRegular');

const RocketFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.76 6.43a2 2 0 1 1 2.82 2.82 2 2 0 0 1-2.82-2.82Zm2.11.7a1 1 0 1 0-1.4 1.41 1 1 0 0 0 1.4-1.4ZM9.44 13.6l.6.6a1.5 1.5 0 0 0 1.71.3l1.12 1.12c.2.2.51.2.7 0L15 14.2c.86-.86.96-2.17.31-3.14l.85-.85a6.3 6.3 0 0 0 1.56-6.33 2.43 2.43 0 0 0-1.6-1.6A6.3 6.3 0 0 0 9.8 3.86l-.85.85A2.5 2.5 0 0 0 5.8 5L4.38 6.43a.5.5 0 0 0 0 .7L5.5 8.27a1.5 1.5 0 0 0 .3 1.7l.6.61-1.21.73a.5.5 0 0 0-.1.78l2.83 2.83a.5.5 0 0 0 .79-.1l.73-1.21Zm7.32-9.42a5.3 5.3 0 0 1-1.3 5.33l-4 4a.5.5 0 0 1-.7 0l-1.07-1.07-2.12-2.12L6.5 9.24a.5.5 0 0 1 0-.7l3.99-4a5.3 5.3 0 0 1 5.33-1.3c.44.13.8.48.93.93ZM5.8 14.91a.5.5 0 0 0-.7-.7l-1.77 1.76a.5.5 0 1 0 .7.7l1.77-1.76ZM4.4 12.79c.2.2.2.5 0 .7l-.7.71a.5.5 0 1 1-.72-.7l.71-.71c.2-.2.51-.2.71 0Zm2.83 3.53a.5.5 0 1 0-.7-.7l-.72.7a.5.5 0 1 0 .71.71l.71-.7Z",
    fill: primaryFill
  }));
};

export const RocketFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RocketFilledIcon, 'RocketFilled');

const RocketRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.76 6.43a2 2 0 1 1 2.82 2.82 2 2 0 0 1-2.82-2.82Zm2.11.7a1 1 0 1 0-1.4 1.42 1 1 0 0 0 1.4-1.42Zm-1.12 7.37a1.5 1.5 0 0 1-1.7-.3l-.61-.6-.74 1.22a.5.5 0 0 1-.78.1L5.1 12.09a.5.5 0 0 1 .1-.79l1.22-.73-.61-.6a1.5 1.5 0 0 1-.3-1.71L4.38 7.14a.5.5 0 0 1 0-.7l1.06-1.07a3 3 0 0 1 3.42-.59l.93-.93a6.3 6.3 0 0 1 6.33-1.56c.76.24 1.36.83 1.6 1.6a6.3 6.3 0 0 1-1.56 6.32l-.94.94a3 3 0 0 1-.58 3.41l-1.06 1.06a.5.5 0 0 1-.71 0l-1.12-1.12Zm4.08-11.26a5.3 5.3 0 0 0-5.33 1.31l-.81.82-.7.7h-.01L6.86 8.2l-.4.4a.5.5 0 0 0 .05.66l4.24 4.24c.18.18.46.2.66.05l.4-.4 2.12-2.12.7-.71.82-.81a5.3 5.3 0 0 0 1.31-5.33c-.14-.45-.49-.8-.93-.94Zm-3.31 10.62.7.7.7-.7a2 2 0 0 0 .53-1.93l-1.93 1.93Zm-4.44-8.3a2 2 0 0 0-1.93.52l-.7.7.7.71 1.93-1.93Zm.63 7.31L7.14 11.3l-.89.53 1.93 1.93.53-.89Zm-2.9 2.04a.5.5 0 1 0-.71-.7l-1.77 1.76a.5.5 0 1 0 .7.71l1.77-1.77ZM4.38 12.8c.2.2.2.51 0 .7l-.71.72a.5.5 0 0 1-.7-.71l.7-.71c.2-.2.51-.2.7 0Zm2.83 3.54a.5.5 0 0 0-.7-.71l-.72.7a.5.5 0 1 0 .7.72l.72-.71Z",
    fill: primaryFill
  }));
};

export const RocketRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RocketRegularIcon, 'RocketRegular');

const RotateLeftFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.39 12a.53.53 0 0 1-.54-.52c0-.29.24-.52.54-.52h.35c1.77 0 3.2-1.08 3.2-2.42 0-1.3-1.35-2.36-3.04-2.42H7.82L9.04 7.3c.2.2.2.53 0 .73a.54.54 0 0 1-.7.05l-.06-.05-2.12-2.08a.51.51 0 0 1 0-.73l2.12-2.08.06-.05c.21-.15.5-.13.7.05.2.2.2.53 0 .74L7.82 5.08h4.92C15.1 5.08 17 6.63 17 8.54S15.1 12 12.74 12h-.35Zm-9-3c-.21 0-.39.17-.39.38v6.87c0 .41.36.75.8.75h12.8a.4.4 0 0 0 .35-.19.37.37 0 0 0-.15-.51L3.6 9.05A.41.41 0 0 0 3.4 9Z",
    fill: primaryFill
  }));
};

export const RotateLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RotateLeftFilledIcon, 'RotateLeftFilled');

const RotateLeftRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.39 12a.53.53 0 0 1-.54-.52c0-.29.24-.52.54-.52h.35c1.77 0 3.2-1.08 3.2-2.42 0-1.3-1.35-2.36-3.04-2.42H7.82L9.04 7.3c.2.2.2.53 0 .73a.54.54 0 0 1-.7.05l-.06-.05-2.12-2.08a.51.51 0 0 1 0-.73l2.12-2.08.06-.05c.21-.15.5-.13.7.05.2.2.2.53 0 .74L7.82 5.08h4.92C15.1 5.08 17 6.63 17 8.54S15.1 12 12.74 12h-.35ZM4 10.41V16h10.18L4 10.41ZM3.8 17a.77.77 0 0 1-.8-.75V9.38c0-.21.18-.38.4-.38.07 0 .14.02.2.05l13.2 7.25c.2.1.26.33.15.51a.4.4 0 0 1-.35.19H3.8Z",
    fill: primaryFill
  }));
};

export const RotateLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RotateLeftRegularIcon, 'RotateLeftRegular');

const RotateRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.61 12c.3 0 .54-.23.54-.52a.53.53 0 0 0-.54-.52h-.35c-1.77 0-3.2-1.08-3.2-2.42 0-1.3 1.35-2.36 3.04-2.42h5.08L10.96 7.3c-.2.2-.2.53 0 .73.2.18.49.2.7.05l.06-.05 2.12-2.08c.21-.2.21-.53 0-.73l-2.12-2.08-.06-.05a.54.54 0 0 0-.7.05c-.2.2-.2.53 0 .74l1.22 1.19H7.26C4.9 5.08 3 6.63 3 8.54S4.9 12 7.26 12h.35Zm9-3c.21 0 .39.17.39.38v6.87c0 .41-.36.75-.8.75H3.4a.4.4 0 0 1-.35-.19.37.37 0 0 1 .15-.51l13.2-7.25a.41.41 0 0 1 .2-.05Z",
    fill: primaryFill
  }));
};

export const RotateRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RotateRightFilledIcon, 'RotateRightFilled');

const RotateRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.61 12c.3 0 .54-.23.54-.52a.53.53 0 0 0-.54-.52h-.35c-1.77 0-3.2-1.08-3.2-2.42 0-1.3 1.35-2.36 3.04-2.42h5.08L10.96 7.3c-.2.2-.2.53 0 .73.2.18.49.2.7.05l.06-.05 2.12-2.08c.21-.2.21-.53 0-.73l-2.12-2.08-.06-.05a.54.54 0 0 0-.7.05c-.2.2-.2.53 0 .74l1.22 1.19H7.26C4.9 5.08 3 6.63 3 8.54S4.9 12 7.26 12h.35ZM16 10.41V16H5.82L16 10.41Zm.2 6.59c.44 0 .8-.34.8-.75V9.38c0-.21-.18-.38-.4-.38a.41.41 0 0 0-.2.05L3.2 16.3a.37.37 0 0 0-.15.51c.07.12.2.19.35.19h12.8Z",
    fill: primaryFill
  }));
};

export const RotateRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RotateRightRegularIcon, 'RotateRightRegular');

const RouterFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 9.5a6.5 6.5 0 0 1 13 0 .5.5 0 0 0 1 0 7.5 7.5 0 0 0-15 0 .5.5 0 0 0 1 0Zm6.5-4a4 4 0 0 0-4 4 .5.5 0 0 1-1 0 5 5 0 0 1 10 0 .5.5 0 0 1-1 0 4 4 0 0 0-4-4ZM7.75 9.25a2.25 2.25 0 1 1 2.75 2.2V13h4a2.5 2.5 0 0 1 0 5h-9a2.5 2.5 0 0 1 0-5h4v-1.56a2.25 2.25 0 0 1-1.75-2.19Z",
    fill: primaryFill
  }));
};

export const RouterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RouterFilledIcon, 'RouterFilled');

const RouterRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 9.5a6.5 6.5 0 0 1 13 0 .5.5 0 0 0 1 0 7.5 7.5 0 0 0-15 0 .5.5 0 0 0 1 0Zm6.5-4a4 4 0 0 0-4 4 .5.5 0 0 1-1 0 5 5 0 0 1 10 0 .5.5 0 0 1-1 0 4 4 0 0 0-4-4ZM7.75 9.25a2.25 2.25 0 1 1 2.75 2.2V13h4a2.5 2.5 0 0 1 0 5h-9a2.5 2.5 0 0 1 0-5h4v-1.56a2.25 2.25 0 0 1-1.75-2.19ZM10 8a1.25 1.25 0 1 0 0 2.5A1.25 1.25 0 0 0 10 8Zm-4.5 6a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 0-3h-9Z",
    fill: primaryFill
  }));
};

export const RouterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RouterRegularIcon, 'RouterRegular');

const RowTripleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v1C3 5.33 3.67 6 4.5 6h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-11Zm0 6C3.67 8 3 8.67 3 9.5v1c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-11Zm0 6c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-11Z",
    fill: primaryFill
  }));
};

export const RowTripleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RowTripleFilledIcon, 'RowTripleFilled');

const RowTripleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.5C3 2.67 3.67 2 4.5 2h11c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 4.5v-1ZM4.5 3a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-11ZM3 9.5C3 8.67 3.67 8 4.5 8h11c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 10.5v-1ZM4.5 9a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-11Zm0 5c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-11ZM4 15.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-1Z",
    fill: primaryFill
  }));
};

export const RowTripleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RowTripleRegularIcon, 'RowTripleRegular');

const RssFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm.5 3a7.5 7.5 0 0 1 7.5 7.5.5.5 0 0 1-1 0A6.5 6.5 0 0 0 6.5 7a.5.5 0 0 1 0-1ZM6 9.5c0-.28.22-.5.5-.5a4.5 4.5 0 0 1 4.5 4.5.5.5 0 0 1-1 0A3.5 3.5 0 0 0 6.5 10a.5.5 0 0 1-.5-.5ZM7 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const RssFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RssFilledIcon, 'RssFilled');

const RssRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm2.5 0a.5.5 0 0 0 0 1 6.5 6.5 0 0 1 6.5 6.5.5.5 0 0 0 1 0A7.5 7.5 0 0 0 6.5 6ZM6 9.5c0-.28.22-.5.5-.5a4.5 4.5 0 0 1 4.5 4.5.5.5 0 0 1-1 0A3.5 3.5 0 0 0 6.5 10a.5.5 0 0 1-.5-.5ZM7 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const RssRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RssRegularIcon, 'RssRegular');

const RulerFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m13.97 3.2.03.3v13c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 6 16.5v-13A1.5 1.5 0 0 1 7.5 2h5c.72 0 1.33.51 1.47 1.2ZM7 14.5v1h1.5a.5.5 0 0 0 0-1H7Zm0-10v1h1.5a.5.5 0 0 0 0-1H7ZM7 7v1h2.5a.5.5 0 0 0 0-1H7Zm0 2.5v1h1.5a.5.5 0 0 0 0-1H7ZM7 12v1h2.5a.5.5 0 1 0 0-1H7Z",
    fill: primaryFill
  }));
};

export const RulerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RulerFilledIcon, 'RulerFilled');

const RulerRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 3.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 2 6 2.67 6 3.5v13c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-13ZM7 13h2.5a.5.5 0 0 0 0-1H7v-1.5h1.5a.5.5 0 0 0 0-1H7V8h2.5a.5.5 0 0 0 0-1H7V5.5h1.5a.5.5 0 0 0 0-1H7v-1c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v13a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1h1.5a.5.5 0 0 0 0-1H7V13Z",
    fill: primaryFill
  }));
};

export const RulerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RulerRegularIcon, 'RulerRegular');

const RunFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.31 2.04a.5.5 0 0 1 .35-.01l6 2a.5.5 0 0 1 .07.92h-.03a6.13 6.13 0 0 0-.37.22c-.25.15-.58.36-.91.62a5.8 5.8 0 0 0-.94.87c-.22.27-.38.53-.45.78l1.86 3.72 2 1.33A2.5 2.5 0 0 1 18 14.57v1.93a.5.5 0 0 1-.48.5l-.02-.5.02.5h-.04a6.42 6.42 0 0 1-.47 0 21.98 21.98 0 0 1-5.65-.84c-3.32-.95-7.23-3.02-9.31-7.45a.5.5 0 0 1 0-.43A12.43 12.43 0 0 1 5.2 4.59a16.2 16.2 0 0 1 4.12-2.55ZM17 15.47c-7.41-.6-11.41-4.2-13.55-7.58-.15.2-.28.41-.39.62 1.94 3.92 5.46 5.8 8.58 6.7A20.97 20.97 0 0 0 17 16v-.54ZM5.96 5.25l1.9 1.9a.5.5 0 0 1 .13.42l-.48 3.4c.7.56 1.5 1.08 2.4 1.55l1.48-1.6-2.33-4.18a.5.5 0 0 1 .6-.71l2.52.84c.13-.31.32-.6.53-.84a6.78 6.78 0 0 1 1.6-1.4l-4.8-1.6c-1.1.47-2.38 1.27-3.55 2.22Zm7.8 8.7c1 .24 2.07.41 3.24.51a1.5 1.5 0 0 0-.67-1.14l-1.65-1.1-.92 1.73Z",
    fill: primaryFill
  }));
};

export const RunFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/RunFilledIcon, 'RunFilled');

const RunRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.31 2.04a.5.5 0 0 1 .35-.01l6 2a.5.5 0 0 1 .07.92h-.03a6.13 6.13 0 0 0-.37.22c-.25.15-.58.36-.91.62a5.8 5.8 0 0 0-.94.87c-.22.27-.38.53-.45.78l1.86 3.72 2 1.33A2.5 2.5 0 0 1 18 14.57v1.93a.5.5 0 0 1-.48.5l-.02-.5.02.5h-.04a6.42 6.42 0 0 1-.47 0 21.98 21.98 0 0 1-5.65-.84c-3.32-.95-7.23-3.02-9.31-7.45a.5.5 0 0 1 0-.43A12.43 12.43 0 0 1 5.2 4.59a16.2 16.2 0 0 1 4.12-2.55ZM17 16v-.53c-7.41-.6-11.41-4.2-13.55-7.58-.15.2-.28.41-.39.62 1.94 3.92 5.46 5.8 8.58 6.7A20.97 20.97 0 0 0 17 16Zm-.67-2.68-1.65-1.1-.92 1.73c1 .24 2.07.41 3.24.51a1.5 1.5 0 0 0-.67-1.14Zm-4.18-5.41-1.59-.53 1.88 3.38a.5.5 0 0 1-.07.58l-1.52 1.63c.6.27 1.23.5 1.92.71l1.17-2.19-1.8-3.58Zm.03-1.04c.13-.31.32-.6.53-.84a6.78 6.78 0 0 1 1.6-1.4l-4.8-1.6c-1.1.47-2.38 1.27-3.55 2.22l1.9 1.9a.5.5 0 0 1 .13.42l-.48 3.4c.7.56 1.5 1.08 2.4 1.55l1.48-1.6-2.33-4.18a.5.5 0 0 1 .6-.71l2.52.84ZM5.2 5.9c-.4.37-.76.75-1.1 1.13a14.82 14.82 0 0 0 2.51 3.14l.36-2.5L5.2 5.9Z",
    fill: primaryFill
  }));
};

export const RunRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/RunRegularIcon, 'RunRegular');

const SanitizeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.77 5.23a2.5 2.5 0 0 0 0 3.54l3.46 3.46c.11.11.23.2.35.3.04-.13.1-.25.17-.36.4-.6.9-1.02 1.49-1.27.26-.1.51-.17.76-.2V7.5a1.5 1.5 0 0 1 2.05-1.4c.07-.25.2-.48.39-.66L8.77 2.77a2.5 2.5 0 0 0-3.54 0L2.77 5.23ZM12.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 1 1-1 0v-4a.5.5 0 0 0-1 0v4.25a2.08 2.08 0 0 0-1.38.08c-.38.16-.74.44-1.04.9a.5.5 0 0 0 .22.73 5.26 5.26 0 0 1 2.71 2.37c.55 1.03 1.6 2.17 2.99 2.17h.26A2.5 2.5 0 0 0 16 16.62l.63-1.26a3.5 3.5 0 0 0 .37-1.57V7.5a.5.5 0 0 0-1 0v4a.5.5 0 1 1-1 0v-5a.5.5 0 0 0-1 0v5a.5.5 0 1 1-1 0v-5a.5.5 0 0 0-.5-.5Zm-9 6c.28 0 .5.22.5.5v.5h.5a.5.5 0 0 1 0 1H4v.5a.5.5 0 1 1-1 0V14h-.5a.5.5 0 1 1 0-1H3v-.5c0-.28.22-.5.5-.5Zm3 3c.28 0 .5.22.5.5v.5h.5a.5.5 0 0 1 0 1H7v.5a.5.5 0 1 1-1 0V17h-.5a.5.5 0 1 1 0-1H6v-.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const SanitizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SanitizeFilledIcon, 'SanitizeFilled');

const SanitizeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.94 3.47 3.47 5.94a1.5 1.5 0 0 0 0 2.12l2.97 2.96c-.25.24-.45.51-.6.82L2.77 8.77a2.5 2.5 0 0 1 0-3.54l2.46-2.46a2.5 2.5 0 0 1 3.54 0L11.3 5.3c-.3.17-.55.39-.76.65L8.06 3.47a1.5 1.5 0 0 0-2.12 0ZM15.9 7c-.2-.58-.76-1-1.41-1h-2c-.65 0-1.2.42-1.41 1H11a2 2 0 0 0-2 2v2.31a2.77 2.77 0 0 0-.56-.06c-.36 0-.77.08-1.13.35-.37.27-.65.69-.8 1.28a.5.5 0 0 0 .3.58c1.9.81 3 2.1 3.61 3.03A3.1 3.1 0 0 0 12.94 18h1.82A2.5 2.5 0 0 0 17 16.62l.63-1.26a3.5 3.5 0 0 0 .37-1.57V9a2 2 0 0 0-2-2h-.09ZM14 7h.5c.28 0 .5.22.5.5v4a.5.5 0 1 0 1 0V8a1 1 0 0 1 1 1v4.8c0 .38-.09.76-.26 1.1l-.63 1.27c-.26.5-.78.83-1.35.83h-1.82c-.64 0-1.27-.42-1.68-1.05a9.01 9.01 0 0 0-3.64-3.21.91.91 0 0 1 .28-.34.9.9 0 0 1 .54-.15 2 2 0 0 1 .83.2A.5.5 0 0 0 10 12V9a1 1 0 0 1 1-1v3.5a.5.5 0 1 0 1 0v-4c0-.28.22-.5.5-.5h.5v4.5a.5.5 0 1 0 1 0V7ZM3.5 12c.28 0 .5.22.5.5v.5h.5a.5.5 0 0 1 0 1H4v.5a.5.5 0 1 1-1 0V14h-.5a.5.5 0 1 1 0-1H3v-.5c0-.28.22-.5.5-.5ZM7 15.5a.5.5 0 0 0-1 0v.5h-.5a.5.5 0 0 0 0 1H6v.5a.5.5 0 1 0 1 0V17h.5a.5.5 0 1 0 0-1H7v-.5Z",
    fill: primaryFill
  }));
};

export const SanitizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SanitizeRegularIcon, 'SanitizeRegular');

const SaveFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h1v3.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V3h.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V15a2 2 0 0 1-2 2v-5.5c0-.83-.67-1.5-1.5-1.5h-7c-.83 0-1.5.67-1.5 1.5V17a2 2 0 0 1-2-2V5Zm9-2H7v3.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V3Zm2 8.5V17H6v-5.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5Z",
    fill: primaryFill
  }));
};

export const SaveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveFilledIcon, 'SaveFilled');

const SaveRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1v-4.5c0-.83.67-1.5 1.5-1.5h7c.83 0 1.5.67 1.5 1.5V16a1 1 0 0 0 1-1V6.62a1 1 0 0 0-.3-.7L14.1 4.28a1 1 0 0 0-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 6 6.5V4H5Zm2 0v2.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V4H7Zm7 12v-4.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5V16h8Z",
    fill: primaryFill
  }));
};

export const SaveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveRegularIcon, 'SaveRegular');

const SaveArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h1v3.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V3h.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V9.6a5.48 5.48 0 0 0-5.66.4H6.5c-.83 0-1.5.67-1.5 1.5V17a2 2 0 0 1-2-2V5Zm6 9.5c0-1.33.47-2.55 1.26-3.5H6.5a.5.5 0 0 0-.5.5V17h3.6c-.38-.75-.6-1.6-.6-2.5ZM12 3H7v3.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V3Zm7 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const SaveArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveArrowRightFilledIcon, 'SaveArrowRightFilled');

const SaveArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V9.6c-.32-.16-.65-.3-1-.4V6.63a1 1 0 0 0-.3-.7L14.1 4.28a1 1 0 0 0-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 6 6.5V4H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1v-4.5c0-.83.67-1.5 1.5-1.5h4.84c-.4.28-.77.62-1.08 1H6.5a.5.5 0 0 0-.5.5V16h3.2c.1.35.24.68.4 1H5a2 2 0 0 1-2-2V5Zm4-1v2.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V4H7Zm12 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const SaveArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveArrowRightRegularIcon, 'SaveArrowRightRegular');

const SaveCopyFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v9A2.5 2.5 0 0 0 4.5 16h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 13.5 2h-9Zm5 4.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2a.5.5 0 0 1 1 0ZM7.5 18c-.95 0-1.82-.38-2.45-1h9.45a2.5 2.5 0 0 0 2.5-2.5V5.05c.62.63 1 1.5 1 2.45v7a3.5 3.5 0 0 1-3.5 3.5h-7Z",
    fill: primaryFill
  }));
};

export const SaveCopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveCopyFilledIcon, 'SaveCopyFilled');

const SaveCopyRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 6.5a.5.5 0 0 0-1 0v2h-2a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2v-2ZM4.5 2A2.5 2.5 0 0 0 2 4.5v9A2.5 2.5 0 0 0 4.5 16h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 13.5 2h-9ZM3 4.5C3 3.67 3.67 3 4.5 3h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 3 13.5v-9ZM7.5 18c-.95 0-1.82-.38-2.45-1h9.45a2.5 2.5 0 0 0 2.5-2.5V5.05c.62.63 1 1.5 1 2.45v7a3.5 3.5 0 0 1-3.5 3.5h-7Z",
    fill: primaryFill
  }));
};

export const SaveCopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveCopyRegularIcon, 'SaveCopyRegular');

const SaveEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2v-5.5c0-.83.67-1.5 1.5-1.5h6.44l1.16-1.16a2.87 2.87 0 0 1 2.9-.7V6.61a2 2 0 0 0-.59-1.41L14.8 3.59A2 2 0 0 0 13.38 3H13v3.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 6 6.5V3H5Zm6.94 8-2.67 2.67c-.4.41-.7.92-.84 1.49l-.37 1.5c-.03.11-.05.23-.06.34H6v-5.5c0-.28.22-.5.5-.5h5.44ZM7 3h5v3.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V3Zm7.8 6.55-4.82 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64Z",
    fill: primaryFill
  }));
};

export const SaveEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveEditFilledIcon, 'SaveEditFilled');

const SaveEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h3l.06-.35.16-.65H6v-4.5c0-.28.22-.5.5-.5h5.44l1-1H6.5c-.83 0-1.5.67-1.5 1.5V16a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1v2.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V4h.38a1 1 0 0 1 .7.3l1.63 1.61a1 1 0 0 1 .29.71V8c.34-.01.68.03 1 .13v-1.5a2 2 0 0 0-.59-1.42L14.8 3.59A2 2 0 0 0 13.38 3H5Zm2 3.5V4h5v2.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5Zm7.8 3.05-4.82 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64Z",
    fill: primaryFill
  }));
};

export const SaveEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveEditRegularIcon, 'SaveEditRegular');

const SaveImageFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2v-5.5C5 9.67 5.67 9 6.5 9h10c.17 0 .34.01.5.04V5.62a2 2 0 0 0-.59-1.41L14.8 2.59A2 2 0 0 0 13.38 2H13v3.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 6 5.5V2H5Zm5.05 8A3.49 3.49 0 0 0 9 12.5V16H6v-5.5c0-.28.22-.5.5-.5h3.55ZM12 2H7v3.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V2Zm-2 10.5a2.5 2.5 0 0 1 2.5-2.5h4a2.5 2.5 0 0 1 2.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0l-3.03 3.03c-.26-.4-.41-.87-.41-1.38v-4Zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-5.88 5.84c.4.26.87.41 1.38.41h4c.5 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0l-3.03 3.03Z",
    fill: primaryFill
  }));
};

export const SaveImageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveImageFilledIcon, 'SaveImageFilled');

const SaveImageRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 6.13v2.9a3.53 3.53 0 0 0-.5-.03H16V6.13a.97.97 0 0 0-.29-.72L13.6 3.3A.96.96 0 0 0 13 3V5.5a1.45 1.45 0 0 1-.44 1.06c-.14.13-.3.24-.48.32-.18.08-.38.12-.58.12h-4a1.45 1.45 0 0 1-1.05-.44 1.6 1.6 0 0 1-.33-.48A1.33 1.33 0 0 1 6 5.5V3H5a.97.97 0 0 0-.7.29c-.1.1-.17.2-.22.32A.86.86 0 0 0 4 4v10c0 .13.03.27.08.4.05.1.12.22.2.31.1.1.2.17.32.21.13.05.26.08.4.08v-4.5a1.45 1.45 0 0 1 .44-1.05c.14-.14.3-.25.48-.33.18-.08.38-.12.58-.12h6c-.96 0-1.82.38-2.45 1H6.5a.5.5 0 0 0-.5.5V15h3v1H5c-.26 0-.52-.05-.76-.16a2.2 2.2 0 0 1-.64-.42 1.9 1.9 0 0 1-.6-1.38V4c0-.26.05-.52.16-.76.1-.24.24-.45.42-.64A1.9 1.9 0 0 1 4.96 2h7.92c.26 0 .52.05.76.15.25.1.47.25.65.44L16.4 4.7c.19.19.34.4.43.65.1.24.16.5.16.77ZM7 3v2.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5V3H7Zm3 9.5a2.5 2.5 0 0 1 2.5-2.5h4a2.5 2.5 0 0 1 2.5 2.5v4c0 .5-.15.98-.41 1.38l-3.03-3.03a1.5 1.5 0 0 0-2.12 0l-3.03 3.03c-.26-.4-.41-.87-.41-1.38v-4Zm7 .25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-5.88 5.84c.4.26.87.41 1.38.41h4c.5 0 .98-.15 1.38-.41l-3.03-3.03a.5.5 0 0 0-.7 0l-3.03 3.03Z",
    fill: primaryFill
  }));
};

export const SaveImageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveImageRegularIcon, 'SaveImageRegular');

const SaveMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5.5V3H5a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2v-4.5C5 9.67 5.67 9 6.5 9h5c.83 0 1.5.67 1.5 1.5V15a2 2 0 0 0 2-2V6.62a2 2 0 0 0-.59-1.41L12.8 3.59A2 2 0 0 0 11.38 3H11v2.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 6 5.5Zm1 0V3h3v2.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5Zm5 9.5H6v-4.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V15Zm-3.5 2c-.95 0-1.82-.38-2.45-1h7.45a2.5 2.5 0 0 0 2.5-2.5V6.05c.62.63 1 1.5 1 2.45v5a3.5 3.5 0 0 1-3.5 3.5h-5Z",
    fill: primaryFill
  }));
};

export const SaveMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveMultipleFilledIcon, 'SaveMultipleFilled');

const SaveMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6.62a2 2 0 0 0-.59-1.41L12.8 3.59A2 2 0 0 0 11.38 3H5ZM4 5a1 1 0 0 1 1-1h1v1.5C6 6.33 6.67 7 7.5 7h2c.83 0 1.5-.67 1.5-1.5V4h.38a1 1 0 0 1 .7.3l1.63 1.61a1 1 0 0 1 .29.71V13a1 1 0 0 1-1 1v-3.5c0-.83-.67-1.5-1.5-1.5h-5C5.67 9 5 9.67 5 10.5V14a1 1 0 0 1-1-1V5Zm3 .5V4h3v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5Zm5 5V14H6v-3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5ZM8.5 17c-.95 0-1.82-.38-2.45-1h7.45a2.5 2.5 0 0 0 2.5-2.5V6.05c.62.63 1 1.5 1 2.45v5a3.5 3.5 0 0 1-3.5 3.5h-5Z",
    fill: primaryFill
  }));
};

export const SaveMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveMultipleRegularIcon, 'SaveMultipleRegular');

const SaveSearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h1v3.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V3h.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V15a2 2 0 0 1-2 2v-5.5c0-.83-.67-1.5-1.5-1.5H9.33a4.5 4.5 0 0 0-6.33.67V5Zm7.56 10.44L12.12 17H14v-5.5a.5.5 0 0 0-.5-.5h-3.26a4.5 4.5 0 0 1 .32 4.44ZM12 3H7v3.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V3Zm-2 10.5c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 0 1-.7.7L8.6 16.3a3.5 3.5 0 1 1 1.4-2.8Zm-6 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z",
    fill: primaryFill
  }));
};

export const SaveSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveSearchFilledIcon, 'SaveSearchFilled');

const SaveSearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V15a2 2 0 0 1-2 2h-2.88l-1-1H14v-4.5a.5.5 0 0 0-.5-.5h-3.26a4.53 4.53 0 0 0-.91-1h4.17c.83 0 1.5.67 1.5 1.5V16a1 1 0 0 0 1-1V6.62a1 1 0 0 0-.3-.7L14.1 4.28a1 1 0 0 0-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 6 6.5V4H5a1 1 0 0 0-1 1v4.76a4.52 4.52 0 0 0-1 .91V5Zm4-1v2.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V4H7Zm3 9.5c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 0 1-.7.7L8.6 16.3a3.5 3.5 0 1 1 1.4-2.8Zm-6 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Z",
    fill: primaryFill
  }));
};

export const SaveSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveSearchRegularIcon, 'SaveSearchRegular');

const SaveSyncFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h1v3.5C6 7.33 6.67 8 7.5 8h4c.83 0 1.5-.67 1.5-1.5V3h.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V9.6a5.48 5.48 0 0 0-5.66.4H6.5c-.83 0-1.5.67-1.5 1.5V17a2 2 0 0 1-2-2V5Zm6 9.5c0-1.33.47-2.55 1.26-3.5H6.5a.5.5 0 0 0-.5.5V17h3.6c-.38-.75-.6-1.6-.6-2.5ZM12 3H7v3.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V3Zm-2 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a1.97 1.97 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z",
    fill: primaryFill
  }));
};

export const SaveSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveSyncFilledIcon, 'SaveSyncFilled');

const SaveSyncRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8.38a2 2 0 0 1 1.41.59l1.62 1.62A2 2 0 0 1 17 6.62V9.6c-.32-.16-.65-.3-1-.4V6.63a1 1 0 0 0-.3-.7L14.1 4.28a1 1 0 0 0-.71-.29H13v2.5c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 6 6.5V4H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1v-4.5c0-.83.67-1.5 1.5-1.5h4.84c-.4.28-.77.62-1.08 1H6.5a.5.5 0 0 0-.5.5V16h3.2c.1.35.24.68.4 1H5a2 2 0 0 1-2-2V5Zm4-1v2.5c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5V4H7Zm3 10.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a1.97 1.97 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z",
    fill: primaryFill
  }));
};

export const SaveSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SaveSyncRegularIcon, 'SaveSyncRegular');

const SavingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m9.65 4.06.18.02a4.5 4.5 0 0 0-.7 3.2c.15.98.91 1.6 1.6 1.87l3.03 1.26c.68.29 1.65.39 2.46-.2a4.5 4.5 0 0 0 1.49-1.86c.19.58.29 1.23.29 1.96 0 1.75-.54 2.98-1.09 3.78a4.95 4.95 0 0 1-.91 1v1.41c0 .83-.67 1.5-1.5 1.5h-1.38c-.62 0-1.12-.5-1.12-1.12a.12.12 0 0 0-.12-.11h-1.76a.12.12 0 0 0-.12.11C10 17.5 9.5 18 8.88 18H7.5A1.5 1.5 0 0 1 6 16.5v-.54l-.16-.1c-.28-.18-.69-.5-1.2-1-.62-.64-1-1.34-1.2-1.8-.07-.17-.2-.27-.33-.3-.64-.1-1.11-.65-1.11-1.3V9.95c0-.63.45-1.17 1.08-1.27.11-.02.24-.13.3-.3a4.4 4.4 0 0 1 1-1.71A6.63 6.63 0 0 1 6 5.47v-2.3c0-.36.23-.61.48-.71.25-.1.58-.08.83.15.29.28.68.63 1.11.92.44.3.87.5 1.23.53ZM6.75 9.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm10.29-2.46a3.5 3.5 0 0 1-1.4 2.36c-.43.31-1 .3-1.5.09l-3.03-1.26c-.48-.2-.88-.56-.98-1.05l-.02-.07a3.5 3.5 0 1 1 6.93-.07Z",
    fill: primaryFill
  }));
};

export const SavingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SavingsFilledIcon, 'SavingsFilled');

const SavingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.95 9.54c.03.24.05.5.05.77 0 1.53-.46 2.56-.91 3.2a3.96 3.96 0 0 1-.85.89.5.5 0 0 0-.24.43v1.67a.5.5 0 0 1-.5.5h-1.38a.12.12 0 0 1-.12-.12c0-.61-.5-1.11-1.12-1.11h-1.76c-.62 0-1.12.5-1.12 1.11 0 .07-.05.12-.12.12H7.5a.5.5 0 0 1-.5-.5v-.85a.5.5 0 0 0-.34-.47l-.04-.02a6.37 6.37 0 0 1-1.26-1.01 4.99 4.99 0 0 1-1-1.49c-.19-.42-.57-.8-1.09-.88a.33.33 0 0 1-.27-.32V9.95c0-.14.1-.26.24-.29.55-.09.94-.51 1.1-.97.12-.4.36-.93.75-1.32a5.64 5.64 0 0 1 1.58-1.1l.02-.02A.5.5 0 0 0 7 5.79v-2.1c.25.22.55.46.87.67.43.3.95.56 1.48.66.12-.33.28-.65.48-.94l-.18-.02a2.9 2.9 0 0 1-1.23-.53 8.47 8.47 0 0 1-1.11-.92.77.77 0 0 0-.83-.15.76.76 0 0 0-.48.7v2.32a6.9 6.9 0 0 0-1.63 1.19 4.4 4.4 0 0 0-.99 1.7c-.06.18-.19.29-.3.3A1.3 1.3 0 0 0 2 9.96v1.5c0 .66.47 1.2 1.1 1.32.13.02.27.12.34.3.2.45.58 1.15 1.2 1.78A7.34 7.34 0 0 0 6 15.96v.54c0 .83.67 1.5 1.5 1.5h1.38c.62 0 1.12-.5 1.12-1.12 0-.06.05-.11.12-.11h1.76c.07 0 .12.05.12.11 0 .62.5 1.12 1.12 1.12h1.38c.83 0 1.5-.67 1.5-1.5v-1.42c.04-.03.1-.07.14-.12.22-.2.5-.48.77-.87A6.48 6.48 0 0 0 18 10.3c0-.73-.1-1.38-.3-1.96-.18.43-.43.84-.75 1.2Zm-.15-4.3a3.5 3.5 0 0 1-1.17 4.16c-.43.31-1 .29-1.49.09L11.1 8.23c-.49-.2-.9-.6-.99-1.12a3.5 3.5 0 0 1 6.7-1.88Zm-1.76 3.35a2.5 2.5 0 1 0-3.94-1.63c0 .03.03.08.09.15.06.06.16.14.3.2l3.04 1.25c.13.06.26.08.35.08.09 0 .13-.03.16-.05Zm-8.29.91a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    fill: primaryFill
  }));
};

export const SavingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SavingsRegularIcon, 'SavingsRegular');

const ScaleFillFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm3.3 1.04a.5.5 0 0 0-.3.46v2a.5.5 0 0 0 1 0v-.8l1.15 1.15a.5.5 0 1 0 .7-.7L7.71 7h.79a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.2.04ZM6 11.5v2a.5.5 0 0 0 .14.35.5.5 0 0 0 .36.15h2a.5.5 0 0 0 0-1h-.8l1.15-1.15a.5.5 0 0 0-.7-.7L7 12.29v-.79a.5.5 0 0 0-1 0Zm7.85-5.36A.5.5 0 0 0 13.5 6h-2a.5.5 0 0 0 0 1h.8l-1.15 1.15a.5.5 0 0 0 .7.7L13 7.71v.79a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.14-.35Zm-.16 7.82a.5.5 0 0 0 .3-.46v-2a.5.5 0 0 0-.99 0v.8l-1.15-1.15a.5.5 0 0 0-.7.7L12.29 13h-.79a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .2-.04Z",
    fill: primaryFill
  }));
};

export const ScaleFillFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScaleFillFilledIcon, 'ScaleFillFilled');

const ScaleFillRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6.5a.5.5 0 0 1 .14-.35A.5.5 0 0 1 6.5 6h2a.5.5 0 0 1 0 1h-.8l1.15 1.15a.5.5 0 1 1-.7.7L7 7.71v.79a.5.5 0 0 1-1 0v-2Zm.04 7.2a.5.5 0 0 1-.04-.2v-2a.5.5 0 0 1 1 0v.8l1.15-1.15a.5.5 0 0 1 .7.7L7.71 13h.79a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.46-.3Zm7.65-7.66a.5.5 0 0 1 .3.46v2a.5.5 0 0 1-.99 0v-.8l-1.15 1.15a.5.5 0 0 1-.7-.7L12.29 7h-.79a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .2.04Zm.16 7.82a.5.5 0 0 1-.35.14h-2a.5.5 0 0 1 0-1h.8l-1.15-1.15a.5.5 0 0 1 .7-.7L13 12.29v-.79a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.14.35ZM3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Z",
    fill: primaryFill
  }));
};

export const ScaleFillRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScaleFillRegularIcon, 'ScaleFillRegular');

const ScaleFitFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Zm11.12 6.08a.5.5 0 0 1 .05-.7l1-.88H11.5a.5.5 0 0 1 0-1h2.67l-1-.87a.5.5 0 0 1 .66-.76l2 1.75a.5.5 0 0 1 0 .76l-2 1.75a.5.5 0 0 1-.7-.05ZM6.88 7.92a.5.5 0 0 1-.05.7l-1 .88H8.5a.5.5 0 0 1 0 1H5.83l1 .87a.5.5 0 0 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .7.05Z",
    fill: primaryFill
  }));
};

export const ScaleFitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScaleFitFilledIcon, 'ScaleFitFilled');

const ScaleFitRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.88 7.92a.5.5 0 0 1-.05.7l-1 .88H8.5a.5.5 0 0 1 0 1H5.83l1 .87a.5.5 0 1 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .7.05Zm7.29 2.58-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 0 0-.66.76l1 .87H11.5a.5.5 0 0 0 0 1h2.67ZM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Z",
    fill: primaryFill
  }));
};

export const ScaleFitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScaleFitRegularIcon, 'ScaleFitRegular');

const ScalesFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 3a.5.5 0 1 0 0 1h.75L2.08 9.22a.95.95 0 0 0-.08.4 3 3 0 0 0 6 0 .95.95 0 0 0-.08-.4L5.75 4H9.5v11h-4a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 0-3h-4V4h3.75l-2.17 5.22a.96.96 0 0 0-.08.4 3 3 0 0 0 6 0 .96.96 0 0 0-.08-.4L15.75 4h.75a.5.5 0 0 0 0-1h-13ZM5 4.8 6.75 9h-3.5L5 4.8ZM16.75 9h-3.5L15 4.8 16.75 9Z",
    fill: primaryFill
  }));
};

export const ScalesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScalesFilledIcon, 'ScalesFilled');

const ScalesRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 3a.5.5 0 1 0 0 1h.75L2.08 9.22a.95.95 0 0 0-.08.4 3 3 0 0 0 6 0 .95.95 0 0 0-.08-.4L5.75 4H9.5v10H6a2 2 0 1 0 0 4h8a2 2 0 0 0 0-4h-3.5V4h3.75l-2.17 5.22a.96.96 0 0 0-.08.4 3 3 0 0 0 6 0 .96.96 0 0 0-.08-.4L15.75 4h.75a.5.5 0 0 0 0-1h-13ZM5 11.5A2 2 0 0 1 3.06 10h3.88A2 2 0 0 1 5 11.5Zm0-6.7L6.75 9h-3.5L5 4.8ZM6 15h8a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2Zm10.75-6h-3.5L15 4.8 16.75 9Zm-3.69 1h3.88a2 2 0 0 1-3.88 0Z",
    fill: primaryFill
  }));
};

export const ScalesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScalesRegularIcon, 'ScalesRegular');

const ScanFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.7 3.5 7.02 8.19l-.18.33-1.65-2.87A6.48 6.48 0 0 1 9.7 3.51ZM8.28 9l.03-.05a2 2 0 0 1 3.43.05l.03.06a2 2 0 0 1-.03 1.94l-.03.05A2 2 0 0 1 8.27 11l-.03-.06A2 2 0 0 1 8.27 9Zm-1.35 2.67.2.33h-3.3a6.5 6.5 0 0 1 .41-5l2.7 4.67ZM10 13.5l.3-.01-1.66 2.87a6.5 6.5 0 0 1-4.12-2.86H10Zm2.99-1.68.18-.33 1.65 2.87a6.48 6.48 0 0 1-4.53 2.13l2.7-4.67Zm.09-3.49a3.52 3.52 0 0 0-.2-.33h3.3a6.5 6.5 0 0 1-.41 5l-2.7-4.67ZM10 6.5l-.3.01 1.66-2.87a6.5 6.5 0 0 1 4.12 2.86H10ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
    fill: primaryFill
  }));
};

export const ScanFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanFilledIcon, 'ScanFilled');

const ScanRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.91 5.19a6.98 6.98 0 0 1 5.65-2.17L7.4 8.5c-.1.18-.19.36-.25.56L4.91 5.2Zm-.67.83 3.12 5.4a3 3 0 0 0 .4.58H3.3a7 7 0 0 1 .95-5.98ZM8.27 11l-.04-.06A2 2 0 0 1 11.73 9l.04.06A2 2 0 0 1 8.27 11Zm1.12-3.94 2.23-3.87c2.08.5 3.8 1.92 4.7 3.81H10c-.21 0-.42.02-.61.06Zm2.85.94h4.47a7 7 0 0 1-.95 5.98l-3.12-5.4c-.1-.2-.25-.4-.4-.58Zm.61 2.94 2.24 3.87a6.98 6.98 0 0 1-5.65 2.17l3.16-5.48c.1-.18.19-.36.25-.56Zm-2.24 2L8.38 16.8A7.01 7.01 0 0 1 3.68 13H10c.21 0 .42-.02.61-.06ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
    fill: primaryFill
  }));
};

export const ScanRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanRegularIcon, 'ScanRegular');

const ScanCameraFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3H7.6a.75.75 0 1 1 0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7.6a.75.75 0 1 1-1.5 0V6.25Zm8.65-2.5c0-.41.34-.75.75-.75h1.35C15.55 3 17 4.46 17 6.25V7.6a.75.75 0 0 1-1.5 0V6.25c0-.97-.78-1.75-1.75-1.75H12.4a.75.75 0 0 1-.75-.75Zm-7.9 7.9c.41 0 .75.34.75.75v1.35c0 .97.78 1.75 1.75 1.75H7.6a.75.75 0 0 1 0 1.5H6.25A3.25 3.25 0 0 1 3 13.75V12.4c0-.41.34-.75.75-.75Zm12.5 0c.41 0 .75.34.75.75v1.35c0 1.8-1.46 3.25-3.25 3.25H12.4a.75.75 0 0 1 0-1.5h1.35c.97 0 1.75-.78 1.75-1.75V12.4c0-.41.34-.75.75-.75ZM10 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-4 1V9a1 1 0 0 1 1-1h1l.7-1.05a1 1 0 0 1 .84-.45h.92a1 1 0 0 1 .84.45L12 8h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1Zm6-2a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
    fill: primaryFill
  }));
};

export const ScanCameraFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanCameraFilledIcon, 'ScanCameraFilled');

const ScanCameraRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6a2 2 0 0 0-2 2v1.5a.5.5 0 0 1-1 0V6Zm9-2.5c0-.28.22-.5.5-.5H14a3 3 0 0 1 3 3v1.5a.5.5 0 0 1-1 0V6a2 2 0 0 0-2-2h-1.5a.5.5 0 0 1-.5-.5ZM3.5 12c.28 0 .5.22.5.5V14c0 1.1.9 2 2 2h1.5a.5.5 0 0 1 0 1H6a3 3 0 0 1-3-3v-1.5c0-.28.22-.5.5-.5Zm13 0c.28 0 .5.22.5.5V14a3 3 0 0 1-3 3h-1.5a.5.5 0 0 1 0-1H14a2 2 0 0 0 2-2v-1.5c0-.28.22-.5.5-.5ZM10 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-4 1V9a1 1 0 0 1 1-1h1l.7-1.05a1 1 0 0 1 .84-.45h.92a1 1 0 0 1 .84.45L12 8h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1Zm6-2a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
    fill: primaryFill
  }));
};

export const ScanCameraRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanCameraRegularIcon, 'ScanCameraRegular');

const ScanDashFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 3A3.25 3.25 0 0 0 3 6.25V7.6a.75.75 0 1 0 1.5 0V6.25c0-.97.78-1.75 1.75-1.75H7.6a.75.75 0 1 0 0-1.5H6.25Zm6.15 0a.75.75 0 0 0 0 1.5h1.35c.97 0 1.75.78 1.75 1.75V7.6a.75.75 0 0 0 1.5 0V6.25C17 4.45 15.54 3 13.75 3H12.4Zm-7.9 9.4a.75.75 0 0 0-1.5 0v1.35C3 15.55 4.46 17 6.25 17H7.6a.75.75 0 0 0 0-1.5H6.25c-.97 0-1.75-.78-1.75-1.75V12.4Zm12.5 0a.75.75 0 0 0-1.5 0v1.35c0 .97-.78 1.75-1.75 1.75H12.4a.75.75 0 0 0 0 1.5h1.35c1.8 0 3.25-1.46 3.25-3.25V12.4ZM6.75 9.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
    fill: primaryFill
  }));
};

export const ScanDashFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanDashFilledIcon, 'ScanDashFilled');

const ScanDashRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v1.5a.5.5 0 0 0 1 0V6c0-1.1.9-2 2-2h1.5a.5.5 0 0 0 0-1H6Zm6.5 0a.5.5 0 0 0 0 1H14a2 2 0 0 1 2 2v1.5a.5.5 0 0 0 1 0V6a3 3 0 0 0-3-3h-1.5ZM4 12.5a.5.5 0 0 0-1 0V14a3 3 0 0 0 3 3h1.5a.5.5 0 0 0 0-1H6a2 2 0 0 1-2-2v-1.5Zm13 0a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-1.5a.5.5 0 0 0 0 1H14a3 3 0 0 0 3-3v-1.5Zm-10.5-3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
    fill: primaryFill
  }));
};

export const ScanDashRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanDashRegularIcon, 'ScanDashRegular');

const ScanObjectFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h2a.5.5 0 0 0 0-1h-2A2.5 2.5 0 0 0 2 4.5v2a.5.5 0 0 0 1 0v-2Zm14 11c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 0 0 1h2a2.5 2.5 0 0 0 2.5-2.5v-2a.5.5 0 0 0-1 0v2ZM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 0 0 1 0v-2A2.5 2.5 0 0 0 15.5 2h-2a.5.5 0 0 0 0 1h2ZM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 2 15.5v-2a.5.5 0 0 1 1 0v2Zm8.23-8.6a1.5 1.5 0 0 0-2.46 0l-2.6 3.75A1.5 1.5 0 0 0 7.42 13h5.18a1.5 1.5 0 0 0 1.23-2.35L11.23 6.9Z",
    fill: primaryFill
  }));
};

export const ScanObjectFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanObjectFilledIcon, 'ScanObjectFilled');

const ScanObjectRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v2a.5.5 0 0 1-1 0v-2A2.5 2.5 0 0 1 4.5 2h2a.5.5 0 0 1 0 1h-2Zm11 14c.83 0 1.5-.67 1.5-1.5v-2a.5.5 0 0 1 1 0v2a2.5 2.5 0 0 1-2.5 2.5h-2a.5.5 0 0 1 0-1h2ZM17 4.5c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 1 0-1h2A2.5 2.5 0 0 1 18 4.5v2a.5.5 0 0 1-1 0v-2ZM4.5 17A1.5 1.5 0 0 1 3 15.5v-2a.5.5 0 0 0-1 0v2A2.5 2.5 0 0 0 4.5 18h2a.5.5 0 0 0 0-1h-2Zm6.73-10.1a1.5 1.5 0 0 0-2.46 0l-2.6 3.75A1.5 1.5 0 0 0 7.42 13h5.18a1.5 1.5 0 0 0 1.23-2.35L11.23 6.9Zm-1.64.57a.5.5 0 0 1 .82 0l2.6 3.75a.5.5 0 0 1-.42.78H7.41a.5.5 0 0 1-.41-.78l2.59-3.75Z",
    fill: primaryFill
  }));
};

export const ScanObjectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanObjectRegularIcon, 'ScanObjectRegular');

const ScanTableFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5c-.83 0-1.5.67-1.5 1.5v1.75a.75.75 0 0 1-1.5 0V6a3 3 0 0 1 3-3h1.75a.75.75 0 0 1 0 1.5H6ZM6 8c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2H6Zm0 1v3c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V9H6Zm6.25-6a.75.75 0 0 0 0 1.5H14c.83 0 1.5.67 1.5 1.5v1.75a.75.75 0 0 0 1.5 0V6a3 3 0 0 0-3-3h-1.75Zm-8.5 8.5c.41 0 .75.34.75.75V14c0 .83.67 1.5 1.5 1.5h1.75a.75.75 0 0 1 0 1.5H6a3 3 0 0 1-3-3v-1.75c0-.41.34-.75.75-.75Zm13.25.75a.75.75 0 0 0-1.5 0V14c0 .83-.67 1.5-1.5 1.5h-1.75a.75.75 0 0 0 0 1.5H14a3 3 0 0 0 3-3v-1.75Z",
    fill: primaryFill
  }));
};

export const ScanTableFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTableFilledIcon, 'ScanTableFilled');

const ScanTableRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4a2 2 0 0 0-2 2v1.5a.5.5 0 0 1-1 0V6a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6Zm2 2a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8Zm5 2H7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1ZM7 9h6v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V9Zm5.5-6a.5.5 0 0 0 0 1H14a2 2 0 0 1 2 2v1.5a.5.5 0 0 0 1 0V6a3 3 0 0 0-3-3h-1.5Zm-9 9c.28 0 .5.22.5.5V14c0 1.1.9 2 2 2h1.5a.5.5 0 0 1 0 1H6a3 3 0 0 1-3-3v-1.5c0-.28.22-.5.5-.5Zm13.5.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-1.5a.5.5 0 0 0 0 1H14a3 3 0 0 0 3-3v-1.5Z",
    fill: primaryFill
  }));
};

export const ScanTableRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTableRegularIcon, 'ScanTableRegular');

const ScanTextFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 .49.61l.01.14c0 .41-.34.75-.75.75H6c-.83 0-1.5.67-1.5 1.5v1.25a.75.75 0 0 1-.89.74A.5.5 0 0 1 3 7.5V6Zm9-2.5c0-.28.22-.5.5-.5H14a3 3 0 0 1 3 3v1.5a.5.5 0 0 1-.61.49l-.14.01a.75.75 0 0 1-.75-.75V6c0-.83-.67-1.5-1.5-1.5h-1.25a.75.75 0 0 1-.74-.89.5.5 0 0 1-.01-.11ZM3.5 12a.5.5 0 0 1 .11.01.75.75 0 0 1 .89.74V14c0 .83.67 1.5 1.5 1.5h1.25a.75.75 0 0 1 .74.89.5.5 0 0 1-.49.61H6a3 3 0 0 1-3-3v-1.5c0-.28.22-.5.5-.5Zm13 0c.28 0 .5.22.5.5V14a3 3 0 0 1-3 3h-1.5a.5.5 0 0 1-.49-.61.75.75 0 0 1 .74-.89H14c.83 0 1.5-.67 1.5-1.5v-1.25a.75.75 0 0 1 .89-.74.5.5 0 0 1 .11-.01ZM6.75 6a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5ZM6 9.75c0-.41.34-.75.75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 6 9.75ZM6.75 12a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z",
    fill: primaryFill
  }));
};

export const ScanTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTextFilledIcon, 'ScanTextFilled');

const ScanTextRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4a2 2 0 0 0-2 2v1.5a.5.5 0 0 1-1 0V6a3 3 0 0 1 3-3h1.5a.5.5 0 0 1 0 1H6Zm0 2.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 3c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm6-9a.5.5 0 0 0 0 1H14a2 2 0 0 1 2 2v1.5a.5.5 0 0 0 1 0V6a3 3 0 0 0-3-3h-1.5Zm-9 9c.28 0 .5.22.5.5V14c0 1.1.9 2 2 2h1.5a.5.5 0 0 1 0 1H6a3 3 0 0 1-3-3v-1.5c0-.28.22-.5.5-.5Zm13.5.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-1.5a.5.5 0 0 0 0 1H14a3 3 0 0 0 3-3v-1.5Z",
    fill: primaryFill
  }));
};

export const ScanTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTextRegularIcon, 'ScanTextRegular');

const ScanThumbUpFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h2a.5.5 0 0 0 0-1h-2A2.5 2.5 0 0 0 2 4.5v2a.5.5 0 0 0 1 0v-2Zm14 11c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 0 0 1h2a2.5 2.5 0 0 0 2.5-2.5v-2a.5.5 0 0 0-1 0v2ZM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 0 0 1 0v-2A2.5 2.5 0 0 0 15.5 2h-2a.5.5 0 0 0 0 1h2ZM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 2 15.5v-2a.5.5 0 0 1 1 0v2ZM9.52 5.4c.2-.47.8-1.08 1.63-.85.54.14.92.46 1.13.9.19.39.22.81.23 1.15 0 .36-.06.76-.14 1.1h.28c1.2 0 2.13 1.13 1.77 2.3l-.92 3a2.2 2.2 0 0 1-2.74 1.4l-3.6-1.08a1.82 1.82 0 0 1-1.19-1.07l-.35-.89c-.32-.83.03-1.74.8-2.18l1.24-.7.03-.02c.04-.04.12-.1.22-.21.2-.22.5-.6.79-1.2l.36-.71c.18-.33.3-.58.46-.94Z",
    fill: primaryFill
  }));
};

export const ScanThumbUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanThumbUpFilledIcon, 'ScanThumbUpFilled');

const ScanThumbUpRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h2a.5.5 0 0 0 0-1h-2A2.5 2.5 0 0 0 2 4.5v2a.5.5 0 0 0 1 0v-2Zm14 11c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 0 0 1h2a2.5 2.5 0 0 0 2.5-2.5v-2a.5.5 0 0 0-1 0v2ZM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 0 0 1 0v-2A2.5 2.5 0 0 0 15.5 2h-2a.5.5 0 0 0 0 1h2ZM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 2 15.5v-2a.5.5 0 0 1 1 0v2Zm8.15-10.95c-.83-.23-1.43.38-1.63.85-.15.36-.28.61-.45.94l-.37.71a4.98 4.98 0 0 1-1.04 1.43l-1.24.7a1.76 1.76 0 0 0-.8 2.18l.35.9c.2.51.65.9 1.18 1.06l3.61 1.08A2.2 2.2 0 0 0 13.5 13l.92-3c.36-1.17-.56-2.3-1.77-2.3h-.28c.08-.34.14-.74.14-1.1-.01-.34-.04-.76-.23-1.15a1.68 1.68 0 0 0-1.13-.9Zm-4.24 5.5 1.24-.7a.5.5 0 0 0 .04-.02h.01v-.01l.02-.01.1-.08A5.97 5.97 0 0 0 9.6 7.5l.35-.69c.17-.32.32-.61.5-1.02.03-.08.1-.17.19-.23a.3.3 0 0 1 .26-.04c.26.07.4.2.48.38.09.18.12.43.13.73 0 .28-.06.64-.15.99-.03.16-.08.31-.12.45a.5.5 0 0 0 .48.65h.93c.6 0 .96.53.82 1l-.92 2.99a1.2 1.2 0 0 1-1.5.75l-3.61-1.09a.82.82 0 0 1-.54-.48L6.55 11a.76.76 0 0 1 .36-.94Z",
    fill: primaryFill
  }));
};

export const ScanThumbUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanThumbUpRegularIcon, 'ScanThumbUpRegular');

const ScanThumbUpOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v2a.5.5 0 0 0 1 0v-2c0-.23.05-.45.15-.65l4.57 4.58a1.42 1.42 0 0 1-.06.05l-1.24.7a1.76 1.76 0 0 0-.8 2.18l.35.9c.2.51.65.9 1.18 1.06l3.61 1.08c.85.26 1.75-.01 2.3-.63l3.09 3.08c-.2.1-.42.15-.65.15h-2a.5.5 0 0 0 0 1h2c.5 0 .98-.15 1.38-.41l.27.26a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7l.26.27Zm6.45 3.62 5.02 5.02.54-1.76c.36-1.17-.56-2.3-1.77-2.3h-.28c.08-.34.14-.74.14-1.1-.01-.34-.04-.76-.23-1.15a1.68 1.68 0 0 0-1.13-.9c-.83-.23-1.43.38-1.63.85-.15.36-.28.61-.45.94a37 37 0 0 0-.21.4ZM17 14.88l.98.97.02-.35v-2a.5.5 0 0 0-1 0v1.38ZM4.15 2.02l.97.98H6.5a.5.5 0 0 0 0-1h-2c-.12 0-.24 0-.35.02ZM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 0 0 1 0v-2A2.5 2.5 0 0 0 15.5 2h-2a.5.5 0 0 0 0 1h2ZM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 2 15.5v-2a.5.5 0 0 1 1 0v2Z",
    fill: primaryFill
  }));
};

export const ScanThumbUpOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanThumbUpOffFilledIcon, 'ScanThumbUpOffFilled');

const ScanThumbUpOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v2a.5.5 0 0 0 1 0v-2c0-.23.05-.45.15-.65l4.57 4.58a1.42 1.42 0 0 1-.06.05l-1.24.7a1.76 1.76 0 0 0-.8 2.18l.35.9c.2.51.65.9 1.18 1.06l3.61 1.08c.85.26 1.75-.01 2.3-.63l3.09 3.08c-.2.1-.42.15-.65.15h-2a.5.5 0 0 0 0 1h2c.5 0 .98-.15 1.38-.41l.27.26a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7l.26.27Zm9.94 9.94c-.29.36-.8.54-1.3.39l-3.61-1.09a.82.82 0 0 1-.54-.48L6.55 11a.76.76 0 0 1 .36-.94l1.24-.7a.5.5 0 0 0 .04-.02h.01v-.01l.02-.01a1.79 1.79 0 0 0 .21-.17l3.92 3.92Zm-3.5-6.32.75.74.35-.68c.17-.32.32-.61.5-1.02.03-.08.1-.17.19-.23a.3.3 0 0 1 .26-.04c.26.07.4.2.48.38.09.18.12.43.13.73 0 .28-.06.64-.15.99-.03.16-.08.31-.12.45a.5.5 0 0 0 .48.65h.93c.6 0 .96.53.82 1l-.39 1.25.8.8.54-1.76c.36-1.17-.56-2.3-1.77-2.3h-.28c.08-.34.14-.74.14-1.1-.01-.34-.04-.76-.23-1.15a1.68 1.68 0 0 0-1.13-.9c-.83-.23-1.43.38-1.63.85-.15.36-.28.61-.45.94l-.21.4ZM17 14.88l.98.97.02-.35v-2a.5.5 0 0 0-1 0v1.38ZM4.15 2.02l.97.98H6.5a.5.5 0 0 0 0-1h-2c-.12 0-.24 0-.35.02ZM15.5 3c.83 0 1.5.67 1.5 1.5v2a.5.5 0 0 0 1 0v-2A2.5 2.5 0 0 0 15.5 2h-2a.5.5 0 0 0 0 1h2ZM3 15.5c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 1 0 1h-2A2.5 2.5 0 0 1 2 15.5v-2a.5.5 0 0 1 1 0v2Z",
    fill: primaryFill
  }));
};

export const ScanThumbUpOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanThumbUpOffRegularIcon, 'ScanThumbUpOffRegular');

const ScanTypeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v1.5a.75.75 0 0 1-1.5 0v-1.5A2.75 2.75 0 0 1 4.75 2h1.5a.75.75 0 0 1 0 1.5h-1.5Zm0 13c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0v1.5A2.75 2.75 0 0 0 4.75 18h1.5a.75.75 0 0 0 0-1.5h-1.5ZM16.5 4.75c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 0 1 0-1.5h1.5A2.75 2.75 0 0 1 18 4.75v1.5a.75.75 0 0 1-1.5 0v-1.5ZM15.25 16.5c.69 0 1.25-.56 1.25-1.25v-1.5a.75.75 0 0 1 1.5 0v1.5A2.75 2.75 0 0 1 15.25 18h-1.5a.75.75 0 0 1 0-1.5h1.5ZM6.5 5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.5 0V6.5h2v7H9A.75.75 0 0 0 9 15h2a.75.75 0 0 0 0-1.5h-.25v-7h2v.25a.75.75 0 0 0 1.5 0v-1A.75.75 0 0 0 13.5 5h-7Z",
    fill: primaryFill
  }));
};

export const ScanTypeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeFilledIcon, 'ScanTypeFilled');

const ScanTypeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v2a.5.5 0 0 1-1 0v-2A2.5 2.5 0 0 1 4.5 2h2a.5.5 0 0 1 0 1h-2ZM5 17a2 2 0 0 1-2-2v-1.5a.5.5 0 0 0-1 0V15a3 3 0 0 0 3 3h1.5a.5.5 0 0 0 0-1H5ZM17 4.5c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 1 0-1h2A2.5 2.5 0 0 1 18 4.5v2a.5.5 0 0 1-1 0v-2ZM15 17a2 2 0 0 0 2-2v-1.5a.5.5 0 0 1 1 0V15a3 3 0 0 1-3 3h-1.5a.5.5 0 0 1 0-1H15ZM6.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V6h2.5v8H9a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-.5V6H13v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5h-7Z",
    fill: primaryFill
  }));
};

export const ScanTypeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeRegularIcon, 'ScanTypeRegular');

const ScanTypeCheckmarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v1.5a.75.75 0 0 1-1.5 0v-1.5A2.75 2.75 0 0 1 4.75 2h1.5a.75.75 0 0 1 0 1.5h-1.5Zm0 13c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0v1.5A2.75 2.75 0 0 0 4.75 18h1.5a.75.75 0 0 0 0-1.5h-1.5ZM16.5 4.75c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 0 1 0-1.5h1.5A2.75 2.75 0 0 1 18 4.75v1.5a.75.75 0 0 1-1.5 0v-1.5ZM6.5 5a.75.75 0 0 0-.75.75v1a.75.75 0 0 0 1.5 0V6.5h2v6.36a5.5 5.5 0 0 1 1.5-2.38V6.5h2v.25a.75.75 0 0 0 1.5 0v-1A.75.75 0 0 0 13.5 5h-7Zm1.25 8.5h1.34a5.53 5.53 0 0 0-.07 1.5H7.75a.75.75 0 0 1 0-1.5Zm11.25 1a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.5.8-.65-.65a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7l-2.65 2.64Z",
    fill: primaryFill
  }));
};

export const ScanTypeCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeCheckmarkFilledIcon, 'ScanTypeCheckmarkFilled');

const ScanTypeCheckmarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v2a.5.5 0 0 1-1 0v-2A2.5 2.5 0 0 1 4.5 2h2a.5.5 0 0 1 0 1h-2ZM5 17a2 2 0 0 1-2-2v-1.5a.5.5 0 0 0-1 0V15a3 3 0 0 0 3 3h1.5a.5.5 0 0 0 0-1H5ZM17 4.5c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 1 0-1h2A2.5 2.5 0 0 1 18 4.5v2a.5.5 0 0 1-1 0v-2ZM6.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0V6h2.5v6.2c.25-.54.6-1.04 1-1.47V6H13v.5a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5h-7ZM8 14h1.02a5.57 5.57 0 0 0 0 1H8a.5.5 0 0 1 0-1Zm11 .5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7Z",
    fill: primaryFill
  }));
};

export const ScanTypeCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeCheckmarkRegularIcon, 'ScanTypeCheckmarkRegular');

const ScanTypeOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.48 3.2c-.3.43-.48.97-.48 1.55v1.5a.75.75 0 0 0 1.5 0v-1.5c0-.16.03-.32.09-.46l2.16 2.17v.29a.75.75 0 0 0 1 .7l2.5 2.5v3.55H9A.75.75 0 0 0 9 15h2a.75.75 0 0 0 0-1.5h-.25v-2.04l4.96 4.95c-.14.06-.3.09-.46.09h-1.5a.75.75 0 0 0 0 1.5h1.5c.58 0 1.12-.18 1.56-.48l.34.33a.5.5 0 0 0 .7-.7l-.33-.34-1.1-1.1L5.94 5.24 4.29 3.6l-1.1-1.1-.34-.34a.5.5 0 1 0-.7.7l.33.34ZM18 15.24c0 .2-.02.39-.06.57l-1.44-1.44v-.63a.75.75 0 0 1 1.5 0v1.5ZM10.75 6.5v2.13l-1.5-1.5V6.5h-.63L7.12 5h6.38c.41 0 .75.34.75.75v1a.75.75 0 0 1-1.5 0V6.5h-2Zm-4.5-3h-.63L4.18 2.06c.18-.04.37-.06.57-.06h1.5a.75.75 0 0 1 0 1.5Zm-1.5 13c-.69 0-1.25-.56-1.25-1.25v-1.5a.75.75 0 0 0-1.5 0v1.5A2.75 2.75 0 0 0 4.75 18h1.5a.75.75 0 0 0 0-1.5h-1.5ZM16.5 4.75c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 0 1 0-1.5h1.5A2.75 2.75 0 0 1 18 4.75v1.5a.75.75 0 0 1-1.5 0v-1.5Z",
    fill: primaryFill
  }));
};

export const ScanTypeOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeOffFilledIcon, 'ScanTypeOffFilled');

const ScanTypeOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v2a.5.5 0 0 0 1 0v-2c0-.23.05-.45.15-.65l6.35 6.36V14H9a.5.5 0 1 0 0 1h2a.5.5 0 0 0 0-1h-.5v-2.8l5.52 5.52A2 2 0 0 1 15 17h-1.5a.5.5 0 1 0 0 1H15c.65 0 1.25-.2 1.74-.55l.4.4a.5.5 0 0 0 .71-.7l-.4-.41-.73-.72L6.03 5.32 3.85 3.15l-.73-.74-.27-.26a.5.5 0 1 0-.7.7l.26.27ZM18 15a3 3 0 0 1-.1.78l-.9-.9V13.5a.5.5 0 1 1 1 0V15Zm-7.5-9v2.38l-1-1V6H8.12l-1-1h6.38c.28 0 .5.22.5.5v1a.5.5 0 0 1-1 0V6h-2.5Zm-4-3H5.12l-.97-.98L4.5 2h2a.5.5 0 0 1 0 1ZM5 17a2 2 0 0 1-2-2v-1.5a.5.5 0 1 0-1 0V15a3 3 0 0 0 3 3h1.5a.5.5 0 0 0 0-1H5ZM17 4.5c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 0 1 0-1h2A2.5 2.5 0 0 1 18 4.5v2a.5.5 0 0 1-1 0v-2Z",
    fill: primaryFill
  }));
};

export const ScanTypeOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScanTypeOffRegularIcon, 'ScanTypeOffRegular');

const ScratchpadFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5H12v-.7A5.5 5.5 0 0 1 8 12H6.5a.5.5 0 0 1 0-1h1.59c.2-.58.76-1 1.41-1v-.5h-3a.5.5 0 0 1 0-1h3c0-.53.1-1.04.3-1.5H6.5a.5.5 0 0 1 0-1h3.88a4 4 0 0 1 6.62.56V3.5c0-.83-.67-1.5-1.5-1.5h-11Zm9 3.5a3 3 0 0 0-3 3v3a3 3 0 1 0 6 0v-3a3 3 0 0 0-3-3Zm-4 5.5c.28 0 .5.22.5.5v.5a3.5 3.5 0 1 0 7 0v-.5a.5.5 0 0 1 1 0v.5a4.5 4.5 0 0 1-4 4.47V18a.5.5 0 0 1-1 0v-1.53A4.5 4.5 0 0 1 9 12v-.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const ScratchpadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScratchpadFilledIcon, 'ScratchpadFilled');

const ScratchpadRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5H12v-.7a5.46 5.46 0 0 1-.8-.3H4.5a.5.5 0 0 1-.5-.5v-13c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v1.88c.4.32.75.72 1 1.18V3.5c0-.83-.67-1.5-1.5-1.5h-11ZM8 11.5c0-.18.03-.34.09-.5H6.5a.5.5 0 0 0 0 1H8v-.5Zm-1.5-3h3v1h-3a.5.5 0 0 1 0-1ZM9.8 7a4 4 0 0 1 .58-1H6.5a.5.5 0 0 0 0 1h3.3Zm3.7-1.5a3 3 0 0 0-3 3v3a3 3 0 1 0 6 0v-3a3 3 0 0 0-3-3Zm-2 3a2 2 0 1 1 4 0v3a2 2 0 1 1-4 0v-3Zm-1.5 3a.5.5 0 0 0-1 0v.5a4.5 4.5 0 0 0 4 4.47V18a.5.5 0 0 0 1 0v-1.53A4.5 4.5 0 0 0 18 12v-.5a.5.5 0 0 0-1 0v.5a3.5 3.5 0 1 1-7 0v-.5Z",
    fill: primaryFill
  }));
};

export const ScratchpadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScratchpadRegularIcon, 'ScratchpadRegular');

const ScreenCutFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a1 1 0 0 1 1-1h.5a.5.5 0 1 0 0-1H4a2 2 0 0 0-2 2v.5a.5.5 0 1 0 1 0V6Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M4 14a1 1 0 0 1-1-1v-.5a.5.5 0 0 0-1 0v.5c0 1.1.9 2 2 2h.25a.5.5 0 0 0 0-1H4Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2.5 8c.28 0 .5.22.5.5v2a.5.5 0 1 1-1 0v-2c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17 6a1 1 0 0 0-1-1h-.5a.5.5 0 0 1 0-1h.5a2 2 0 0 1 2 2v.5a.5.5 0 0 1-1 0V6Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17 13a1 1 0 0 1-1 1h-.25a.5.5 0 0 0 0 1H16a2 2 0 0 0 2-2v-.5a.5.5 0 0 0-1 0v.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17 8.5a.5.5 0 0 1 1 0v2a.5.5 0 1 1-1 0v-2Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6 4.5c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H6.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M11 4a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1H11Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2.7l.5-.74-1.96-2.93a1.5 1.5 0 1 1 2.5-1.66L10 9.55l1.25-1.88a1.5 1.5 0 0 1 2.5 1.66l-1.95 2.93.5.74H15a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.22 8.09a.5.5 0 0 0-.14.69l2.31 3.48-1.23 1.85a2 2 0 0 0-2.51 2.64 2 2 0 1 0 3.34-2.08l1-1.51L11 14.67a2 2 0 1 0 .84-.55l-1.24-1.86-.6-.9L7.9 8.23a.5.5 0 0 0-.7-.14ZM12.5 17a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-5 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "m10.6 10.45.6.9 1.72-2.57a.5.5 0 0 0-.14-.7.5.5 0 0 0-.7.15l-1.48 2.22Z",
    fill: primaryFill
  }));
};

export const ScreenCutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenCutFilledIcon, 'ScreenCutFilled');

const ScreenCutRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5a1 1 0 0 0-1 1v.5a.5.5 0 1 1-1 0V6c0-1.1.9-2 2-2h.5a.5.5 0 0 1 0 1H4Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 13a1 1 0 0 0 1 1h.25a.5.5 0 0 1 0 1H4a2 2 0 0 1-2-2v-.5a.5.5 0 0 1 1 0v.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 8.5a.5.5 0 0 0-1 0v2a.5.5 0 1 0 1 0v-2Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M16 5a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V6a2 2 0 0 0-2-2h-.5a.5.5 0 0 0 0 1h.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M16 14a1 1 0 0 0 1-1v-.5a.5.5 0 0 1 1 0v.5a2 2 0 0 1-2 2h-.25a.5.5 0 0 1 0-1H16Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17.5 8a.5.5 0 0 0-.5.5v2a.5.5 0 1 0 1 0v-2a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6.5 4a.5.5 0 0 0 0 1H9a.5.5 0 1 0 0-1H6.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.5 4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.22 8.09a.5.5 0 0 0-.14.69l2.31 3.48-1.23 1.85a2 2 0 0 0-2.51 2.64 2 2 0 1 0 3.34-2.08l1-1.51L11 14.67a2 2 0 1 0 .84-.55l-1.24-1.86-.6-.9L7.9 8.23a.5.5 0 0 0-.7-.14ZM12.5 17a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-5 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "m10.6 10.45.6.9 1.72-2.57a.5.5 0 0 0-.14-.7.5.5 0 0 0-.7.15l-1.48 2.22Z",
    fill: primaryFill
  }));
};

export const ScreenCutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenCutRegularIcon, 'ScreenCutRegular');

const ScreenPersonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6.05a2.5 2.5 0 0 1 2.22-1.99A2.99 2.99 0 0 1 15.5 9a3 3 0 0 1 2.5 1.34V7a3 3 0 0 0-3-3H5Zm12.5 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const ScreenPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenPersonFilledIcon, 'ScreenPersonFilled');

const ScreenPersonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h6.3c.07-.37.23-.7.45-1H4.75C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V9.4c.4.23.74.56 1 .94V6.75A2.75 2.75 0 0 0 15.25 4H4.75Zm12.75 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const ScreenPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenPersonRegularIcon, 'ScreenPersonRegular');

const ScreenSearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16h-5.13l-1.56-1.56A4.5 4.5 0 0 0 2 8.76V6.75ZM4.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 14.6A3.5 3.5 0 1 0 4.5 16Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const ScreenSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenSearchFilledIcon, 'ScreenSearchFilled');

const ScreenSearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16h-5.13l-1-1h6.13c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v1.5c-.36.13-.7.3-1 .5v-2ZM4.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 14.6A3.5 3.5 0 1 0 4.5 16Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const ScreenSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenSearchRegularIcon, 'ScreenSearchRegular');

const ScreenshotFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2Zm1.5 2C5.67 5 5 5.67 5 6.5v2a.5.5 0 0 0 1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 0 0-1h-2Zm5 0a.5.5 0 0 0 0 1h2c.28 0 .5.22.5.5v2a.5.5 0 0 0 1 0v-2c0-.83-.67-1.5-1.5-1.5h-2ZM6 11.5a.5.5 0 0 0-1 0v2c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 1-.5-.5v-2Zm9 0a.5.5 0 0 0-1 0v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2c.83 0 1.5-.67 1.5-1.5v-2Z",
    fill: primaryFill
  }));
};

export const ScreenshotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenshotFilledIcon, 'ScreenshotFilled');

const ScreenshotRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 5C5.67 5 5 5.67 5 6.5v2a.5.5 0 0 0 1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 0 0-1h-2Zm5 0a.5.5 0 0 0 0 1h2c.28 0 .5.22.5.5v2a.5.5 0 0 0 1 0v-2c0-.83-.67-1.5-1.5-1.5h-2ZM6 11.5a.5.5 0 0 0-1 0v2c0 .83.67 1.5 1.5 1.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 1-.5-.5v-2Zm9 0a.5.5 0 0 0-1 0v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2c.83 0 1.5-.67 1.5-1.5v-2ZM3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm1 0v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1Z",
    fill: primaryFill
  }));
};

export const ScreenshotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ScreenshotRegularIcon, 'ScreenshotRegular');

const SearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 0 1 4.38 8.82l4.15 4.15a.75.75 0 0 1-.98 1.13l-.08-.07-4.15-4.15A5.5 5.5 0 1 1 8.5 3Zm0 1.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
    fill: primaryFill
  }));
};

export const SearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchFilledIcon, 'SearchFilled');

const SearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 0 1 4.23 9.02l4.12 4.13a.5.5 0 0 1-.63.76l-.07-.06-4.13-4.12A5.5 5.5 0 1 1 8.5 3Zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z",
    fill: primaryFill
  }));
};

export const SearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchRegularIcon, 'SearchRegular');

const SearchInfoFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 8.5a5.5 5.5 0 1 0-1.98 4.23l4.13 4.12.07.06a.5.5 0 0 0 .63-.76l-4.12-4.13A5.48 5.48 0 0 0 14 8.5ZM8.5 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM9 8.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 1 0Z",
    fill: primaryFill
  }));
};

export const SearchInfoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchInfoFilledIcon, 'SearchInfoFilled');

const SearchInfoRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 0 1 4.23 9.02l4.12 4.13a.5.5 0 0 1-.63.76l-.07-.06-4.13-4.12A5.5 5.5 0 1 1 8.5 3Zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 4c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5ZM9 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    fill: primaryFill
  }));
};

export const SearchInfoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchInfoRegularIcon, 'SearchInfoRegular');

const SearchSettingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 0 1 4.38 8.82l4.15 4.15a.75.75 0 0 1-.98 1.13l-.08-.07-4.15-4.15c-.28.22-.6.41-.92.57-.1-.5-.27-.99-.5-1.43a4 4 0 1 0-5.86-2.94c-.5.1-.99.25-1.44.47A5.5 5.5 0 0 1 8.5 3Zm-5.43 8.44a2 2 0 0 1-1.44 2.48l-.46.12a4.7 4.7 0 0 0 .01 1.01l.35.09A2 2 0 0 1 3 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 8 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55ZM5.5 15.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const SearchSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchSettingsFilledIcon, 'SearchSettingsFilled');

const SearchSettingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 0 1 4.23 9.02l4.12 4.13a.5.5 0 0 1-.63.76l-.07-.06-4.13-4.12a5.5 5.5 0 0 1-1.12.72 5.45 5.45 0 0 0-.29-.98A4.5 4.5 0 1 0 4.05 9.2c-.33.1-.65.21-.95.36A5.5 5.5 0 0 1 8.5 3Zm-5.43 8.44a2 2 0 0 1-1.44 2.48l-.46.12a4.7 4.7 0 0 0 .01 1.01l.35.09A2 2 0 0 1 3 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 8 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55ZM5.5 15.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const SearchSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchSettingsRegularIcon, 'SearchSettingsRegular');

const SearchShieldFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 0 1 4.38 8.82l4.15 4.15a.75.75 0 0 1-.98 1.13l-.08-.07-4.15-4.15c-.54.41-1.15.72-1.82.91V12.21a4 4 0 1 0-5.48-4.12c-.2.07-.37.18-.52.34-.32.33-.63.58-.96.78A5.5 5.5 0 0 1 8.5 3ZM7 10.35a4.63 4.63 0 0 1-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0 0 3 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0C7.69 18.09 9 16.27 9 13.58V11a.4.4 0 0 0-.4-.33 4.23 4.23 0 0 1-1.6-.32Z",
    fill: primaryFill
  }));
};

export const SearchShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchShieldFilledIcon, 'SearchShieldFilled');

const SearchShieldRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a5.5 5.5 0 0 1 4.23 9.02l4.12 4.13a.5.5 0 0 1-.63.76l-.07-.06-4.13-4.12c-.58.48-1.27.85-2.02 1.06v-1.05a4.5 4.5 0 1 0-6-4.31c-.32.33-.63.58-.96.78A5.5 5.5 0 0 1 8.5 3ZM7 10.35a4.63 4.63 0 0 1-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0 0 3 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0C7.69 18.09 9 16.27 9 13.58V11a.4.4 0 0 0-.4-.33 4.23 4.23 0 0 1-1.6-.32Z",
    fill: primaryFill
  }));
};

export const SearchShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchShieldRegularIcon, 'SearchShieldRegular');

const SearchSquareFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm6 6.5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L11.8 11.1A3.5 3.5 0 1 0 9 12.5Z",
    fill: primaryFill
  }));
};

export const SearchSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchSquareFilledIcon, 'SearchSquareFilled');

const SearchSquareRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 12.5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L11.8 11.1A3.5 3.5 0 1 0 9 12.5Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z",
    fill: primaryFill
  }));
};

export const SearchSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchSquareRegularIcon, 'SearchSquareRegular');

const SearchVisualFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3h1a.75.75 0 0 1 0 1.5h-1c-.97 0-1.75.78-1.75 1.75v1a.75.75 0 0 1-1.5 0v-1Zm14 7.5c0 1.8-1.46 3.25-3.25 3.25h-1a.75.75 0 0 1 0-1.5h1c.97 0 1.75-.78 1.75-1.75v-1a.75.75 0 0 1 1.5 0v1Zm0-7.5C17 4.45 15.54 3 13.75 3h-1a.75.75 0 0 0 0 1.5h1c.97 0 1.75.78 1.75 1.75v1a.75.75 0 0 0 1.5 0v-1ZM6.25 17A3.25 3.25 0 0 1 3 13.75v-1a.75.75 0 0 1 1.5 0v1c0 .97.78 1.75 1.75 1.75h1a.75.75 0 0 1 0 1.5h-1ZM10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM7 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const SearchVisualFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchVisualFilledIcon, 'SearchVisualFilled');

const SearchVisualRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 3a3 3 0 0 1 3 3v1.5a.5.5 0 0 1-1 0V6a2 2 0 0 0-2-2h-1.5a.5.5 0 0 1 0-1H14ZM6 3a3 3 0 0 0-3 3v1.5a.5.5 0 0 0 1 0V6c0-1.1.9-2 2-2h1.5a.5.5 0 0 0 0-1H6Zm8 14a3 3 0 0 0 3-3v-1.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-1.5a.5.5 0 0 0 0 1H14ZM3 14a3 3 0 0 0 3 3h1.5a.5.5 0 0 0 0-1H6a2 2 0 0 1-2-2v-1.5a.5.5 0 0 0-1 0V14Zm7-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6.5 7.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    fill: primaryFill
  }));
};

export const SearchVisualRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SearchVisualRegularIcon, 'SearchVisualRegular');

const SelectAllOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm.27 15c.34.6.99 1 1.73 1h8a4 4 0 0 0 4-4V6a2 2 0 0 0-1-1.73V14a3 3 0 0 1-3 3H4.27Z",
    fill: primaryFill
  }));
};

export const SelectAllOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectAllOffFilledIcon, 'SelectAllOffFilled');

const SelectAllOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4ZM3 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm1.27 13c.34.6.99 1 1.73 1h8a4 4 0 0 0 4-4V6a2 2 0 0 0-1-1.73V14a3 3 0 0 1-3 3H4.27Z",
    fill: primaryFill
  }));
};

export const SelectAllOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectAllOffRegularIcon, 'SelectAllOffRegular');

const SelectAllOnFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm10.33 2.62a.5.5 0 0 0-.7.05l-3.15 3.6-1.63-1.62a.5.5 0 1 0-.7.7l2 2a.5.5 0 0 0 .73-.02l3.5-4a.5.5 0 0 0-.05-.7ZM4.27 17c.34.6.99 1 1.73 1h8a4 4 0 0 0 4-4V6a2 2 0 0 0-1-1.73V14a3 3 0 0 1-3 3H4.27Z",
    fill: primaryFill
  }));
};

export const SelectAllOnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectAllOnFilledIcon, 'SelectAllOnFilled');

const SelectAllOnRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm2 15a2 2 0 0 1-1.73-1H14a3 3 0 0 0 3-3V4.27c.6.34 1 .99 1 1.73v8a4 4 0 0 1-4 4H6Zm6.38-10.67a.5.5 0 0 0-.76-.66l-3.14 3.6-1.63-1.62a.5.5 0 1 0-.7.7l2 2a.5.5 0 0 0 .73-.02l3.5-4Z",
    fill: primaryFill
  }));
};

export const SelectAllOnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectAllOnRegularIcon, 'SelectAllOnRegular');

const SelectObjectFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-11 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 4.75c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 7 4.75Zm0 10.5c0-.41.34-.75.75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm-3-7.5a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5Zm10.5 0a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5Z",
    fill: primaryFill
  }));
};

export const SelectObjectFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectFilledIcon, 'SelectObjectFilled');

const SelectObjectRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-11 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 4.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 11c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm-3-8a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Zm11 0a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Z",
    fill: primaryFill
  }));
};

export const SelectObjectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectRegularIcon, 'SelectObjectRegular');

const SelectObjectSkewFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm-4 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM3.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM6 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm8.11.75H9.9a2.5 2.5 0 0 0 0-1.5h4.22a2.5 2.5 0 0 0 0 1.5ZM3.61 13 5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5Zm6.5 3.25H5.9a2.5 2.5 0 0 0 0-1.5h4.22a2.5 2.5 0 0 0 0 1.5Zm2.5-3.25 2.37-6.51c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5Z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewFilledIcon, 'SelectObjectSkewFilled');

const SelectObjectSkewRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02A1.5 1.5 0 0 0 16.48 6Zm-5.4 10a1.5 1.5 0 1 0 1.42-2h-.01c-.65 0-1.2.42-1.41 1l-.01.02a1.5 1.5 0 0 0 0 .98ZM3.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM7.49 6a1.5 1.5 0 1 0 .02-3 1.5 1.5 0 0 0-.02 3Zm-3.62 7.03 2.32-6.4c.28.17.6.3.94.34l-2.32 6.4c-.28-.17-.6-.3-.94-.34ZM14.05 5h-4.1a2.51 2.51 0 0 0 0-1h4.1a2.51 2.51 0 0 0 0 1Zm-8.1 11h4.1a2.51 2.51 0 0 1 0-1h-4.1a2.51 2.51 0 0 1 0 1Zm6.92-2.97 2.32-6.4c.28.17.6.3.94.34l-2.32 6.4c-.28-.17-.6-.3-.94-.34Z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewRegularIcon, 'SelectObjectSkewRegular');

const SelectObjectSkewDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm-13 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm4-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm3.89.75h4.22a2.5 2.5 0 0 1 0-1.5H9.9a2.5 2.5 0 0 1 0 1.5ZM3.6 13 5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5Zm2.28 3.25h3.4a5.48 5.48 0 0 1-.28-1.5H5.89a2.5 2.5 0 0 1 0 1.5ZM16.39 7l-.77 2.11a5.52 5.52 0 0 0-1.56-.1l.92-2.52c.4.3.88.48 1.41.5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewDismissFilledIcon, 'SelectObjectSkewDismissFilled');

const SelectObjectSkewDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02a1.5 1.5 0 0 0 .47 1.64c.26.21.58.34.94.34ZM2 15.5a1.5 1.5 0 1 0 2.92-.48V15a1.5 1.5 0 0 0-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5ZM7.49 6h.01c.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 1 0-2.37.68c.26.21.58.34.94.34Zm-1.3.63-2.32 6.4c.34.05.66.17.94.34l2.32-6.4a2.48 2.48 0 0 1-.94-.34ZM14.05 5h-4.1a2.51 2.51 0 0 0 0-1h4.1a2.51 2.51 0 0 0 0 1Zm.45 4c.3 0 .59.02.87.07l.76-2.1a2.48 2.48 0 0 1-.94-.34L14.33 9h.17Zm-5.48 6c.03.34.1.68.19 1H5.95a2.51 2.51 0 0 0 0-1h3.07Zm9.98-.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewDismissRegularIcon, 'SelectObjectSkewDismissRegular');

const SelectObjectSkewEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm-13 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm4-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm3.89.75h4.22a2.5 2.5 0 0 1 0-1.5H9.9a2.5 2.5 0 0 1 0 1.5ZM3.6 13 5.98 6.5c.4.3.88.48 1.41.5l-2.37 6.52c-.4-.3-.88-.48-1.41-.5Zm2.28 3.25H9.4l.02-.1c.12-.46.34-.9.65-1.26 0-.05.02-.1.03-.14H5.9a2.5 2.5 0 0 1 0 1.5ZM16.39 7l-.92 2.53-.37.31-2.1 2.1 1.98-5.45c.4.3.88.48 1.41.5Zm-5.41 8.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewEditFilledIcon, 'SelectObjectSkewEditFilled');

const SelectObjectSkewEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.49 6h.01a1.5 1.5 0 1 0-1.41-2l-.01.02a1.5 1.5 0 0 0 .47 1.64c.26.21.58.34.94.34ZM2 15.5a1.5 1.5 0 1 0 2.92-.48V15a1.5 1.5 0 0 0-1.4-1H3.5c-.83 0-1.5.67-1.5 1.5ZM7.49 6h.01c.65 0 1.2-.42 1.41-1l.01-.02a1.5 1.5 0 1 0-2.37.68c.26.21.58.34.94.34Zm-1.3.63-2.32 6.4c.34.05.66.17.94.34l2.32-6.4a2.48 2.48 0 0 1-.94-.34ZM14.05 5h-4.1a2.51 2.51 0 0 0 0-1h4.1a2.51 2.51 0 0 0 0 1Zm-.64 6.53 1.67-1.67 1.05-2.89a2.48 2.48 0 0 1-.94-.34l-1.78 4.9ZM5.95 16h3.52c.11-.36.29-.7.52-1H5.95a2.51 2.51 0 0 1 0 1Zm5.03-.62 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const SelectObjectSkewEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SelectObjectSkewEditRegularIcon, 'SelectObjectSkewEditRegular');

const SendFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z",
    fill: primaryFill
  }));
};

export const SendFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendFilledIcon, 'SendFilled');

const SendRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.18 2.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 0 1 0 .9l-15 7.5a.5.5 0 0 1-.7-.58L3.98 10 2.02 2.63a.5.5 0 0 1 .16-.52Zm2.7 8.39-1.61 6.06L16.38 10 3.27 3.44 4.88 9.5h6.62a.5.5 0 1 1 0 1H4.88Z",
    fill: primaryFill
  }));
};

export const SendRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendRegularIcon, 'SendRegular');

const SendClockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.72 1.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l6.33-3.16A5.5 5.5 0 0 1 17.2 9.7l.52-.26a.5.5 0 0 0 0-.9l-15-7.5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const SendClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendClockFilledIcon, 'SendClockFilled');

const SendClockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.18 1.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 1 1-.44.9l-14.01-7L4.88 8.5h6.62a.5.5 0 1 1 0 1H4.88l-1.61 6.06 6.1-3.06c-.15.41-.27.84-.32 1.29l-6.33 3.16a.5.5 0 0 1-.7-.58L3.98 9 2.02 1.63a.5.5 0 0 1 .16-.52ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const SendClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendClockRegularIcon, 'SendClockRegular');

const SendCopyFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.47 2.22c.3-.3.77-.3 1.06 0l2.5 2.5a.75.75 0 0 1-1.06 1.06L9.75 4.56v6.69a.75.75 0 0 1-1.5 0V4.56L7.03 5.78a.75.75 0 0 1-1.06-1.06l2.5-2.5ZM5.57 16.5A2 2 0 0 0 7.5 18H13a4.5 4.5 0 0 0 4.5-4.5v-2.25a.75.75 0 0 0-1.5 0v2.25a3 3 0 0 1-3 3H5.57ZM4.5 8.75a.75.75 0 0 0-1.5 0v4.75c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8.75a.75.75 0 0 0-1.5 0v4.75a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V8.75Z",
    fill: primaryFill
  }));
};

export const SendCopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendCopyFilledIcon, 'SendCopyFilled');

const SendCopyRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.65 2.15c.2-.2.5-.2.7 0l3 3a.5.5 0 0 1-.7.7L9.5 3.71v7.79a.5.5 0 0 1-1 0V3.7L6.35 5.86a.5.5 0 1 1-.7-.7l3-3ZM5.27 17c.34.6.99 1 1.73 1h6a4 4 0 0 0 4-4v-3.5a.5.5 0 1 0-1 0V14a3 3 0 0 1-3 3H5.27ZM4 8.5a.5.5 0 0 0-1 0V14c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-1 0V14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.5Z",
    fill: primaryFill
  }));
};

export const SendCopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SendCopyRegularIcon, 'SendCopyRegular');

const SerialPortFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.33 9.07A2.5 2.5 0 0 1 4.77 6h10.46a2.5 2.5 0 0 1 2.43 3.07l-.7 3A2.5 2.5 0 0 1 14.53 14H5.47a2.5 2.5 0 0 1-2.44-1.93l-.7-3ZM6 9.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM8.5 9a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0ZM7 11.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5-.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5-.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0ZM10 9.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5-.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
    fill: primaryFill
  }));
};

export const SerialPortFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SerialPortFilledIcon, 'SerialPortFilled');

const SerialPortRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 9.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM8.5 9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM7 11.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM10 9.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM4.77 6a2.5 2.5 0 0 0-2.44 3.07l.7 3A2.5 2.5 0 0 0 5.47 14h9.06a2.5 2.5 0 0 0 2.43-1.93l.7-3A2.5 2.5 0 0 0 15.23 6H4.77ZM3.3 8.84A1.5 1.5 0 0 1 4.77 7h10.46c.97 0 1.68.9 1.46 1.84l-.7 3A1.5 1.5 0 0 1 14.53 13H5.47c-.7 0-1.3-.48-1.46-1.16l-.7-3Z",
    fill: primaryFill
  }));
};

export const SerialPortRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SerialPortRegularIcon, 'SerialPortRegular');

const ServerFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2A2.5 2.5 0 0 0 5 4.5v11A2.5 2.5 0 0 0 7.5 18h5a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 12.5 2h-5ZM7 5.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 7c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ServerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerFilledIcon, 'ServerFilled');

const ServerRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM7 12.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM5 4.5A2.5 2.5 0 0 1 7.5 2h5A2.5 2.5 0 0 1 15 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 5 15.5v-11ZM7.5 3C6.67 3 6 3.67 6 4.5v11c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-5Z",
    fill: primaryFill
  }));
};

export const ServerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerRegularIcon, 'ServerRegular');

const ServerMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2A2.5 2.5 0 0 0 5 4.5v11A2.5 2.5 0 0 0 7.5 18h5a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 12.5 2h-5Zm0 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1ZM7 12.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM2 7c0-1.1.9-2 2-2v10.5c0 .17.01.34.04.5H4a2 2 0 0 1-2-2V7Zm14 8.5c0 .17-.01.34-.04.5H16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2v10.5Z",
    fill: primaryFill
  }));
};

export const ServerMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerMultipleFilledIcon, 'ServerMultipleFilled');

const ServerMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM7 12.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM5 4.5A2.5 2.5 0 0 1 7.5 2h5A2.5 2.5 0 0 1 15 4.5V5h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-1.05a2.5 2.5 0 0 1-2.45 2h-5a2.5 2.5 0 0 1-2.45-2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h1v-.5ZM15 15h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1v9ZM5 6H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1V6Zm2.5-3C6.67 3 6 3.67 6 4.5v11c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-5Z",
    fill: primaryFill
  }));
};

export const ServerMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerMultipleRegularIcon, 'ServerMultipleRegular');

const ServerPlayFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2A2.5 2.5 0 0 0 5 4.5v11A2.5 2.5 0 0 0 7.5 18h2.76a5.47 5.47 0 0 1-1.24-3H7.5a.5.5 0 0 1 0-1h1.52c.03-.34.1-.68.19-1H7.5a.5.5 0 0 1 0-1h2.1A5.5 5.5 0 0 1 15 9.02V4.5A2.5 2.5 0 0 0 12.5 2h-5ZM7 5.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm12 9a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.29-.44-2.97-1.65a.5.5 0 0 0-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 0 0 0-.88Z",
    fill: primaryFill
  }));
};

export const ServerPlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerPlayFilledIcon, 'ServerPlayFilled');

const ServerPlayRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 9.02V4.5c0-.83-.67-1.5-1.5-1.5h-5C6.67 3 6 3.67 6 4.5v11c0 .83.67 1.5 1.5 1.5h2.1c.18.36.4.7.66 1H7.5A2.5 2.5 0 0 1 5 15.5v-11A2.5 2.5 0 0 1 7.5 2h5A2.5 2.5 0 0 1 15 4.5v4.52a5.57 5.57 0 0 0-1 0ZM7.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM7 12.5c0-.28.22-.5.5-.5h2.1c-.16.32-.3.65-.4 1H7.5a.5.5 0 0 1-.5-.5Zm2 2c0-.17 0-.34.02-.5H7.5a.5.5 0 0 0 0 1h1.52a5.57 5.57 0 0 1-.02-.5Zm10 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.29-.44-2.97-1.65a.5.5 0 0 0-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 0 0 0-.88Z",
    fill: primaryFill
  }));
};

export const ServerPlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServerPlayRegularIcon, 'ServerPlayRegular');

const ServiceBellFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5a2 2 0 1 1 4 0v.79a7 7 0 0 1 5 6.71.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5 7 7 0 0 1 5-6.71V5Zm2.5 3.5c.42 0 .84 0 1.27.16.41.15.87.45 1.31 1.12a.5.5 0 0 0 .84-.56 3.66 3.66 0 0 0-1.81-1.5 4.51 4.51 0 0 0-1.59-.22h-.02a.5.5 0 0 0 0 1Zm-7 5.5a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 0 0 0-3h-13Z",
    fill: primaryFill
  }));
};

export const ServiceBellFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServiceBellFilledIcon, 'ServiceBellFilled');

const ServiceBellRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 8.5c.42 0 .84 0 1.27.16.41.15.87.45 1.31 1.12a.5.5 0 0 0 .84-.56 3.66 3.66 0 0 0-1.81-1.5 4.51 4.51 0 0 0-1.59-.22h-.02a.5.5 0 0 0 0 1ZM8 5v.79a7 7 0 0 0-5 6.71c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5 7 7 0 0 0-5-6.71V5a2 2 0 1 0-4 0Zm2-1a1 1 0 0 1 1 1v.57a7.06 7.06 0 0 0-2 0V5a1 1 0 0 1 1-1Zm0 2.5a6 6 0 0 1 5.98 5.5H4.02A6 6 0 0 1 10 6.5ZM3.5 14a1.5 1.5 0 0 0 0 3h13a1.5 1.5 0 0 0 0-3h-13ZM3 15.5c0-.28.22-.5.5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ServiceBellRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ServiceBellRegularIcon, 'ServiceBellRegular');

const SettingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.53 8.53 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54ZM8 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z",
    fill: primaryFill
  }));
};

export const SettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SettingsFilledIcon, 'SettingsFilled');

const SettingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.53 8.53 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54Zm1.06 0 1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1c.3.79.72 1.51 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67a7.56 7.56 0 0 0 2.5 0l.3-1.67a2 2 0 0 1 2.64-1.53l1.6.58a7.5 7.5 0 0 0 1.24-2.16l-1.3-1.1a2 2 0 0 1 0-3.04l1.3-1.1a7.5 7.5 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a7.55 7.55 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a7.5 7.5 0 0 0-1.24 2.16ZM7.5 10a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm1 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
    fill: primaryFill
  }));
};

export const SettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SettingsRegularIcon, 'SettingsRegular');

const SettingsChatFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32-.07.06a5.5 5.5 0 0 0-4.35.32 2 2 0 1 0-2.34 2.34 5.48 5.48 0 0 0-.13 4.81l-.43 1.4-.05.27a8.48 8.48 0 0 1-.79-.13.5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54Zm8.1 11.12a.4.4 0 0 0 .52.48l1.79-.54A4.5 4.5 0 1 0 14.5 10a4.49 4.49 0 0 0-2.72.92 4.48 4.48 0 0 0-1.21 5.77l-.55 1.78v.03ZM14.5 15a.5.5 0 0 1 0 1h-2a.5.5 0 1 1 0-1h2Zm-2-2h4a.5.5 0 1 1 0 1h-4a.5.5 0 1 1 0-1Z",
    fill: primaryFill
  }));
};

export const SettingsChatFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SettingsChatFilledIcon, 'SettingsChatFilled');

const SettingsChatRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32-.07.06c-.33-.11-.68-.2-1.04-.25a2 2 0 0 1 .47-.57l1.29-1.1a7.5 7.5 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a7.55 7.55 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a7.5 7.5 0 0 0-1.24 2.16l1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1c.3.79.72 1.51 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67.53.07-.22.7-.05.27a8.48 8.48 0 0 1-.79-.13.5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54Zm8.1 11.12a.4.4 0 0 0 .52.48l1.79-.54a4.5 4.5 0 1 0 .13-7.94 4.48 4.48 0 0 0-1.89 6.19l-.24.8-.3.98v.03ZM14.5 15a.5.5 0 0 1 0 1h-2a.5.5 0 1 1 0-1h2Zm2-1h-4a.5.5 0 1 1 0-1h4a.5.5 0 1 1 0 1ZM10 7.5a2.5 2.5 0 0 1 2.43 1.9c-.33.14-.64.3-.93.5a1.5 1.5 0 1 0-1.6 1.6c-.2.29-.36.6-.5.93A2.5 2.5 0 0 1 10 7.5Z",
    fill: primaryFill
  }));
};

export const SettingsChatRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SettingsChatRegularIcon, 'SettingsChatRegular');

const ShapeExcludeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10.5v-6A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V7H9.5A2.5 2.5 0 0 0 7 9.5V13H4.5A2.5 2.5 0 0 1 2 10.5ZM7 13v2.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H13v3.5a2.5 2.5 0 0 1-2.5 2.5H7Z",
    fill: primaryFill
  }));
};

export const ShapeExcludeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeExcludeFilledIcon, 'ShapeExcludeFilled');

const ShapeExcludeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10.53V4.5A2.5 2.5 0 0 1 4.5 2h6.06A2.49 2.49 0 0 1 13 4.5V7h2.5A2.5 2.5 0 0 1 18 9.5v6.22A2.5 2.5 0 0 1 15.5 18h-6A2.5 2.5 0 0 1 7 15.5V13H4.5a2.52 2.52 0 0 1-2.09-1.12c-.25-.38-.4-.84-.4-1.32L2 10.53ZM12 8H9.5C8.67 8 8 8.67 8 9.5V12h2.5c.83 0 1.5-.67 1.5-1.5V8ZM3 9.56v.94c0 .23.05.45.15.65l8-8A1.5 1.5 0 0 0 10.5 3h-.94L3 9.56ZM8.14 3H6.56L3 6.56v1.58L8.14 3ZM3 5.14 5.14 3H4.5C3.67 3 3 3.67 3 4.5v.64Zm8.85-1.29L8.5 7.21c.3-.14.64-.21 1-.21h.8L12 5.3v-.8c0-.23-.05-.45-.15-.65ZM7.21 8.5l-3.36 3.35c.2.1.42.15.65.15h.8L7 10.3v-.8c0-.36.07-.7.2-1ZM8 13.7v1.6l2.3-2.3H8.7l-.7.7Zm5-3.4L15.3 8h-1.6l-.7.7v1.6Zm3.4-2-8.1 8.1c.24.32.6.53 1 .59L17 9.3a1.5 1.5 0 0 0-.59-1Zm.6 2.4L10.7 17h1.6l4.7-4.7v-1.6Zm0 3L13.7 17h1.6l1.7-1.7v-1.6Z",
    fill: primaryFill
  }));
};

export const ShapeExcludeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeExcludeRegularIcon, 'ShapeExcludeRegular');

const ShapeIntersectFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V7h2.5A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5V13H4.5A2.5 2.5 0 0 1 2 10.5v-6ZM7 12V9.5A2.5 2.5 0 0 1 9.5 7H12V4.5c0-.83-.67-1.5-1.5-1.5h-6C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H7Zm1 1v2.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H13v2.5a2.5 2.5 0 0 1-2.5 2.5H8Z",
    fill: primaryFill
  }));
};

export const ShapeIntersectFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeIntersectFilledIcon, 'ShapeIntersectFilled');

const ShapeIntersectRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 0 1 4.5 2h6A2.5 2.5 0 0 1 13 4.5V7h2.5A2.5 2.5 0 0 1 18 9.5v6a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 7 15.5V13H4.5A2.5 2.5 0 0 1 2 10.5v-6Zm10 0c0-.83-.67-1.5-1.5-1.5h-6C3.67 3 3 3.67 3 4.5v6c0 .83.67 1.5 1.5 1.5H7V9.5A2.5 2.5 0 0 1 9.5 7H12V4.5Zm-4 6.2V12h.3L12 8.3V8h-1.3L8 10.7Zm.02-1.42 1.26-1.26a1.5 1.5 0 0 0-1.26 1.26ZM13 8v2.5a2.5 2.5 0 0 1-2.5 2.5H8v2.5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5H13Zm-3.3 4h.8c.83 0 1.5-.67 1.5-1.5v-.8L9.7 12Z",
    fill: primaryFill
  }));
};

export const ShapeIntersectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeIntersectRegularIcon, 'ShapeIntersectRegular');

const ShapeSubtractFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H7v2.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H13V4.5A2.5 2.5 0 0 0 10.5 2h-6ZM8 9.5C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5v-6Z",
    fill: primaryFill
  }));
};

export const ShapeSubtractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeSubtractFilledIcon, 'ShapeSubtractFilled');

const ShapeSubtractRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5V10.56c.01.48.16.94.41 1.32l.02.02A2.52 2.52 0 0 0 4.3 13H7v2.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H13V4.5a2.52 2.52 0 0 0-.41-1.38l-.02-.02A2.51 2.51 0 0 0 10.51 2H4.5Zm.64 1L3 5.14V4.5C3 3.67 3.67 3 4.5 3h.64ZM3 6.56 6.56 3h1.58L3 8.14V6.56ZM9.56 3h.94c.23 0 .45.05.65.15l-8 8A1.5 1.5 0 0 1 3 10.5v-.94L9.56 3Zm2.3.85c.09.2.14.42.14.65v.8L10.3 7h-.8c-.36 0-.7.07-1 .2l3.35-3.35ZM7.2 8.5c-.14.3-.21.64-.21 1v.8L5.3 12h-.8a1.5 1.5 0 0 1-.65-.15L7.21 8.5Zm.79 1C8 8.67 8.67 8 9.5 8h6c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 8 15.5v-6Z",
    fill: primaryFill
  }));
};

export const ShapeSubtractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeSubtractRegularIcon, 'ShapeSubtractRegular');

const ShapeUnionFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.5 13H7v2.5A2.5 2.5 0 0 0 9.5 18h6a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 15.5 7H13V4.5A2.5 2.5 0 0 0 10.5 2h-6Z",
    fill: primaryFill
  }));
};

export const ShapeUnionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeUnionFilledIcon, 'ShapeUnionFilled');

const ShapeUnionRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v6A2.5 2.5 0 0 0 4.3 13H7v2.5A2.5 2.5 0 0 0 9.5 18h6.22a2.5 2.5 0 0 0 2.27-2.28v-.01l.01-.21v-6A2.5 2.5 0 0 0 15.5 7H13V4.5a2.52 2.52 0 0 0-.5-1.5 2.5 2.5 0 0 0-2-1h-6Zm6.65 1.15-8 8A1.5 1.5 0 0 1 3 10.5v-.94L9.56 3h.94c.23 0 .45.05.65.15Zm-7.3 8.7 8-8c.1.2.15.42.15.65v.8L5.3 12h-.8a1.5 1.5 0 0 1-.65-.15ZM12 6.71v.79c0 .21.13.4.32.47l-4.35 4.35A.5.5 0 0 0 7.5 12h-.8L12 6.7ZM13.7 8h1.6L8 15.3v-1.6L13.7 8Zm2.7.3c.32.24.53.6.59 1L9.3 17a1.5 1.5 0 0 1-1-.59l8.1-8.1Zm.6 2.4v1.6L12.3 17h-1.6l6.3-6.3Zm0 3v1.6L15.3 17h-1.6l3.3-3.3ZM3 8.15V6.56L6.56 3h1.58L3 8.14Zm0-3V4.5C3 3.67 3.67 3 4.5 3h.64L3 5.14Z",
    fill: primaryFill
  }));
};

export const ShapeUnionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapeUnionRegularIcon, 'ShapeUnionRegular');

const ShapesFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 7.5A5.5 5.5 0 0 1 12.98 7H10.5A3.5 3.5 0 0 0 7 10.5v2.48A5.5 5.5 0 0 1 2 7.5Zm8.5.5A2.5 2.5 0 0 0 8 10.5v5a2.5 2.5 0 0 0 2.5 2.5h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 15.5 8h-5Z",
    fill: primaryFill
  }));
};

export const ShapesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapesFilledIcon, 'ShapesFilled');

const ShapesRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 3a4.5 4.5 0 0 0-.5 8.97v1A5.5 5.5 0 1 1 12.98 7h-1A4.5 4.5 0 0 0 7.5 3Zm3 5A2.5 2.5 0 0 0 8 10.5v5a2.5 2.5 0 0 0 2.5 2.5h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 15.5 8h-5ZM9 10.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 9 15.5v-5Z",
    fill: primaryFill
  }));
};

export const ShapesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShapesRegularIcon, 'ShapesRegular');

const ShareFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.38 5.7V3.59c0-.48.53-.74.89-.47l.06.05 4.5 4.42c.2.2.23.54.05.77l-.05.07-4.5 4.42c-.34.33-.89.12-.95-.34v-2.18l-.26.03a9.25 9.25 0 0 0-5.19 2.5c-.39.35-.99.03-.93-.5.5-4.09 2.59-6.34 6.15-6.63l.23-.01ZM5.5 4A2.5 2.5 0 0 0 3 6.5v8A2.5 2.5 0 0 0 5.5 17h8a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0v1c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 0 1 4 14.5v-8C4 5.67 4.67 5 5.5 5h3a.5.5 0 0 0 0-1h-3Z",
    fill: primaryFill
  }));
};

export const ShareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareFilledIcon, 'ShareFilled');

const ShareRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m13.33 12.84 4.5-4.42.05-.07a.59.59 0 0 0-.05-.77l-4.5-4.42-.06-.05c-.36-.27-.9-.01-.9.47V5.7l-.22.01C8.6 6.01 6.5 8.26 6 12.35c-.06.53.54.85.93.5a9.64 9.64 0 0 1 4.45-2.38c.24-.06.5-.1.74-.12l.26-.02v2.17c.06.46.61.67.95.34Zm-1.1-6.12 1.15-.08V4.61L16.82 8l-3.44 3.39V9.23l-1.36.12c-1.7.19-3.32.87-4.83 2 .3-1.33.8-2.34 1.47-3.06a5.2 5.2 0 0 1 3.57-1.57ZM5.5 4A2.5 2.5 0 0 0 3 6.5v8A2.5 2.5 0 0 0 5.5 17h8a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0v1c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 0 1 4 14.5v-8C4 5.67 4.67 5 5.5 5h3a.5.5 0 0 0 0-1h-3Z",
    fill: primaryFill
  }));
};

export const ShareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareRegularIcon, 'ShareRegular');

const ShareAndroidFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5a2.5 2.5 0 0 1-4.47 1.54L7.92 9.35a2.5 2.5 0 0 1 0 1.3l4.61 2.3a2.5 2.5 0 1 1-.45.9l-4.61-2.3a2.5 2.5 0 1 1 0-3.1l4.61-2.3A2.5 2.5 0 1 1 17 5.5Z",
    fill: primaryFill
  }));
};

export const ShareAndroidFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareAndroidFilledIcon, 'ShareAndroidFilled');

const ShareAndroidRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5.5a2.5 2.5 0 1 1 .53 1.54L7.92 9.35a2.5 2.5 0 0 1 0 1.3l4.61 2.3a2.5 2.5 0 1 1-.45.9l-4.61-2.3a2.5 2.5 0 1 1 0-3.1l4.61-2.3A2.5 2.5 0 0 1 12 5.5ZM14.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM4 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
    fill: primaryFill
  }));
};

export const ShareAndroidRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareAndroidRegularIcon, 'ShareAndroidRegular');

const ShareCloseTrayFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 16a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4Zm6-10a.5.5 0 0 0-.5.5v5.8l-1.65-1.65a.5.5 0 0 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7l-1.65 1.64V6.5A.5.5 0 0 0 10 6Z",
    fill: primaryFill
  }));
};

export const ShareCloseTrayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareCloseTrayFilledIcon, 'ShareCloseTrayFilled');

const ShareCloseTrayRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6a.5.5 0 0 0-.5.5v5.8l-1.65-1.65a.5.5 0 0 0-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 0 0-.7-.7l-1.65 1.64V6.5A.5.5 0 0 0 10 6Zm-8 8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8Zm2 1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4Z",
    fill: primaryFill
  }));
};

export const ShareCloseTrayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareCloseTrayRegularIcon, 'ShareCloseTrayRegular');

const ShareIosFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 9.25c.38 0 .7.28.74.65l.01.1v5.25A2.75 2.75 0 0 1 13.92 18H6.25a2.75 2.75 0 0 1-2.74-2.58l-.01-.17V10A.75.75 0 0 1 5 9.9v5.35c0 .65.5 1.18 1.12 1.24l.13.01h7.5c.65 0 1.18-.5 1.24-1.12l.01-.13V10c0-.41.34-.75.75-.75ZM5.23 6.46l4.24-4.24a.75.75 0 0 1 .98-.07l.08.07 4.24 4.24a.75.75 0 0 1-.97 1.14l-.09-.08-2.96-2.96v7.69c0 .38-.28.7-.65.74L10 13a.75.75 0 0 1-.74-.65l-.01-.1V4.56L6.29 7.52a.75.75 0 0 1-.98.08l-.08-.08a.75.75 0 0 1-.08-.97l.08-.09 4.24-4.24-4.24 4.24Z",
    fill: primaryFill
  }));
};

export const ShareIosFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareIosFilledIcon, 'ShareIosFilled');

const ShareIosRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 9.5a.5.5 0 0 1 .5.41V16a2.5 2.5 0 0 1-2.34 2.5H6a2.5 2.5 0 0 1-2.5-2.34V10a.5.5 0 0 1 1-.09V16c0 .78.6 1.42 1.36 1.5H14c.78 0 1.42-.6 1.5-1.36V10c0-.28.22-.5.5-.5ZM5.4 6.39l4.25-4.24a.5.5 0 0 1 .63-.06l.07.06 4.25 4.24a.5.5 0 0 1-.64.76l-.07-.05-3.39-3.4V13a.5.5 0 0 1-.41.5H10a.5.5 0 0 1-.5-.41V3.7L6.11 7.1a.5.5 0 0 1-.64.05L5.4 7.1a.5.5 0 0 1-.05-.64l.05-.07 4.25-4.24L5.4 6.39Z",
    fill: primaryFill
  }));
};

export const ShareIosRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareIosRegularIcon, 'ShareIosRegular');

const ShareScreenPersonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6.05a2.5 2.5 0 0 1 2.22-1.99A2.99 2.99 0 0 1 15.5 9a3 3 0 0 1 2.5 1.34V7a3 3 0 0 0-3-3H5Zm12.5 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonFilledIcon, 'ShareScreenPersonFilled');

const ShareScreenPersonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h6.3c.07-.37.23-.7.45-1H4.75C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V9.4c.4.23.74.56 1 .94V6.75A2.75 2.75 0 0 0 15.25 4H4.75Zm12.75 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonRegularIcon, 'ShareScreenPersonRegular');

const ShareScreenPersonOverlayFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.34a3 3 0 1 0-4.73 3.67c-1.1.1-2 .92-2.22 1.99H5a3 3 0 0 1-3-3V7Zm2 0v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1Zm13.5 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonOverlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonOverlayFilledIcon, 'ShareScreenPersonOverlayFilled');

const ShareScreenPersonOverlayRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.6c-.26-.4-.6-.72-1-.95V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h6.75c-.22.3-.38.63-.45 1h-6.3A2.75 2.75 0 0 1 2 13.25v-6.5ZM15.5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5ZM5 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5Z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonOverlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonOverlayRegularIcon, 'ShareScreenPersonOverlayRegular');

const ShareScreenPersonOverlayInsideFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5Zm10 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM12 10a1 1 0 0 0-1 1v1c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1h-3Z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonOverlayInsideFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonOverlayInsideFilledIcon, 'ShareScreenPersonOverlayInsideFilled');

const ShareScreenPersonOverlayInsideRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM11 11a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-1ZM5 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5Zm-.25-2A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4H4.75ZM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25v-6.5Z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonOverlayInsideRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonOverlayInsideRegularIcon, 'ShareScreenPersonOverlayInsideRegular');

const ShareScreenPersonPFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3.34a3 3 0 1 0-4.73 3.67c-1.1.1-2 .92-2.22 1.99H5a3 3 0 0 1-3-3V7Zm4 .5v5a.5.5 0 0 0 1 0V11h1a2 2 0 1 0 0-4H6.5a.5.5 0 0 0-.5.5ZM7 10h1a1 1 0 0 0 0-2H7v2Zm10.5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonPFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonPFilledIcon, 'ShareScreenPersonPFilled');

const ShareScreenPersonPRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.6c-.26-.4-.6-.72-1-.95V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h6.75c-.22.3-.38.63-.45 1h-6.3A2.75 2.75 0 0 1 2 13.25v-6.5ZM15.5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5Zm-9-12a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0V11h1a2 2 0 1 0 0-4H6.5ZM8 10H7V8h1a1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const ShareScreenPersonPRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenPersonPRegularIcon, 'ShareScreenPersonPRegular');

const ShareScreenStartFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm6 10a.5.5 0 0 1-.5-.5V7.7L7.85 9.36a.5.5 0 1 1-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-.5.5Z",
    fill: primaryFill
  }));
};

export const ShareScreenStartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenStartFilledIcon, 'ShareScreenStartFilled');

const ShareScreenStartRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 14a.5.5 0 0 1-.5-.5V7.7L7.85 9.36a.5.5 0 1 1-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-.5.5ZM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Z",
    fill: primaryFill
  }));
};

export const ShareScreenStartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenStartRegularIcon, 'ShareScreenStartRegular');

const ShareScreenStopFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11Zm2.65 3.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const ShareScreenStopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenStopFilledIcon, 'ShareScreenStopFilled');

const ShareScreenStopRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7ZM2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5v-7ZM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11Z",
    fill: primaryFill
  }));
};

export const ShareScreenStopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShareScreenStopRegularIcon, 'ShareScreenStopRegular');

const ShieldFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Z",
    fill: primaryFill
  }));
};

export const ShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldFilledIcon, 'ShieldFilled');

const ShieldRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM9.6 3.35A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25Z",
    fill: primaryFill
  }));
};

export const ShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldRegularIcon, 'ShieldRegular');

const ShieldAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6a5.5 5.5 0 0 0-6.78 8.35l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const ShieldAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldAddFilledIcon, 'ShieldAddFilled');

const ShieldAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6c-.32-.16-.65-.3-1-.4V5.44a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25.2.43.44.84.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const ShieldAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldAddRegularIcon, 'ShieldAddRegular');

const ShieldBadgeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h6V9c3.23 0 3.75-.83 4.11-1.43.2-.32.36-.57.89-.57s.69.25.89.57c.2.32.43.7 1.11 1V7a2 2 0 0 0-2-2H4Zm10.53 3.83v.02a1.63 1.63 0 0 1-.45.5c-.4.3-1.17.65-2.58.65a.5.5 0 0 0-.5.5v2c0 1.03.13 2.14.7 3.12.56 1 1.55 1.82 3.14 2.35.1.04.22.04.32 0a5.35 5.35 0 0 0 3.15-2.35c.56-.98.69-2.09.69-3.12v-2a.5.5 0 0 0-.5-.5c-1.41 0-2.18-.35-2.57-.65a1.63 1.63 0 0 1-.46-.52.5.5 0 0 0-.94 0Zm.94 0v.01Zm-.94 0v.01Z",
    fill: primaryFill
  }));
};

export const ShieldBadgeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldBadgeFilledIcon, 'ShieldBadgeFilled');

const ShieldBadgeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 7c0-1.1.9-2 2-2h11a2 2 0 0 1 2 2v1.57a2.11 2.11 0 0 1-1-.82V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6v1H4a2 2 0 0 1-2-2V7Zm12.53 1.83a.5.5 0 0 1 .95.02 1.63 1.63 0 0 0 .45.5c.4.3 1.16.65 2.57.65.28 0 .5.22.5.5v2c0 1.03-.13 2.14-.7 3.12a5.35 5.35 0 0 1-3.14 2.35.5.5 0 0 1-.32 0 5.35 5.35 0 0 1-3.15-2.35A6.19 6.19 0 0 1 11 12.5v-2a.5.5 0 0 1 .5-.5c1.41 0 2.18-.35 2.57-.65a1.63 1.63 0 0 0 .46-.52Zm.94 0v.01Zm0 0Zm-.94 0v.01Zm.15 1.32c-.54.4-1.38.76-2.68.84v1.51c0 .97.12 1.86.56 2.63A4.27 4.27 0 0 0 15 16.97a4.27 4.27 0 0 0 2.44-1.84c.44-.77.56-1.66.56-2.63v-1.51a4.81 4.81 0 0 1-2.68-.84L15 9.87c-.1.09-.2.19-.32.28Zm-.15-1.32",
    fill: primaryFill
  }));
};

export const ShieldBadgeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldBadgeRegularIcon, 'ShieldBadgeRegular');

const ShieldCheckmarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6a5.5 5.5 0 0 0-6.78 8.35l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-2.15-1.85c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0Z",
    fill: primaryFill
  }));
};

export const ShieldCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldCheckmarkFilledIcon, 'ShieldCheckmarkFilled');

const ShieldCheckmarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.6c-.32-.16-.65-.3-1-.4V5.44a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.24 1.8 5.64 5.48 7.25.2.43.44.84.74 1.2l-.04.02a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const ShieldCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldCheckmarkRegularIcon, 'ShieldCheckmarkRegular');

const ShieldDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42.5.5 0 0 1 .55 0ZM8.03 6.97a.75.75 0 0 0-1.06 1.06L8.94 10l-1.97 1.97a.75.75 0 1 0 1.06 1.06L10 11.06l1.97 1.97a.75.75 0 1 0 1.06-1.06L11.06 10l1.97-1.97a.75.75 0 0 0-1.06-1.06L10 8.94 8.03 6.97Z",
    fill: primaryFill
  }));
};

export const ShieldDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldDismissFilledIcon, 'ShieldDismissFilled');

const ShieldDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15Zm2.43-5.07a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Z",
    fill: primaryFill
  }));
};

export const ShieldDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldDismissRegularIcon, 'ShieldDismissRegular');

const ShieldDismissShieldFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0c.34-.14.68-.27 1-.42a5.82 5.82 0 0 1-.66-1.16 7.05 7.05 0 0 1-.52-2.5V11.05l-1.97 1.97a.75.75 0 0 1-1.06-1.06L8.94 10 6.97 8.03a.75.75 0 0 1 1.06-1.06L10 8.94l1.97-1.97a.75.75 0 1 1 1.06 1.06l-1.64 1.64h.01c.9 0 1.76-.37 2.6-1.24a1.39 1.39 0 0 1 2 0 5.06 5.06 0 0 0 1 .8V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM17 10.35a4.63 4.63 0 0 1-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0 0 13 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 0 0-.4-.33 4.24 4.24 0 0 1-1.6-.32Z",
    fill: primaryFill
  }));
};

export const ShieldDismissShieldFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldDismissShieldFilledIcon, 'ShieldDismissShieldFilled');

const ShieldDismissShieldRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0c.34-.14.68-.27 1-.42-.2-.27-.38-.56-.52-.86-.21.1-.43.18-.66.27-4.03-1.6-6-4.07-6-7.46V5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43v3a5.06 5.06 0 0 0 1 .8V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm-.24 8.67c.11-.47.46-.87.94-1.02l1.87-1.88a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15a.5.5 0 1 0-.7.7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l.04.04Zm6.96-.4a4.63 4.63 0 0 1-1-.59c-.24-.18-.48-.4-.72-.64a.39.39 0 0 0-.56 0 4.5 4.5 0 0 1-3.32 1.55.4.4 0 0 0-.4.41v2.77c.03.8.18 1.51.44 2.15A4.81 4.81 0 0 0 13 18c.52.4 1.15.73 1.87.98.09.03.17.03.26 0 2.56-.89 3.87-2.71 3.87-5.4V11a.4.4 0 0 0-.4-.33 4.24 4.24 0 0 1-1.6-.32Z",
    fill: primaryFill
  }));
};

export const ShieldDismissShieldRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldDismissShieldRegularIcon, 'ShieldDismissShieldRegular');

const ShieldErrorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM10 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5A.5.5 0 0 0 10 6Zm0 8.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    fill: primaryFill
  }));
};

export const ShieldErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldErrorFilledIcon, 'ShieldErrorFilled');

const ShieldErrorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5Zm0 8.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM9.6 3.35A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25Z",
    fill: primaryFill
  }));
};

export const ShieldErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldErrorRegularIcon, 'ShieldErrorRegular');

const ShieldGlobeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm2.68 8.42a3 3 0 0 1-1.43 2.08c.24-.57.4-1.3.45-2.08h.98Zm0-1a3 3 0 0 0-1.43-2.08c.24.57.4 1.3.45 2.08h.98Zm-1.98 0a5.13 5.13 0 0 0-.46-1.88 1.72 1.72 0 0 0-.39-.54.43.43 0 0 0-.12-.08.03.03 0 0 0-.02 0h-.01a.43.43 0 0 0-.11.08c-.11.09-.25.26-.39.54-.23.46-.4 1.11-.46 1.88h1.96Zm-1.96 1c.05.77.23 1.42.46 1.88.14.28.28.45.39.54a.42.42 0 0 0 .12.08.03.03 0 0 0 .02 0h.01c.02-.01.06-.03.11-.08.11-.09.25-.26.39-.54.23-.46.4-1.11.46-1.88H9.02Zm-1 0c.04.79.2 1.5.45 2.08a3 3 0 0 1-1.43-2.08h.98Zm0-1c.04-.79.2-1.5.45-2.08A3 3 0 0 0 7.04 9.5h.98ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: primaryFill
  }));
};

export const ShieldGlobeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldGlobeFilledIcon, 'ShieldGlobeFilled');

const ShieldGlobeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Zm8.96 5.07h-.98c-.04.79-.2 1.5-.45 2.08a3 3 0 0 0 1.43-2.08Zm0-1a3 3 0 0 0-1.43-2.08c.24.57.4 1.3.45 2.08h.98Zm-1.98 0a5.13 5.13 0 0 0-.46-1.88 1.72 1.72 0 0 0-.39-.54.43.43 0 0 0-.12-.08.03.03 0 0 0-.02 0h-.01a.43.43 0 0 0-.11.08c-.11.09-.25.26-.39.54-.23.46-.4 1.11-.46 1.88h1.96Zm-1.96 1c.05.77.23 1.42.46 1.88.14.28.28.45.39.54a.42.42 0 0 0 .12.08.03.03 0 0 0 .02 0h.01c.02-.01.06-.03.11-.08.11-.09.25-.26.39-.54.23-.46.4-1.11.46-1.88H9.02Zm-1 0h-.98a3 3 0 0 0 1.43 2.08c-.24-.57-.4-1.3-.45-2.08Zm0-1c.04-.79.2-1.5.45-2.08A3 3 0 0 0 7.04 9.5h.98ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: primaryFill
  }));
};

export const ShieldGlobeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldGlobeRegularIcon, 'ShieldGlobeRegular');

const ShieldKeyholeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM11.5 9c0 .65-.42 1.2-1 1.41v2.09a.5.5 0 0 1-1 0v-2.09a1.5 1.5 0 1 1 2-1.41Z",
    fill: primaryFill
  }));
};

export const ShieldKeyholeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldKeyholeFilledIcon, 'ShieldKeyholeFilled');

const ShieldKeyholeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 9c0 .65-.42 1.2-1 1.41v2.09a.5.5 0 0 1-1 0v-2.09a1.5 1.5 0 1 1 2-1.41Zm-1.22-6.92a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Z",
    fill: primaryFill
  }));
};

export const ShieldKeyholeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldKeyholeRegularIcon, 'ShieldKeyholeRegular');

const ShieldLockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.5 12v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5Zm1-1v1h2v-1a1 1 0 1 0-2 0Zm1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.34A3 3 0 0 0 11.5 11v.06A2 2 0 0 0 10 13v4a2 2 0 0 0 .24.94l-.06.03a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Z",
    fill: primaryFill
  }));
};

export const ShieldLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldLockFilledIcon, 'ShieldLockFilled');

const ShieldLockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.34c-.26-.38-.6-.7-1-.94V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46V17a2 2 0 0 0 .24.94l-.06.03a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM12.5 12v-1a2 2 0 1 1 4 0v1h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h.5Zm1-1v1h2v-1a1 1 0 1 0-2 0Zm1.75 4a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z",
    fill: primaryFill
  }));
};

export const ShieldLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldLockRegularIcon, 'ShieldLockRegular');

const ShieldPersonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM10 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 5c-2.5 0-3.5-1.25-3.5-2.5 0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5 0 1.24-1 2.5-3.5 2.5Z",
    fill: primaryFill
  }));
};

export const ShieldPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldPersonFilledIcon, 'ShieldPersonFilled');

const ShieldPersonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 5c2.5 0 3.5-1.26 3.5-2.5 0-.83-.67-1.5-1.5-1.5H8c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5Zm.28-12.42a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Z",
    fill: primaryFill
  }));
};

export const ShieldPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldPersonRegularIcon, 'ShieldPersonRegular');

const ShieldPersonAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0l.04-.02A5.48 5.48 0 0 1 9 14.42c-1.77-.29-2.5-1.35-2.5-2.42 0-.83.67-1.5 1.5-1.5h2.73A5.48 5.48 0 0 1 17 9.6V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM10 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm9 5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const ShieldPersonAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldPersonAddFilledIcon, 'ShieldPersonAddFilled');

const ShieldPersonAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0l.04-.02a5.5 5.5 0 0 1-.74-1.2C5.8 15.15 4 12.75 4 9.5V5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.2c.35.1.68.23 1 .39V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM9 14.42a5.48 5.48 0 0 1 1.73-3.92H8c-.83 0-1.5.67-1.5 1.5 0 1.07.73 2.13 2.5 2.42Zm3-6.92a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm7 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const ShieldPersonAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldPersonAddRegularIcon, 'ShieldPersonAddRegular');

const ShieldProhibitedFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0l.07-.03A5.5 5.5 0 1 1 17 9.26V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm.42 13.52 4.9-4.9a3.5 3.5 0 0 0-4.9 4.9Zm.7.7a3.5 3.5 0 0 0 4.9-4.9l-4.9 4.9Zm2.1 1.7a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z",
    fill: primaryFill
  }));
};

export const ShieldProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldProhibitedFilledIcon, 'ShieldProhibitedFilled');

const ShieldProhibitedRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0l.07-.03c-.55-.4-1.02-.9-1.38-1.48C5.6 14.86 4 12.56 4 9.5V5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V8.6c.36.18.7.4 1 .66V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm.42 13.52 4.9-4.9a3.5 3.5 0 0 0-4.9 4.9Zm.7.7a3.5 3.5 0 0 0 4.9-4.9l-4.9 4.9Zm2.1 1.7a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z",
    fill: primaryFill
  }));
};

export const ShieldProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldProhibitedRegularIcon, 'ShieldProhibitedRegular');

const ShieldQuestionFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42Zm1.03 11.67a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm-2-5.5a1.25 1.25 0 1 1 2.5 0c0 .46-.27.76-.73 1.22l-.03.03c-.42.42-.99.99-.99 1.9v.1a.5.5 0 0 0 1 0v-.1c0-.47.27-.77.73-1.22l.03-.04c.42-.41.99-.98.99-1.89a2.25 2.25 0 0 0-4.5 0 .5.5 0 0 0 1 0Z",
    fill: primaryFill
  }));
};

export const ShieldQuestionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldQuestionFilledIcon, 'ShieldQuestionFilled');

const ShieldQuestionRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.72 2.08a.5.5 0 0 1 .56 0c1.94 1.3 4.03 2.1 6.3 2.43A.5.5 0 0 1 17 5v4.5c0 3.9-2.3 6.73-6.82 8.47a.5.5 0 0 1-.36 0C5.31 16.23 3 13.39 3 9.5V5a.5.5 0 0 1 .43-.5 15.05 15.05 0 0 0 6.3-2.42ZM9.6 3.35A15.97 15.97 0 0 1 4 5.43V9.5c0 3.4 1.97 5.86 6 7.46 4.03-1.6 6-4.07 6-7.46V5.43a15.97 15.97 0 0 1-5.6-2.08L10 3.1l-.4.25Zm1.15 10.4a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-2-5.5a1.25 1.25 0 1 1 2.5 0c0 .46-.27.76-.73 1.22l-.03.03c-.42.42-.99.99-.99 1.9v.1a.5.5 0 0 0 1 0v-.1c0-.47.27-.77.73-1.22l.03-.04c.42-.41.99-.98.99-1.89a2.25 2.25 0 0 0-4.5 0 .5.5 0 0 0 1 0Z",
    fill: primaryFill
  }));
};

export const ShieldQuestionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldQuestionRegularIcon, 'ShieldQuestionRegular');

const ShieldTaskFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.08a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42Zm3.57 5.77-4 4a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7l1.65 1.64 3.65-3.64a.5.5 0 0 1 .7.7Z",
    fill: primaryFill
  }));
};

export const ShieldTaskFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldTaskFilledIcon, 'ShieldTaskFilled');

const ShieldTaskRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.85 7.85a.5.5 0 0 0-.7-.7L9.5 10.79 7.85 9.15a.5.5 0 0 0-.7.7l2 2c.2.2.5.2.7 0l4-4Zm-3.57-5.77a.5.5 0 0 0-.56 0 15.05 15.05 0 0 1-6.3 2.43A.5.5 0 0 0 3 5v4.5c0 3.9 2.3 6.73 6.82 8.47a.5.5 0 0 0 .36 0C14.69 16.23 17 13.39 17 9.5V5a.5.5 0 0 0-.43-.5 15.05 15.05 0 0 1-6.3-2.42ZM4 5.43a15.97 15.97 0 0 0 5.6-2.08l.4-.25.4.25A15.97 15.97 0 0 0 16 5.43V9.5c0 3.4-1.97 5.86-6 7.46-4.03-1.6-6-4.07-6-7.46V5.43Z",
    fill: primaryFill
  }));
};

export const ShieldTaskRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShieldTaskRegularIcon, 'ShieldTaskRegular');

const ShiftsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm7 .5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V6.5Z",
    fill: primaryFill
  }));
};

export const ShiftsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsFilledIcon, 'ShiftsFilled');

const ShiftsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V6.5ZM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z",
    fill: primaryFill
  }));
};

export const ShiftsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsRegularIcon, 'ShiftsRegular');

const Shifts30MinutesFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM8 8a2 2 0 0 0-2 2v.5c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5V10a2 2 0 0 0-2-2H8Zm-2.5 5.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.05-3.58c-.18.3-.3.77-.3 1.33s.12 1.03.3 1.33c.17.28.4.42.7.42.3 0 .53-.14.7-.42.18-.3.3-.77.3-1.33a2.6 2.6 0 0 0-.3-1.33c-.17-.28-.4-.42-.7-.42-.3 0-.53.14-.7.42Zm-.85-.52c.33-.53.85-.9 1.55-.9.7 0 1.22.37 1.55.9.32.5.45 1.17.45 1.85 0 .68-.13 1.34-.45 1.85-.33.53-.85.9-1.55.9-.7 0-1.22-.37-1.55-.9a3.58 3.58 0 0 1-.45-1.85c0-.68.13-1.34.45-1.85Zm-4.14.5c.46-.36.83-.43 1.08-.4.25.05.44.2.54.37.1.17.09.35 0 .48-.08.14-.32.35-.9.4a.5.5 0 0 0 0 1c.6.05.82.25.9.37.09.13.1.31 0 .5-.1.18-.3.33-.55.37-.25.04-.61-.02-1.07-.38a.5.5 0 1 0-.62.78c.62.5 1.26.68 1.85.6.57-.1 1.02-.45 1.26-.9a1.47 1.47 0 0 0-.33-1.85 1.47 1.47 0 0 0 .33-1.86c-.24-.44-.7-.78-1.27-.86a2.4 2.4 0 0 0-1.84.6.5.5 0 0 0 .62.78Z",
    fill: primaryFill
  }));
};

export const Shifts30MinutesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Shifts30MinutesFilledIcon, 'Shifts30MinutesFilled');

const Shifts30MinutesRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM10 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-3 8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V10a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0V10Zm-1.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.05-3.58c-.18.3-.3.77-.3 1.33s.12 1.03.3 1.33c.17.28.4.42.7.42.3 0 .53-.14.7-.42.18-.3.3-.77.3-1.33a2.6 2.6 0 0 0-.3-1.33c-.17-.28-.4-.42-.7-.42-.3 0-.53.14-.7.42Zm-.85-.52c.33-.53.85-.9 1.55-.9.7 0 1.22.37 1.55.9.32.5.45 1.17.45 1.85 0 .68-.13 1.34-.45 1.85-.33.53-.85.9-1.55.9-.7 0-1.22-.37-1.55-.9a3.58 3.58 0 0 1-.45-1.85c0-.68.13-1.34.45-1.85Zm-4.14.5c.46-.36.83-.43 1.08-.4.25.05.44.2.54.37.1.17.09.35 0 .48-.08.14-.32.35-.9.4a.5.5 0 0 0 0 1c.6.05.82.25.9.37.09.13.1.31 0 .5-.1.18-.3.33-.55.37-.25.04-.61-.02-1.07-.38a.5.5 0 1 0-.62.78c.62.5 1.26.68 1.85.6.57-.1 1.02-.45 1.26-.9a1.47 1.47 0 0 0-.33-1.85 1.47 1.47 0 0 0 .33-1.86c-.24-.44-.7-.78-1.27-.86a2.4 2.4 0 0 0-1.84.6.5.5 0 0 0 .62.78Z",
    fill: primaryFill
  }));
};

export const Shifts30MinutesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Shifts30MinutesRegularIcon, 'Shifts30MinutesRegular');

const ShiftsActivityFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.7a.75.75 0 0 1-.67.83 6.5 6.5 0 1 0 7.14 7.14.75.75 0 1 1 1.5.16 8 8 0 1 1-8.8-8.8c.42-.04.79.26.83.68Zm1.02-.06c.1-.4.5-.65.9-.55.38.09.75.2 1.1.35a.75.75 0 0 1-.55 1.39 6.55 6.55 0 0 0-.9-.29.75.75 0 0 1-.55-.9Zm6.54 4.33a.75.75 0 0 0-1.39.56c.12.29.21.59.28.9a.75.75 0 1 0 1.46-.35c-.09-.38-.2-.75-.35-1.1ZM14.3 3.93a.75.75 0 0 1 1.06-.08c.3.27.6.56.86.87a.75.75 0 0 1-1.15.97 6.65 6.65 0 0 0-.7-.7.75.75 0 0 1-.07-1.06ZM10 5.75a.75.75 0 0 0-1.5 0v5c0 .41.34.75.75.75h3a.75.75 0 1 0 0-1.5H10V5.75Z",
    fill: primaryFill
  }));
};

export const ShiftsActivityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsActivityFilledIcon, 'ShiftsActivityFilled');

const ShiftsActivityRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.48a.5.5 0 0 1-.46.53 7 7 0 1 0 7.45 7.45.5.5 0 1 1 1 .07 8 8 0 1 1-8.52-8.51.5.5 0 0 1 .53.46Zm1 .07a.5.5 0 0 1 .6-.4c.56.12 1.1.3 1.6.52a.5.5 0 1 1-.4.91c-.44-.2-.91-.34-1.4-.44a.5.5 0 0 1-.4-.59Zm6.34 4.25a.5.5 0 1 0-.92.4c.2.45.34.91.44 1.4a.5.5 0 0 0 .98-.2 7.95 7.95 0 0 0-.5-1.6ZM14.4 3.92a.5.5 0 0 1 .7-.07c.4.33.75.69 1.08 1.08a.5.5 0 1 1-.78.63c-.28-.34-.6-.66-.93-.94a.5.5 0 0 1-.07-.7ZM10 5.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h3a.5.5 0 1 0 0-1H10V5.5Z",
    fill: primaryFill
  }));
};

export const ShiftsActivityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsActivityRegularIcon, 'ShiftsActivityRegular');

const ShiftsAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v3.6a5.5 5.5 0 0 1 7.4 7.4H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm4.5 3c.28 0 .5.22.5.5V9h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5Zm-.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H6v-1.5Z",
    fill: primaryFill
  }));
};

export const ShiftsAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsAddFilledIcon, 'ShiftsAddFilled');

const ShiftsAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm-.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H6v1.5a.5.5 0 0 1-1 0V15H3.5a.5.5 0 0 1 0-1H5v-1.5c0-.28.22-.5.5-.5ZM11 6.5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11V6.5Z",
    fill: primaryFill
  }));
};

export const ShiftsAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsAddRegularIcon, 'ShiftsAddRegular');

const ShiftsAvailabilityFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12.92A7 7 0 0 1 12.92 6 6 6 0 1 0 6 12.92Zm3.35-8.27c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 1 1 .7-.7L6 7.29l2.65-2.64c.2-.2.5-.2.7 0ZM13 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-1.65-8.35L13 12.29l1.65-1.64a.5.5 0 0 1 .7.7L13.71 13l1.64 1.65a.5.5 0 0 1-.7.7L13 13.71l-1.65 1.64a.5.5 0 0 1-.7-.7L12.29 13l-1.64-1.65a.5.5 0 0 1 .7-.7Z",
    fill: primaryFill
  }));
};

export const ShiftsAvailabilityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsAvailabilityFilledIcon, 'ShiftsAvailabilityFilled');

const ShiftsAvailabilityRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.92 6.08a5 5 0 1 0-5.84 5.84c-.05.32-.08.66-.08 1A6 6 0 1 1 12.92 6c-.34 0-.68.03-1 .08Zm-.57 4.57a.5.5 0 0 0-.7.7L12.29 13l-1.64 1.65a.5.5 0 0 0 .7.7L13 13.71l1.65 1.64a.5.5 0 0 0 .7-.7L13.71 13l1.64-1.65a.5.5 0 0 0-.7-.7L13 12.29l-1.65-1.64ZM13 19a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-1a5 5 0 1 1 0-10 5 5 0 0 1 0 10ZM9.35 5.35a.5.5 0 1 0-.7-.7L6 7.29 4.85 6.15a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3-3Z",
    fill: primaryFill
  }));
};

export const ShiftsAvailabilityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsAvailabilityRegularIcon, 'ShiftsAvailabilityRegular');

const ShiftsCheckmarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6a5.48 5.48 0 0 0-.66-6h2.76a.5.5 0 0 0 0-1H10V6.5a.5.5 0 0 0-1 0v3.76a5.48 5.48 0 0 0-6-.66V6Zm7 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0L4.5 15.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const ShiftsCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsCheckmarkFilledIcon, 'ShiftsCheckmarkFilled');

const ShiftsCheckmarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm3 7.26c.27.22.52.47.74.74h2.76a.5.5 0 0 0 0-1H10V6.5a.5.5 0 0 0-1 0v3.76Zm1 4.24a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0L4.5 15.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const ShiftsCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsCheckmarkRegularIcon, 'ShiftsCheckmarkRegular');

const ShiftsDayFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9Zm3.4 2.04a1.82 1.82 0 0 0-.34.5l-.03.08a.5.5 0 0 0 .94.34l.02-.05.13-.17c.12-.11.3-.24.65-.24.4 0 .64.23.75.54.1.33.03.72-.24.96-.15.15-.34.28-.58.44l-.04.02c-.22.15-.47.31-.7.51A2.52 2.52 0 0 0 6 12.5a.5.5 0 0 0 .5.5H9a.5.5 0 0 0 0-1H7.07c.1-.32.29-.56.54-.77.18-.15.39-.3.62-.44l.02-.02c.23-.15.5-.33.72-.54.58-.54.71-1.34.5-2A1.74 1.74 0 0 0 7.77 7c-.64 0-1.09.26-1.36.54ZM11.5 7a.5.5 0 0 0-.5.5V10a.5.5 0 0 0 .5.5H13v2a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v2h-1v-2a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const ShiftsDayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsDayFilledIcon, 'ShiftsDayFilled');

const ShiftsDayRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.4 7.54c.28-.28.73-.54 1.37-.54.88 0 1.48.56 1.7 1.23.21.66.08 1.46-.5 2-.23.21-.49.39-.72.54l-.02.02c-.23.15-.44.29-.62.44a1.6 1.6 0 0 0-.54.77H9a.5.5 0 1 1 0 1H6.5a.5.5 0 0 1-.5-.5c0-.97.44-1.59.96-2.03.23-.2.48-.36.7-.5l.04-.03c.24-.16.43-.3.58-.44a.93.93 0 0 0 .24-.96.75.75 0 0 0-.75-.54.86.86 0 0 0-.65.24.82.82 0 0 0-.15.22.5.5 0 0 1-.94-.34l.03-.07.07-.14c.05-.1.15-.23.28-.37ZM11.5 7c.28 0 .5.22.5.5v2h1v-2a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-2h-1.5a.5.5 0 0 1-.5-.5V7.5c0-.28.22-.5.5-.5Zm-6-4A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3h-9ZM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-9Z",
    fill: primaryFill
  }));
};

export const ShiftsDayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsDayRegularIcon, 'ShiftsDayRegular');

const ShiftsOpenFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 5.75c0-.69.56-1.25 1.25-1.25H7.5a.75.75 0 0 0 0-1.5H5.75A2.75 2.75 0 0 0 3 5.75v8.5A2.75 2.75 0 0 0 5.75 17H7.5a.75.75 0 0 0 0-1.5H5.75c-.69 0-1.25-.56-1.25-1.25v-8.5Zm8-2.75a.75.75 0 0 0 0 1.5h1.75c.69 0 1.25.56 1.25 1.25v8.5c0 .69-.56 1.25-1.25 1.25H12.5a.75.75 0 0 0 0 1.5h1.75A2.75 2.75 0 0 0 17 14.25v-8.5A2.75 2.75 0 0 0 14.25 3H12.5Zm-2 2.75a.75.75 0 0 0-1.5 0v4.5c0 .41.34.75.75.75h3.5a.75.75 0 0 0 0-1.5H10.5V5.75Z",
    fill: primaryFill
  }));
};

export const ShiftsOpenFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsOpenFilledIcon, 'ShiftsOpenFilled');

const ShiftsOpenRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.5C4 4.67 4.67 4 5.5 4h2a.5.5 0 0 0 0-1h-2A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h2a.5.5 0 0 0 0-1h-2A1.5 1.5 0 0 1 4 14.5v-9ZM12.5 3a.5.5 0 0 0 0 1h2c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-2a.5.5 0 0 0 0 1h2a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3h-2ZM10 5.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1H10V5.5Z",
    fill: primaryFill
  }));
};

export const ShiftsOpenRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsOpenRegularIcon, 'ShiftsOpenRegular');

const ShiftsProhibitedFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6A5.5 5.5 0 0 0 3 9.6V6Zm8 .5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11V6.5Zm-10 8a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1ZM5.5 18c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 0 1 5.5 18Z",
    fill: primaryFill
  }));
};

export const ShiftsProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsProhibitedFilledIcon, 'ShiftsProhibitedFilled');

const ShiftsProhibitedRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.6c.16-.32.3-.65.4-1H14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3.2c-.35.1-.68.24-1 .4V6Zm7.5 0c.28 0 .5.22.5.5V9h1.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5ZM1 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1ZM5.5 18c-.79 0-1.51-.26-2.1-.7l4.9-4.9A3.5 3.5 0 0 1 5.5 18Z",
    fill: primaryFill
  }));
};

export const ShiftsProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsProhibitedRegularIcon, 'ShiftsProhibitedRegular');

const ShiftsQuestionMarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v3.6a5.5 5.5 0 0 1 7.4 7.4H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm4.5 3c.28 0 .5.22.5.5V9h2a.5.5 0 0 1 0 1h-2.5a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5Zm-.5 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25Zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95Z",
    fill: primaryFill
  }));
};

export const ShiftsQuestionMarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsQuestionMarkFilledIcon, 'ShiftsQuestionMarkFilled');

const ShiftsQuestionMarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v3.6c.32-.16.65-.3 1-.4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.2c-.1.35-.24.68-.4 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm5 3.5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H11V6.5Zm-1 8a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.5 1.88a.62.62 0 1 0 0 1.25.62.62 0 0 0 0-1.25Zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 1 0 1-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 0 0 1 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95Z",
    fill: primaryFill
  }));
};

export const ShiftsQuestionMarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsQuestionMarkRegularIcon, 'ShiftsQuestionMarkRegular');

const ShiftsTeamFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3.02l.02-.38c0-.91-.59-1.75-1.45-2.02a2.25 2.25 0 0 0-3.31-3.01A2.75 2.75 0 0 0 3 10.1V6Zm7 .5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V6.5Zm-6.25 8a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM4 19c2.14 0 3-1.1 3-2.19a1.3 1.3 0 0 0-1.29-1.31H2.3A1.3 1.3 0 0 0 1 16.81c0 1.1.86 2.19 3 2.19Zm3.5-.5h-.02c.35-.51.52-1.1.52-1.69 0-.48-.15-.93-.4-1.31h1.33c.6 0 1.07.5 1.07 1.13 0 .93-.71 1.87-2.5 1.87Zm.25-4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: primaryFill
  }));
};

export const ShiftsTeamFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsTeamFilledIcon, 'ShiftsTeamFilled');

const ShiftsTeamRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H10V6.5ZM6 3a3 3 0 0 0-3 3v4.1a2.75 2.75 0 0 1 1-.09V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.1a2.16 2.16 0 0 1 .08 1H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM3.75 14.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM4 19c2.14 0 3-1.1 3-2.19a1.3 1.3 0 0 0-1.29-1.31H2.3A1.3 1.3 0 0 0 1 16.81c0 1.1.86 2.19 3 2.19Zm3.5-.5h-.02c.35-.51.52-1.1.52-1.69 0-.48-.15-.93-.4-1.31h1.33c.6 0 1.07.5 1.07 1.13 0 .93-.71 1.87-2.5 1.87Zm.25-4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: primaryFill
  }));
};

export const ShiftsTeamRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShiftsTeamRegularIcon, 'ShiftsTeamRegular');

const ShoppingBagFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 0 1 .73-1.77A2.43 2.43 0 0 1 8.5 2a2.43 2.43 0 0 1 1.5.5 2.44 2.44 0 0 1 2.48-.3 2.53 2.53 0 0 1 1.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 0 1 1 1v8a2.95 2.95 0 0 1-1.47 2.58l-.59-.26-.5-.22-.2-.11-.23-.17-.24-.21-.27-.29A2 2 0 0 1 12 15V6h1V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 11.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0 1 11 4.5V15a2.95 2.95 0 0 0 .77 2l.3.33.31.27.31.23.31.17H7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1Zm1 0h3V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 8.5 3a1.47 1.47 0 0 0-1.06.44A1.48 1.48 0 0 0 7 4.5V6Z",
    fill: primaryFill
  }));
};

export const ShoppingBagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagFilledIcon, 'ShoppingBagFilled');

const ShoppingBagRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.5a2.5 2.5 0 0 0-4 2V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h6.5a2.5 2.5 0 0 0 2.5-2.5V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2Zm-3 2a1.5 1.5 0 1 1 3 0V6H7V4.5Zm3.67-1.25A1.5 1.5 0 0 1 13 4.5V6h-2V4.5c0-.45-.12-.88-.33-1.25ZM7 17a2 2 0 0 1-2-2V7h6v8.5c0 .56.19 1.08.5 1.5H7Zm8-1.5a1.5 1.5 0 0 1-3 0V7h3v8.5Z",
    fill: primaryFill
  }));
};

export const ShoppingBagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagRegularIcon, 'ShoppingBagRegular');

const ShoppingBagArrowLeftFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 0 1 .73-1.77A2.43 2.43 0 0 1 8.5 2a2.43 2.43 0 0 1 1.5.5 2.44 2.44 0 0 1 2.48-.3 2.53 2.53 0 0 1 1.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 0 1 1 1v2.2a5.5 5.5 0 0 0-4 .4V6h1V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 11.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0 1 11 4.5v5.76a5.49 5.49 0 0 0-.74 7.74H7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1Zm4 0V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 8.5 3a1.47 1.47 0 0 0-1.06.44A1.48 1.48 0 0 0 7 4.5V6h3Zm9 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z",
    fill: primaryFill
  }));
};

export const ShoppingBagArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagArrowLeftFilledIcon, 'ShoppingBagArrowLeftFilled');

const ShoppingBagArrowLeftRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 6a1 1 0 0 1 1 1v2.2c-.32-.08-.66-.15-1-.18V7h-3v2.6c-.36.18-.7.4-1 .66V7H5v8a1.98 1.98 0 0 0 1.23 1.84c.24.1.5.16.77.16h2.6c.18.36.4.7.66 1H7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1V4.5a2.42 2.42 0 0 1 .73-1.77A2.43 2.43 0 0 1 8.5 2a2.43 2.43 0 0 1 1.5.5 2.44 2.44 0 0 1 2.48-.3 2.53 2.53 0 0 1 1.32 1.33c.13.3.2.63.2.97V6h1Zm-2-1.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 11.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0 1 11 4.5V6h2V4.5ZM7 6h3V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 8.5 3a1.47 1.47 0 0 0-1.06.44A1.48 1.48 0 0 0 7 4.5V6Zm7.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-2.36-4.85 2-2a.5.5 0 0 1 .71.7L13.71 14h2.79a.5.5 0 0 1 0 1h-2.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1-.15-.35.5.5 0 0 1 .14-.35Z",
    fill: primaryFill
  }));
};

export const ShoppingBagArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagArrowLeftRegularIcon, 'ShoppingBagArrowLeftRegular');

const ShoppingBagDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 0 1 .73-1.77A2.43 2.43 0 0 1 8.5 2a2.43 2.43 0 0 1 1.5.5 2.44 2.44 0 0 1 2.48-.3 2.53 2.53 0 0 1 1.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 0 1 1 1v2.2a5.5 5.5 0 0 0-4 .4V6h1V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 11.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0 1 11 4.5v5.76a5.49 5.49 0 0 0-.74 7.74H7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1Zm4 0V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 8.5 3a1.47 1.47 0 0 0-1.06.44A1.48 1.48 0 0 0 7 4.5V6h3Zm9 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const ShoppingBagDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagDismissFilledIcon, 'ShoppingBagDismissFilled');

const ShoppingBagDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.5a2.5 2.5 0 0 0-4 2V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h3.26a5.5 5.5 0 0 1-.66-1H7a2 2 0 0 1-2-2V7h6v3.26c.3-.26.64-.48 1-.66V7h3v2.02c.34.03.68.1 1 .19V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2Zm-3 2a1.5 1.5 0 1 1 3 0V6H7V4.5Zm3.67-1.25A1.5 1.5 0 0 1 13 4.5V6h-2V4.5c0-.45-.12-.88-.33-1.25ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const ShoppingBagDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagDismissRegularIcon, 'ShoppingBagDismissRegular');

const ShoppingBagPauseFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 0 1 .73-1.77A2.43 2.43 0 0 1 8.5 2a2.43 2.43 0 0 1 1.5.5 2.44 2.44 0 0 1 2.48-.3 2.53 2.53 0 0 1 1.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 0 1 1 1v2.2a5.5 5.5 0 0 0-4 .4V6h1V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 11.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0 1 11 4.5v5.76a5.49 5.49 0 0 0-.74 7.74H7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1Zm4 0V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 8.5 3a1.47 1.47 0 0 0-1.06.44A1.48 1.48 0 0 0 7 4.5V6h3Zm9 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM13 12a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Zm3 0a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const ShoppingBagPauseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPauseFilledIcon, 'ShoppingBagPauseFilled');

const ShoppingBagPauseRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.5a2.5 2.5 0 0 0-4 2V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h3.26a5.5 5.5 0 0 1-.66-1H7a2 2 0 0 1-2-2V7h6v3.26c.3-.26.64-.48 1-.66V7h3v2.02c.34.03.68.1 1 .19V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2Zm-3 2a1.5 1.5 0 1 1 3 0V6H7V4.5Zm3.67-1.25A1.5 1.5 0 0 1 13 4.5V6h-2V4.5c0-.45-.12-.88-.33-1.25ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM13 12a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Zm3 0a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const ShoppingBagPauseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPauseRegularIcon, 'ShoppingBagPauseRegular');

const ShoppingBagPercentFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5V6H5a1 1 0 0 0-1 1v8a2.93 2.93 0 0 0 .88 2.13A3 3 0 0 0 7 18h3.09a1.5 1.5 0 0 1 .35-1.56l.56-.56v-1.05a3 3 0 0 1 0-5.66V4.5a2.48 2.48 0 0 0-.33-1.24 1.48 1.48 0 0 1 2.21.66c.08.18.12.37.12.58V6h-1v3a3 3 0 0 1 3 2.88l1-1V7a1 1 0 0 0-1-1h-1V4.5a2.48 2.48 0 0 0-4-2A2.54 2.54 0 0 0 8.5 2a2.42 2.42 0 0 0-1.77.73A2.43 2.43 0 0 0 6 4.5Zm4 0V6H7V4.5a1.48 1.48 0 0 1 .91-1.38 1.48 1.48 0 0 1 1.97.8c.08.18.12.37.12.58Zm2 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm.85-4.15a.5.5 0 0 0-.7-.7l-6 6a.5.5 0 0 0 .7.7l6-6Z",
    fill: primaryFill
  }));
};

export const ShoppingBagPercentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPercentFilledIcon, 'ShoppingBagPercentFilled');

const ShoppingBagPercentRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c.56 0 1.08.19 1.5.5a2.5 2.5 0 0 1 4 2V6h1a1 1 0 0 1 1 1v3.88l-1 1V7h-3v2a3 3 0 0 0-1 .17V7H5v8c0 1.1.9 2 2 2h3.09a1.5 1.5 0 0 0 0 1H7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1V4.5A2.5 2.5 0 0 1 8.5 2Zm0 1C7.67 3 7 3.67 7 4.5V6h3V4.5C10 3.67 9.33 3 8.5 3Zm3 0c-.3 0-.6.1-.83.25.2.37.33.8.33 1.25V6h2V4.5c0-.83-.67-1.5-1.5-1.5Zm.5 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm.85-4.15a.5.5 0 0 0-.7-.7l-6 6a.5.5 0 0 0 .7.7l6-6Z",
    fill: primaryFill
  }));
};

export const ShoppingBagPercentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPercentRegularIcon, 'ShoppingBagPercentRegular');

const ShoppingBagPlayFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4.5V6H5a1 1 0 0 0-1 1v8a2.93 2.93 0 0 0 .88 2.13A3 3 0 0 0 7 18h3.26a5.48 5.48 0 0 1 .74-7.74V4.5a2.48 2.48 0 0 0-.33-1.24 1.48 1.48 0 0 1 2.21.66c.08.18.12.37.12.58V6h-1v3.6a5.48 5.48 0 0 1 4-.4V7a1 1 0 0 0-1-1h-1V4.5a2.48 2.48 0 0 0-4-2A2.54 2.54 0 0 0 8.5 2a2.42 2.42 0 0 0-1.77.73A2.43 2.43 0 0 0 6 4.5ZM10 6H7V4.5a1.48 1.48 0 0 1 .91-1.38 1.48 1.48 0 0 1 1.97.8c.08.18.12.37.12.58V6Zm4.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.74-6.55c.1 0 .18.03.26.08l2.3 1.51c.07.05.12.1.16.18a.54.54 0 0 1-.03.54.46.46 0 0 1-.13.13l-2.3 1.57a.54.54 0 0 1-.12.06.45.45 0 0 1-.32-.02.57.57 0 0 1-.16-.1.5.5 0 0 1-.14-.36v-3.08a.51.51 0 0 1 .3-.46.44.44 0 0 1 .18-.05Z",
    fill: primaryFill
  }));
};

export const ShoppingBagPlayFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPlayFilledIcon, 'ShoppingBagPlayFilled');

const ShoppingBagPlayRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 6a1 1 0 0 1 1 1v2.2c-.32-.08-.66-.15-1-.18V7h-3v2.6c-.36.18-.7.4-1 .66V7H5v8a1.98 1.98 0 0 0 1.23 1.84c.24.1.5.16.77.16h2.6c.18.36.4.7.66 1H7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1V4.5a2.42 2.42 0 0 1 .73-1.77A2.43 2.43 0 0 1 8.5 2a2.43 2.43 0 0 1 1.5.5 2.44 2.44 0 0 1 2.48-.3 2.53 2.53 0 0 1 1.32 1.33c.13.3.2.63.2.97V6h1Zm-2-1.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 11.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0 1 11 4.5V6h2V4.5ZM7 6h3V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 8.5 3a1.47 1.47 0 0 0-1.06.44A1.48 1.48 0 0 0 7 4.5V6Zm12 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.98-1.97a.45.45 0 0 0-.45-.03.5.5 0 0 0-.15.1.51.51 0 0 0-.14.36v3.08a.5.5 0 0 0 .14.35.45.45 0 0 0 .52.12.54.54 0 0 0 .09-.05l2.3-1.57a.46.46 0 0 0 .16-.18.54.54 0 0 0 0-.49.49.49 0 0 0-.17-.18l-2.3-1.5Z",
    fill: primaryFill
  }));
};

export const ShoppingBagPlayRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagPlayRegularIcon, 'ShoppingBagPlayRegular');

const ShoppingBagTagFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6V4.5a2.42 2.42 0 0 1 .73-1.77A2.43 2.43 0 0 1 8.5 2a2.43 2.43 0 0 1 1.5.5 2.44 2.44 0 0 1 2.48-.3 2.53 2.53 0 0 1 1.32 1.33c.13.3.2.63.2.97V6h1a1 1 0 0 1 1 1v2.6a2.5 2.5 0 0 0-1.62-.6H12V6h1V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 11.5 3c-.3 0-.58.09-.83.26A2.5 2.5 0 0 1 11 4.5v4.55c-1.14.24-2 1.25-2 2.46v2.88c0 .66.26 1.29.72 1.76L11.53 18H7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1Zm4 0V4.5a1.47 1.47 0 0 0-.44-1.06A1.48 1.48 0 0 0 8.5 3a1.47 1.47 0 0 0-1.06.44A1.48 1.48 0 0 0 7 4.5V6h3Zm.43 9.45a1.51 1.51 0 0 1-.43-1.06v-2.88c0-.83.68-1.51 1.51-1.51h2.87c.4 0 .8.16 1.07.45l3.11 3.14c.6.6.58 1.57-.02 2.15l-2.95 2.84a1.5 1.5 0 0 1-2.12-.03l-3.04-3.1Zm1.57-2.7a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z",
    fill: primaryFill
  }));
};

export const ShoppingBagTagFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagTagFilledIcon, 'ShoppingBagTagFilled');

const ShoppingBagTagRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.5a2.5 2.5 0 0 0-4 2V6H5a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h4.53l-.98-1H7a2 2 0 0 1-2-2V7h6v2.05c.16-.03.34-.05.51-.05H12V7h3v2.08c.37.09.7.27 1 .51V7a1 1 0 0 0-1-1h-1V4.5a2.5 2.5 0 0 0-4-2Zm-3 2a1.5 1.5 0 1 1 3 0V6H7V4.5Zm3.67-1.25A1.5 1.5 0 0 1 13 4.5V6h-2V4.5c0-.45-.12-.88-.33-1.25Zm-.24 12.2a1.51 1.51 0 0 1-.43-1.06v-2.88c0-.83.68-1.51 1.51-1.51h2.87c.4 0 .8.16 1.07.45l3.11 3.14c.6.6.58 1.57-.02 2.15l-2.95 2.84a1.5 1.5 0 0 1-2.12-.03l-3.04-3.1Zm1.57-2.7a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z",
    fill: primaryFill
  }));
};

export const ShoppingBagTagRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingBagTagRegularIcon, 'ShoppingBagTagRegular');

const ShortpickFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.5a.5.5 0 0 0 0-1H7V3h.5a.5.5 0 0 0 0-1H7Zm2.5 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h.5v2h-.5a.5.5 0 0 0 0 1h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-.5Zm-3 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm-5 2c.28 0 .5.22.5.5v8c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-8a.5.5 0 0 1 1 0v8a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 4 15.5v-8c0-.28.22-.5.5-.5ZM7 12a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H7ZM6 8a1 1 0 0 1 1-1h.5a.5.5 0 0 1 0 1H7v2h.5a.5.5 0 0 1 0 1H7a1 1 0 0 1-1-1V8Zm3-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3 0c0-.28.22-.5.5-.5h.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.5a.5.5 0 0 1 0-1h.5V8h-.5a.5.5 0 0 1-.5-.5Zm-3 3c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ShortpickFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShortpickFilledIcon, 'ShortpickFilled');

const ShortpickRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.5a.5.5 0 0 0 0-1H7V3h.5a.5.5 0 0 0 0-1H7Zm2.5 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h.5v2h-.5a.5.5 0 0 0 0 1h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-.5Zm-3 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM5 7.5a.5.5 0 0 0-1 0v8A2.5 2.5 0 0 0 6.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-8a.5.5 0 0 0-1 0v8c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5v-8ZM7 12a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H7Zm0 1h6v2H7v-2ZM6 8a1 1 0 0 1 1-1h.5a.5.5 0 0 1 0 1H7v2h.5a.5.5 0 0 1 0 1H7a1 1 0 0 1-1-1V8Zm3-.5c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3 0c0-.28.22-.5.5-.5h.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.5a.5.5 0 0 1 0-1h.5V8h-.5a.5.5 0 0 1-.5-.5Zm-3 3c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ShortpickRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShortpickRegularIcon, 'ShortpickRegular');

const ShowerheadFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m15.48 2.42-1.7 1.7a7.03 7.03 0 0 1 2.06 2.02l1.68-1.68a1.44 1.44 0 1 0-2.04-2.04ZM4.85 11.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 .7.7l2-2Zm2 2a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 .7.7l2-2Zm2 1.3c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0Zm4.86-.8a1.46 1.46 0 0 0-.18-.22L5.87 6.47a1.45 1.45 0 0 0-2.05 2.05l7.66 7.66a1.45 1.45 0 0 0 2.23-1.82ZM6.58 5.78a2.46 2.46 0 0 0-.45-.36 6 6 0 0 1 8.46 8.46c-.1-.16-.22-.3-.35-.44L6.58 5.77Z",
    fill: primaryFill
  }));
};

export const ShowerheadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShowerheadFilledIcon, 'ShowerheadFilled');

const ShowerheadRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.43 2.57a1.94 1.94 0 0 0-2.74 0L12.65 4.6v.01a6 6 0 0 0-6.76 1.02 1.91 1.91 0 0 0-1.74 3.22l7 7a1.91 1.91 0 0 0 3.23-1.74 6 6 0 0 0 1.01-6.76l2.04-2.03c.76-.76.76-2 0-2.75Zm-2.57 3.9a6.05 6.05 0 0 0-1.34-1.33l1.88-1.86a.94.94 0 1 1 1.33 1.33l-1.87 1.87Zm-8.02-.34a5 5 0 0 1 7.03 7.03l-.01-.01-7-7-.02-.02Zm-.72.7 7.05 7.05a.91.91 0 0 1-1.31 1.27l-7-7a.91.91 0 0 1 1.26-1.32Zm.73 6.32c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0Zm-2-1.3a.5.5 0 1 0-.7-.7l-2 2a.5.5 0 1 0 .7.7l2-2Zm4 3.3c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l2-2c.2-.2.5-.2.7 0Z",
    fill: primaryFill
  }));
};

export const ShowerheadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShowerheadRegularIcon, 'ShowerheadRegular');

const SidebarSearchLtrFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-2.59a1.5 1.5 0 0 0-.35-.56l-2-2A4.49 4.49 0 0 0 5.5 8c-.93 0-1.78.28-2.5.76V5.5Zm10 1v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0Zm-4 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 0 1-.7.7L7.6 15.3A3.5 3.5 0 1 1 9 12.5Zm-1 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z",
    fill: primaryFill
  }));
};

export const SidebarSearchLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SidebarSearchLtrFilledIcon, 'SidebarSearchLtrFilled');

const SidebarSearchLtrRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-2.59a1.5 1.5 0 0 0-.35-.56l-.44-.44h3.38c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v2.76c-.36.12-.7.3-1 .5V5.5Zm5.3 9.1a3.5 3.5 0 1 0-.7.7l2.55 2.55a.5.5 0 0 0 .7-.7L8.3 14.6Zm-2.8.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm8-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const SidebarSearchLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SidebarSearchLtrRegularIcon, 'SidebarSearchLtrRegular');

const SidebarSearchRtlFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v7a4.5 4.5 0 1 0-4.5 4.5h-7A2.5 2.5 0 0 1 3 14.5v-9Zm3 1v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0Zm10 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 0 1-.7.7L14.6 15.3a3.5 3.5 0 1 1 1.4-2.8Zm-1 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z",
    fill: primaryFill
  }));
};

export const SidebarSearchRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SidebarSearchRtlFilledIcon, 'SidebarSearchRtlFilled');

const SidebarSearchRtlRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v7c0-1.07-.37-2.06-1-2.83V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h4.17c.77.63 1.76 1 2.83 1h-7A2.5 2.5 0 0 1 3 14.5v-9Zm3 1a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7Zm10 6c0 .79-.26 1.51-.7 2.1l2.55 2.55a.5.5 0 0 1-.7.7L14.6 15.3a3.5 3.5 0 1 1 1.4-2.8Zm-1 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z",
    fill: primaryFill
  }));
};

export const SidebarSearchRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SidebarSearchRtlRegularIcon, 'SidebarSearchRtlRegular');

const SignOutFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 3.5a.5.5 0 0 0-.58-.5l-7 1.08a.5.5 0 0 0-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 0 0 .58-.5V10h5.17l-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.65.76l1 .87H11V3.5Zm-2.5 7.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm4 4.75H12v-5h1v4.5a.5.5 0 0 1-.5.5ZM12 8V4h.5c.28 0 .5.22.5.5V8h-1Z",
    fill: primaryFill
  }));
};

export const SignOutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SignOutFilledIcon, 'SignOutFilled');

const SignOutRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 11.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM11 3.5a.5.5 0 0 0-.58-.5l-7 1.08a.5.5 0 0 0-.42.49v10.86c0 .25.18.46.42.5l7 1.07a.5.5 0 0 0 .58-.5V10h5.17l-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 1 0-.65.76l1 .87H11V3.5Zm-1 .58v11.84L4 15V5l6-.92ZM12.5 16H12v-5h1v4.5a.5.5 0 0 1-.5.5ZM12 8V4h.5c.28 0 .5.22.5.5V8h-1Z",
    fill: primaryFill
  }));
};

export const SignOutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SignOutRegularIcon, 'SignOutRegular');

const SignatureFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.02 2.77a2.44 2.44 0 1 1 3.46 3.46L14.2 7.5l.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-6.65 6.64a.5.5 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65l1.26-3.75a.5.5 0 0 1 .12-.2l8.62-8.62ZM3.27 16.9c-.02 0-.04-.02-.05-.03l1.35-.34c.53.27 1.18.47 1.93.47.5 0 1.01-.18 1.53-.47.53-.3 1.03-.7 1.53-1.1l.13-.11c.44-.36.9-.74 1.34-1 .47-.27 1.04-.49 1.63-.3.82.28 1.08 1.04 1.32 1.84.05.18.15.36.26.49.11.12.2.15.26.15.19 0 .46-.1.8-.3a9.43 9.43 0 0 0 .93-.62 5.6 5.6 0 0 1 1.1-.55h.03l.14.47-.14-.48a.5.5 0 0 1 .28.96 2.74 2.74 0 0 0-.21.08 4.6 4.6 0 0 0-.92.54l-.7.46a2.7 2.7 0 0 1-1.31.44c-.44 0-.78-.23-1-.49a2.33 2.33 0 0 1-.48-.87c-.26-.87-.41-1.08-.68-1.17-.16-.05-.4-.02-.8.22-.37.21-.77.54-1.23.92l-.12.1c-.5.4-1.06.84-1.66 1.19-.6.34-1.29.6-2.03.6a5.49 5.49 0 0 1-3.23-1.1Z",
    fill: primaryFill
  }));
};

export const SignatureFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SignatureFilledIcon, 'SignatureFilled');

const SignatureRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.02 2.77a2.44 2.44 0 1 1 3.46 3.46L14.2 7.5l.08.09a2 2 0 0 1 0 2.82l-1.44 1.44a.5.5 0 0 1-.7-.7l1.44-1.44a1 1 0 0 0 0-1.42l-.09-.08-6.65 6.64a.5.5 0 0 1-.23.14l-4 1a.5.5 0 0 1-.6-.65l1.26-3.75a.5.5 0 0 1 .12-.2l8.62-8.62Zm2.75.7a1.44 1.44 0 0 0-2.04 0l-8.54 8.55-.93 2.77 2.98-.74 8.53-8.53c.57-.56.57-1.48 0-2.04ZM3.22 16.88l.05.03C4 17.44 5.1 18 6.5 18c.74 0 1.42-.26 2.03-.6.6-.35 1.16-.8 1.66-1.2l.12-.1c.46-.37.86-.7 1.23-.91.4-.24.64-.27.8-.22.27.1.42.3.68 1.17.09.3.24.61.47.87.23.26.57.49 1.01.49.47 0 .94-.23 1.3-.44a12.61 12.61 0 0 0 .97-.64 4.6 4.6 0 0 1 .82-.42l.04-.02h.01a.5.5 0 0 0-.28-.96h-.01l-.02.01a2.35 2.35 0 0 0-.31.12c-.2.09-.47.22-.8.43l-.33.23c-.19.13-.38.26-.6.39-.33.2-.6.3-.79.3-.06 0-.15-.03-.26-.15-.11-.13-.2-.31-.26-.5-.24-.8-.5-1.55-1.32-1.82-.59-.2-1.16.02-1.63.3-.44.25-.9.63-1.34.99l-.13.1c-.5.41-1 .8-1.53 1.1-.52.3-1.02.48-1.53.48-.75 0-1.4-.2-1.93-.47l-1.35.34ZM17.5 15.5l-.14-.48.14.48Z",
    fill: primaryFill
  }));
};

export const SignatureRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SignatureRegularIcon, 'SignatureRegular');

const SimFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5a3 3 0 0 1 3-3h3.46a3 3 0 0 1 2.13.88l2.53 2.53A3 3 0 0 1 16 7.54V15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm3 5.5v.5h3V9H8.5C7.67 9 7 9.67 7 10.5ZM7 12v1.5c0 .83.67 1.5 1.5 1.5H10v-3H7Zm4.5 3c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5H11v6h.5Z",
    fill: primaryFill
  }));
};

export const SimFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SimFilledIcon, 'SimFilled');

const SimRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 9h3c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 7 13.5v-3C7 9.67 7.67 9 8.5 9ZM8 10.5v.5h2v-1H8.5a.5.5 0 0 0-.5.5ZM8 12v1.5c0 .28.22.5.5.5H10v-2H8Zm3.5 2a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H11v4h.5ZM7 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V7.54a3 3 0 0 0-.88-2.13L12.6 2.88A3 3 0 0 0 10.46 2H7ZM5 5c0-1.1.9-2 2-2h3.46a2 2 0 0 1 1.42.59l2.53 2.53A2 2 0 0 1 15 7.54V15a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5Z",
    fill: primaryFill
  }));
};

export const SimRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SimRegularIcon, 'SimRegular');

const SkipBack10FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.63V3.75a.75.75 0 0 0-1.5 0v3.5c0 .41.34.75.75.75h4a.75.75 0 0 0 0-1.5H5.23A6.3 6.3 0 0 1 10 4.25c2.4 0 4.53 1.41 5.65 3.54.15.28.43.46.73.46.54 0 .91-.53.67-1.01A7.93 7.93 0 0 0 10 2.75a7.77 7.77 0 0 0-6 2.88Zm4.25 5.12a.75.75 0 0 0-1.24-.57l-1.75 1.5a.75.75 0 1 0 .98 1.14l.51-.44v3.87a.75.75 0 0 0 1.5 0v-5.5ZM15 13.5c0 1.93-.63 3.5-2.5 3.5-1.88 0-2.5-1.57-2.5-3.5s.63-3.5 2.5-3.5c1.88 0 2.5 1.57 2.5 3.5Zm-1.5 0c0-.85-.15-1.4-.32-1.69a.59.59 0 0 0-.22-.22.94.94 0 0 0-.46-.09.94.94 0 0 0-.46.09.59.59 0 0 0-.22.22c-.17.3-.32.84-.32 1.69s.15 1.4.32 1.69c.08.12.15.18.22.22.07.04.2.09.46.09s.39-.05.46-.09c.07-.04.14-.1.22-.22.17-.3.32-.84.32-1.69Z",
    fill: primaryFill
  }));
};

export const SkipBack10Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipBack10FilledIcon, 'SkipBack10Filled');

const SkipBack10RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.5a.5.5 0 1 1 1 0v2.2a8 8 0 0 1 13.16 1.75.5.5 0 1 1-.9.44 7 7 0 0 0-12-.89H7.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4Zm5 7a.5.5 0 0 0-.78-.42l-1.5 1a.5.5 0 0 0 .56.84l.72-.49v5.07a.5.5 0 0 0 1 0v-6Zm4.5-.5c-.93 0-1.6.44-2 1.13-.37.65-.5 1.5-.5 2.37 0 .86.13 1.72.5 2.37.4.7 1.07 1.13 2 1.13.94 0 1.6-.44 2-1.13.38-.65.5-1.5.5-2.37 0-.86-.12-1.72-.5-2.37a2.18 2.18 0 0 0-2-1.13ZM11 13.5c0-.8.13-1.44.37-1.87.23-.4.57-.63 1.13-.63.57 0 .9.23 1.13.63.25.43.37 1.08.37 1.87 0 .8-.12 1.44-.37 1.87-.22.4-.56.63-1.13.63-.56 0-.9-.23-1.13-.63A3.87 3.87 0 0 1 11 13.5Z",
    fill: primaryFill
  }));
};

export const SkipBack10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipBack10RegularIcon, 'SkipBack10Regular');

const SkipForward10FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.73 5.63V3.75a.75.75 0 0 1 1.5 0v3.5c0 .41-.33.75-.75.75h-4a.75.75 0 0 1 0-1.5h2.03a6.3 6.3 0 0 0-4.78-2.25 6.45 6.45 0 0 0-5.65 3.54.83.83 0 0 1-.73.46c-.54 0-.91-.53-.67-1.01a7.93 7.93 0 0 1 7.05-4.49c2.4 0 4.54 1.12 6 2.88ZM12.5 17c1.88 0 2.5-1.57 2.5-3.5s-.62-3.5-2.5-3.5c-1.87 0-2.5 1.57-2.5 3.5s.63 3.5 2.5 3.5Zm.68-1.81a.59.59 0 0 1-.22.22.94.94 0 0 1-.46.09.94.94 0 0 1-.46-.09.59.59 0 0 1-.21-.22 3.38 3.38 0 0 1-.33-1.69c0-.85.15-1.4.32-1.69a.59.59 0 0 1 .22-.22c.07-.04.2-.09.46-.09s.4.05.46.09c.07.04.14.1.22.22.18.3.32.84.32 1.69s-.14 1.4-.32 1.69Zm-4.93-4.44a.75.75 0 0 0-1.24-.57l-1.75 1.5a.75.75 0 1 0 .98 1.14l.51-.44v3.87a.75.75 0 0 0 1.5 0v-5.5Z",
    fill: primaryFill
  }));
};

export const SkipForward10Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForward10FilledIcon, 'SkipForward10Filled');

const SkipForward10RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 3.5a.5.5 0 1 0-1 0v2.2A8 8 0 0 0 2.84 7.45a.5.5 0 1 0 .9.44 7 7 0 0 1 12-.89H12.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .5-.5v-4Zm-6.5 7.63c.4-.7 1.07-1.13 2-1.13.94 0 1.6.44 2 1.13.37.65.5 1.5.5 2.37 0 .86-.13 1.72-.5 2.37-.4.7-1.06 1.13-2 1.13-.93 0-1.6-.44-2-1.13-.37-.65-.5-1.5-.5-2.37 0-.86.13-1.72.5-2.37Zm.87.5A3.87 3.87 0 0 0 11 13.5c0 .8.12 1.44.37 1.87.23.4.57.63 1.13.63.57 0 .9-.23 1.13-.63.25-.43.37-1.08.37-1.87 0-.8-.12-1.44-.37-1.87-.23-.4-.56-.63-1.13-.63-.56 0-.9.23-1.13.63ZM8 10.5a.5.5 0 0 0-.78-.42l-1.5 1a.5.5 0 1 0 .56.84l.72-.49v5.07a.5.5 0 0 0 1 0v-6Z",
    fill: primaryFill
  }));
};

export const SkipForward10Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForward10RegularIcon, 'SkipForward10Regular');

const SkipForward30FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.73 5.63V3.75a.75.75 0 0 1 1.5 0v3.5c0 .41-.33.75-.75.75h-4a.75.75 0 0 1 0-1.5h2.03a6.3 6.3 0 0 0-4.78-2.25 6.45 6.45 0 0 0-5.65 3.54.83.83 0 0 1-.73.46c-.54 0-.91-.53-.67-1.01a7.93 7.93 0 0 1 7.05-4.49c2.4 0 4.54 1.12 6 2.88ZM4.97 10.72a.75.75 0 0 0 1.06 1.07v-.01l.07-.06a2.3 2.3 0 0 1 1.4-.47c.56 0 .88.15 1.04.3.16.13.22.29.22.43-.01.24-.26.77-1.26.77a.75.75 0 0 0 0 1.5c1 0 1.25.53 1.26.77 0 .14-.06.3-.22.44s-.48.29-1.04.29a2.3 2.3 0 0 1-1.46-.53h-.01a.75.75 0 0 0-1.06 1.06c-.28-.28 0 0 0 0h.01l.01.02a2.03 2.03 0 0 0 .19.16 3.8 3.8 0 0 0 2.33.8c.81-.01 1.5-.24 2-.66a2.05 2.05 0 0 0 .08-3.1 2.05 2.05 0 0 0-.07-3.1 3.05 3.05 0 0 0-2.02-.65 3.8 3.8 0 0 0-2.5.95l-.02.01ZM16 13.5c0 2.07-.62 3.75-2.5 3.75-1.87 0-2.5-1.68-2.5-3.75 0-2.07.63-3.75 2.5-3.75 1.88 0 2.5 1.68 2.5 3.75Zm-1.5 0c0-.93-.15-1.56-.35-1.9a.67.67 0 0 0-.23-.26.8.8 0 0 0-.42-.09.8.8 0 0 0-.42.09.67.67 0 0 0-.23.26c-.2.34-.35.97-.35 1.9 0 .93.15 1.56.35 1.9.09.16.17.23.23.26a.8.8 0 0 0 .42.09.8.8 0 0 0 .42-.09c.07-.03.15-.1.23-.26.2-.34.35-.97.35-1.9Z",
    fill: primaryFill
  }));
};

export const SkipForward30Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForward30FilledIcon, 'SkipForward30Filled');

const SkipForward30RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 3c.28 0 .5.22.5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 1 1 0-1h3.25a7 7 0 0 0-12.01.89.5.5 0 1 1-.9-.44A8 8 0 0 1 16 5.7V3.5c0-.28.22-.5.5-.5Zm-3 7c-.93 0-1.6.44-2 1.13-.37.65-.5 1.5-.5 2.37 0 .86.13 1.72.5 2.37.4.7 1.07 1.13 2 1.13.94 0 1.6-.44 2-1.13.37-.65.5-1.5.5-2.37 0-.86-.13-1.72-.5-2.37a2.18 2.18 0 0 0-2-1.13ZM12 13.5c0-.8.12-1.44.37-1.87.23-.4.57-.63 1.13-.63.57 0 .9.23 1.13.63.25.43.37 1.08.37 1.87 0 .8-.12 1.44-.37 1.87-.23.4-.56.63-1.13.63-.56 0-.9-.23-1.13-.63A3.87 3.87 0 0 1 12 13.5Zm-6.85-1.9c.19.2.5.2.7 0h.02l.07-.07A2.56 2.56 0 0 1 7.5 11c.6 0 .98.16 1.2.35.22.19.31.42.3.64 0 .4-.4 1.01-1.5 1.01a.5.5 0 0 0 0 1c1.1 0 1.5.6 1.5 1.01a.8.8 0 0 1-.3.64c-.22.19-.6.35-1.2.35a2.56 2.56 0 0 1-1.65-.6.5.5 0 0 0-.7 0c-.34.33 0 .7 0 .7a3.37 3.37 0 0 0 .18.16A3.56 3.56 0 0 0 7.5 17c.78 0 1.4-.21 1.85-.59.44-.37.67-.9.65-1.42a1.89 1.89 0 0 0-.8-1.49c.5-.37.79-.9.8-1.49a1.8 1.8 0 0 0-.65-1.42A2.8 2.8 0 0 0 7.5 10a3.56 3.56 0 0 0-2.34.88v.01h-.01a.5.5 0 0 0 0 .71Zm.7 3.8Z",
    fill: primaryFill
  }));
};

export const SkipForward30Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForward30RegularIcon, 'SkipForward30Regular');

const SkipForwardTabFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.09 7.97C4.2 6.57 6.07 4.89 8.35 4.4c1.9-.42 4.25-.04 6.86 2.35H12.5a.75.75 0 1 0 0 1.5H17c.41 0 .75-.34.75-.75v-4a.75.75 0 0 0-1.5 0v2.17c-2.92-2.68-5.75-3.28-8.22-2.74-2.76.6-4.9 2.58-6.12 4.1a.75.75 0 0 0 1.18.94Zm3.41 2.78c-.97 0-1.75.78-1.75 1.75v3c0 .97.78 1.75 1.75 1.75h7c.97 0 1.75-.78 1.75-1.75v-3c0-.97-.78-1.75-1.75-1.75h-7Zm-.25 1.75c0-.14.11-.25.25-.25h7c.14 0 .25.11.25.25v3c0 .14-.11.25-.25.25h-7a.25.25 0 0 1-.25-.25v-3Z",
    fill: primaryFill
  }));
};

export const SkipForwardTabFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForwardTabFilledIcon, 'SkipForwardTabFilled');

const SkipForwardTabRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.9 7.81C4.01 6.4 5.92 4.66 8.3 4.15c2.1-.46 4.7.03 7.54 2.85H12.5a.5.5 0 0 0 0 1H17a.5.5 0 0 0 .5-.5v-4a.5.5 0 1 0-1 0v2.75c-3.03-2.97-5.92-3.62-8.42-3.08C5.4 3.76 3.31 5.7 2.11 7.2a.5.5 0 0 0 .78.62ZM6.5 11c-.83 0-1.5.67-1.5 1.5v3c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-7ZM6 12.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-3Z",
    fill: primaryFill
  }));
};

export const SkipForwardTabRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkipForwardTabRegularIcon, 'SkipForwardTabRegular');

const SlashForwardFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.02 2.05c.38.15.58.58.43.97l-5.5 14.5a.75.75 0 1 1-1.4-.54l5.5-14.5a.75.75 0 0 1 .97-.43Z",
    fill: primaryFill
  }));
};

export const SlashForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlashForwardFilledIcon, 'SlashForwardFilled');

const SlashForwardRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.66 2.03c.26.08.4.37.31.63l-5 15a.5.5 0 1 1-.94-.32l5-15a.5.5 0 0 1 .63-.31Z",
    fill: primaryFill
  }));
};

export const SlashForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlashForwardRegularIcon, 'SlashForwardRegular');

const SleepFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.16 2.74a.5.5 0 0 1 .43-.13c3.5.6 6.4 3.67 6.4 7.4a7.5 7.5 0 0 1-7.5 7.5 7.96 7.96 0 0 1-6.4-3.22.5.5 0 0 1 .37-.79 6.94 6.94 0 0 0 4.69-2.59c1.34-1.65 2.24-4.17 1.85-7.75a.5.5 0 0 1 .16-.42ZM3.5 10C4.33 10 5 9.33 5 8.5V4.9l3-.76V6.1A1.5 1.5 0 1 0 9 7.5v-4a.5.5 0 0 0-.62-.48l-4 1A.5.5 0 0 0 4 4.5v2.59A1.5 1.5 0 1 0 3.5 10Z",
    fill: primaryFill
  }));
};

export const SleepFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SleepFilledIcon, 'SleepFilled');

const SleepRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.59 2.61a.5.5 0 0 0-.59.55c.4 3.58-.5 6.1-1.85 7.75a6.94 6.94 0 0 1-4.69 2.6.5.5 0 0 0-.37.78 7.96 7.96 0 0 0 6.4 3.21A7.5 7.5 0 0 0 18 10c0-3.72-2.9-6.78-6.4-7.39Zm-1.66 8.93c1.43-1.77 2.36-4.34 2.13-7.8A6.65 6.65 0 0 1 17 10a6.5 6.5 0 0 1-6.5 6.5 7.1 7.1 0 0 1-5.06-2.14 8.1 8.1 0 0 0 4.49-2.82ZM3.5 10C4.33 10 5 9.33 5 8.5V4.89l3-.75v1.94A1.5 1.5 0 1 0 9 7.5v-4a.5.5 0 0 0-.62-.49l-4 1A.5.5 0 0 0 4 4.5v2.58A1.5 1.5 0 1 0 3.5 10Z",
    fill: primaryFill
  }));
};

export const SleepRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SleepRegularIcon, 'SleepRegular');

const SlideAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.5A5.5 5.5 0 0 0 9.2 16H4.76A2.75 2.75 0 0 1 2 13.26v-6.5Zm17 7.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const SlideAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideAddFilledIcon, 'SlideAddFilled');

const SlideAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.5a5.5 5.5 0 0 0-1-.65V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h4.27c.03.34.1.68.19 1H4.75A2.75 2.75 0 0 1 2 13.25v-6.5Zm17 7.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const SlideAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideAddRegularIcon, 'SlideAddRegular');

const SlideArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v3.76a5.48 5.48 0 0 0-5.8-.76H5.5a.5.5 0 0 0 0 1h5.23c-.46.43-.84.94-1.13 1.5H5.5a.5.5 0 0 0 0 1h3.7a5.5 5.5 0 0 0 0 3H4.5A2.5 2.5 0 0 1 2 13.5v-7Zm3.5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const SlideArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideArrowRightFilledIcon, 'SlideArrowRightFilled');

const SlideArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm0 2.5a.5.5 0 0 0 0 1h5.23c.43-.4.93-.75 1.48-1H5.5Zm0 2.5h4.1c-.16.32-.3.65-.4 1H5.5a.5.5 0 0 1 0-1Zm-1 3h4.52c.03.34.1.68.19 1H4.5A2.5 2.5 0 0 1 2 13.5v-7A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v3.76a5.5 5.5 0 0 0-1-.66V6.5c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5Zm14.5-.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const SlideArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideArrowRightRegularIcon, 'SlideArrowRightRegular');

const SlideEraserFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v5.07l-.4-.41a2.25 2.25 0 0 0-3.2 0l-3.74 3.75A2.24 2.24 0 0 0 10 16H4a2 2 0 0 1-2-2V6Zm13.12 5.37a1.25 1.25 0 0 1 1.76 0l1.75 1.75c.5.48.5 1.28 0 1.76l-2.57 2.58-3.52-3.52 2.58-2.57Zm-3.18 3.17-.57.58a1.25 1.25 0 0 0 0 1.76l1.75 1.75c.48.5 1.28.5 1.76 0l.58-.57-3.52-3.52Z",
    fill: primaryFill
  }));
};

export const SlideEraserFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideEraserFilledIcon, 'SlideEraserFilled');

const SlideEraserRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h6c0-.34.08-.69.23-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4.23c.21.11.41.25.6.43l.4.41V6a2 2 0 0 0-2-2H4Zm11.12 7.37a1.25 1.25 0 0 1 1.76 0l1.75 1.75c.5.48.5 1.28 0 1.76l-2.57 2.58-3.52-3.52 2.58-2.57Zm-3.18 3.17-.57.58a1.25 1.25 0 0 0 0 1.76l1.75 1.75c.48.5 1.28.5 1.76 0l.58-.57-3.52-3.52Z",
    fill: primaryFill
  }));
};

export const SlideEraserRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideEraserRegularIcon, 'SlideEraserRegular');

const SlideGridFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7Zm1 3.5a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1H5ZM10.5 7a1 1 0 0 1 1-1H15a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1V7Zm1 3.5a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1H15a1 1 0 0 0 1-1v-1.5a1 1 0 0 0-1-1h-3.5ZM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Z",
    fill: primaryFill
  }));
};

export const SlideGridFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideGridFilledIcon, 'SlideGridFilled');

const SlideGridRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 6a1 1 0 0 0-1 1v1.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5Zm3.5 1v1.5H5V7h3.5ZM4 11.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1.5Zm1 0V13h3.5v-1.5H5ZM11.5 6H15a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1ZM15 7h-3.5v1.5H15V7Zm-4.5 4.5a1 1 0 0 1 1-1H15a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1v-1.5Zm1 0V13H15v-1.5h-3.5ZM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Z",
    fill: primaryFill
  }));
};

export const SlideGridRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideGridRegularIcon, 'SlideGridRegular');

const SlideHideFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2V8a3 3 0 0 1 3-3h8a2 2 0 0 0-2-2H6Zm0 5a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H7a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0V8Zm3.5-2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h.5a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V8a2 2 0 0 0-2-2h-.5ZM6 10.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Zm12 0a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Zm-12 4a.5.5 0 0 0-1 0v.5c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H7a1 1 0 0 1-1-1v-.5Zm12 0a.5.5 0 0 0-1 0v.5a1 1 0 0 1-1 1h-.5a.5.5 0 0 0 0 1h.5a2 2 0 0 0 2-2v-.5ZM9.5 16a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
    fill: primaryFill
  }));
};

export const SlideHideFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideHideFilledIcon, 'SlideHideFilled');

const SlideHideRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2v-1a1 1 0 0 1-1-1V7a3 3 0 0 1 3-3h7a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2H6Zm0 5a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H7a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0V8Zm3.5-2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h.5a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V8a2 2 0 0 0-2-2h-.5ZM6 10.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Zm12 0a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Zm-12 4a.5.5 0 0 0-1 0v.5c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H7a1 1 0 0 1-1-1v-.5Zm12 0a.5.5 0 0 0-1 0v.5a1 1 0 0 1-1 1h-.5a.5.5 0 0 0 0 1h.5a2 2 0 0 0 2-2v-.5ZM9.5 16a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
    fill: primaryFill
  }));
};

export const SlideHideRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideHideRegularIcon, 'SlideHideRegular');

const SlideLayoutFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7h9c.28 0 .5.22.5.5V9H5V7.5c0-.28.22-.5.5-.5ZM7 10v3H5.5a.5.5 0 0 1-.5-.5V10h2Zm7.5 3H8v-3h7v2.5a.5.5 0 0 1-.5.5Zm-10-9A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11Zm10 10h-9A1.5 1.5 0 0 1 4 12.5v-5C4 6.67 4.67 6 5.5 6h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5Z",
    fill: primaryFill
  }));
};

export const SlideLayoutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideLayoutFilledIcon, 'SlideLayoutFilled');

const SlideLayoutRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 14A1.5 1.5 0 0 1 4 12.5v-5C4 6.67 4.67 6 5.5 6h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-9Zm0-7a.5.5 0 0 0-.5.5V9h10V7.5a.5.5 0 0 0-.5-.5h-9ZM7 10H5v2.5c0 .28.22.5.5.5H7v-3Zm1 3h6.5a.5.5 0 0 0 .5-.5V10H8v3ZM2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5v-7ZM4.5 5C3.67 5 3 5.67 3 6.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11Z",
    fill: primaryFill
  }));
};

export const SlideLayoutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideLayoutRegularIcon, 'SlideLayoutRegular');

const SlideLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4.84a3.49 3.49 0 0 0-1.5-.34h-4A3.5 3.5 0 0 0 9.63 16H4a2 2 0 0 1-2-2V6Zm10.5 5.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16ZM12 14c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const SlideLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideLinkFilledIcon, 'SlideLinkFilled');

const SlideLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4.84a3.47 3.47 0 0 0-1-.3V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.14c.11.36.28.7.49 1H4a2 2 0 0 1-2-2V6Zm10.5 5.5a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16ZM12 14c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const SlideLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideLinkRegularIcon, 'SlideLinkRegular');

const SlideMicrophoneFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v5.47a3 3 0 0 0-6 .03v1.07a1.5 1.5 0 0 0-1.95 1.64c.06.45.19.89.37 1.29H4.5A2.5 2.5 0 0 1 2 13.5v-7Zm3.5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM5 10c0 .28.22.5.5.5H11a.5.5 0 0 0 0-1H5.5a.5.5 0 0 0-.5.5Zm.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.5 0a2 2 0 1 1 4 0v2a2 2 0 0 1-4 0v-2Zm-.97 2.43a.5.5 0 1 0-.99.14 4 4 0 0 0 3.46 3.4v.53a.5.5 0 1 0 1 0v-.53a4 4 0 0 0 3.46-3.4.5.5 0 1 0-1-.14 3 3 0 0 1-5.93 0Z",
    fill: primaryFill
  }));
};

export const SlideMicrophoneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMicrophoneFilledIcon, 'SlideMicrophoneFilled');

const SlideMicrophoneRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm0 2.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm-.5 3c0-.28.22-.5.5-.5H10a.5.5 0 0 1 0 1H5.5a.5.5 0 0 1-.5-.5ZM4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h5.92a4.97 4.97 0 0 1-.32-1H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v3.26a3 3 0 0 1 1 2.2V6.5A2.5 2.5 0 0 0 15.5 4h-11Zm8.5 8a2 2 0 1 1 4 0v2a2 2 0 0 1-4 0v-2Zm-.97 2.43a.5.5 0 1 0-.99.14 4 4 0 0 0 3.46 3.4v.53a.5.5 0 1 0 1 0v-.53a4 4 0 0 0 3.46-3.4.5.5 0 1 0-1-.14 3 3 0 0 1-5.93 0Z",
    fill: primaryFill
  }));
};

export const SlideMicrophoneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMicrophoneRegularIcon, 'SlideMicrophoneRegular');

const SlideMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2V8a3 3 0 0 1 3-3h8a2 2 0 0 0-2-2H6Zm1 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h9a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H7Z",
    fill: primaryFill
  }));
};

export const SlideMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleFilledIcon, 'SlideMultipleFilled');

const SlideMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2v-1a1 1 0 0 1-1-1V7a3 3 0 0 1 3-3h7a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2H6Zm1 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h9a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H7ZM6 8a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8Z",
    fill: primaryFill
  }));
};

export const SlideMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleRegularIcon, 'SlideMultipleRegular');

const SlideMultipleArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2V8a3 3 0 0 1 3-3h8a2 2 0 0 0-2-2H6Zm1 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.6a5.5 5.5 0 0 1 8.4-6.74V8a2 2 0 0 0-2-2H7Zm7.5 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const SlideMultipleArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleArrowRightFilledIcon, 'SlideMultipleArrowRightFilled');

const SlideMultipleArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a4 4 0 0 0-4 4v5c0 1.1.9 2 2 2v-1a1 1 0 0 1-1-1V7a3 3 0 0 1 3-3h7a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2H6Zm1 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h2.6c-.16-.32-.3-.65-.4-1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v1.6c.36.18.7.4 1 .66V8a2 2 0 0 0-2-2H7Zm7.5 4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const SlideMultipleArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleArrowRightRegularIcon, 'SlideMultipleArrowRightRegular');

const SlideMultipleSearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a4 4 0 0 0-4 4v2.76c.58-.4 1.27-.65 2-.73V8a3 3 0 0 1 3-3h8a2 2 0 0 0-2-2H6Zm10 14h-5.88l-1.56-1.56A4.5 4.5 0 0 0 5 9.03V8c0-1.1.9-2 2-2h9a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2ZM4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const SlideMultipleSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleSearchFilledIcon, 'SlideMultipleSearchFilled');

const SlideMultipleSearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a4 4 0 0 0-4 4v2.76c.3-.2.64-.38 1-.5V7a3 3 0 0 1 3-3h7a1 1 0 0 1 1 1h1a2 2 0 0 0-2-2H6Zm10 14h-5.88l-1-1H16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1.26a4.47 4.47 0 0 0-1-.23V8c0-1.1.9-2 2-2h9a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2ZM4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const SlideMultipleSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideMultipleSearchRegularIcon, 'SlideMultipleSearchRegular');

const SlideSearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-5.38l-1.56-1.56c.21-.44.36-.93.41-1.44h3.53a.5.5 0 0 0 0-1H8.97a4.47 4.47 0 0 0-.44-1.5h5.97a.5.5 0 0 0 0-1H7.85A4.49 4.49 0 0 0 2 8.76V6.5Zm3.5.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm-1 9c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 14.6A3.5 3.5 0 1 0 4.5 16Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const SlideSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSearchFilledIcon, 'SlideSearchFilled');

const SlideSearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm3.03 3.5a4.5 4.5 0 0 0-.68-1h6.65a.5.5 0 0 1 0 1H8.53Zm.47 2c0 .17 0 .34-.03.5h3.53a.5.5 0 0 0 0-1H8.97c.02.16.03.33.03.5Zm-6-6v1.76c-.36.12-.7.3-1 .5V6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-5.38l-1-1h6.38c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11C3.67 5 3 5.67 3 6.5ZM4.5 16c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L7.3 14.6A3.5 3.5 0 1 0 4.5 16Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const SlideSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSearchRegularIcon, 'SlideSearchRegular');

const SlideSettingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h4.46A5.5 5.5 0 0 1 18 10.26V6.75A2.75 2.75 0 0 0 15.25 4H4.75Zm7.32 7.44a2 2 0 0 1-1.44 2.48l-.46.12a4.73 4.73 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const SlideSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSettingsFilledIcon, 'SlideSettingsFilled');

const SlideSettingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v3.5a5.5 5.5 0 0 0-1-.65V6.75C17 5.78 16.22 5 15.25 5H4.75C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h4.27c.03.34.1.68.19 1H4.75A2.75 2.75 0 0 1 2 13.25v-6.5Zm10.07 4.7a2 2 0 0 1-1.44 2.47l-.46.12a4.73 4.73 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.05a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const SlideSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSettingsRegularIcon, 'SlideSettingsRegular');

const SlideSizeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25v-6.5Zm9-.25c0 .28.22.5.5.5h.8l-1.65 1.65a.5.5 0 0 0 .7.7L13 7.71v.79a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm-1.65 4.15a.5.5 0 0 0-.7 0L7 12.29v-.79a.5.5 0 0 0-1 0v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1h-.8l1.65-1.65a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const SlideSizeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSizeFilledIcon, 'SlideSizeFilled');

const SlideSizeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25v-6.5ZM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5H4.75ZM11 6.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-.8l-1.65 1.65a.5.5 0 0 1-.7-.7L12.29 7h-.79a.5.5 0 0 1-.5-.5Zm-2.35 4.15a.5.5 0 0 1 .7.7L7.71 13h.79a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 1 0v.8l1.65-1.65Z",
    fill: primaryFill
  }));
};

export const SlideSizeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideSizeRegularIcon, 'SlideSizeRegular');

const SlideTextFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.5A2.5 2.5 0 0 1 4.5 4h11A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5v-7Zm3.5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM5 10c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5Zm.5 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
    fill: primaryFill
  }));
};

export const SlideTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTextFilledIcon, 'SlideTextFilled');

const SlideTextRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm0 2.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Zm-.5 3c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11ZM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5v-7Z",
    fill: primaryFill
  }));
};

export const SlideTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTextRegularIcon, 'SlideTextRegular');

const SlideTextMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 15a2.5 2.5 0 0 0 2.5-2.5v-7c0-.1 0-.19-.02-.28A2.5 2.5 0 0 0 13.5 3h-9A2.5 2.5 0 0 0 2 5.5v7A2.51 2.51 0 0 0 4.48 15h9.02Zm-8-9h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1Zm0 2.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Zm-.5 3c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM6.5 17a2.5 2.5 0 0 1-2-1h9a3.5 3.5 0 0 0 3.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 0 1-4.5 4.5h-7Z",
    fill: primaryFill
  }));
};

export const SlideTextMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTextMultipleFilledIcon, 'SlideTextMultipleFilled');

const SlideTextMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 6a.5.5 0 1 0 0 1h4a.5.5 0 0 0 0-1h-4ZM5 9c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 9Zm.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM16 5.5A2.5 2.5 0 0 0 13.5 3h-9A2.5 2.5 0 0 0 2 5.5v7A2.5 2.5 0 0 0 4.5 15h9a2.5 2.5 0 0 0 2.5-2.5v-7Zm-13 7v-7C3 4.67 3.67 4 4.5 4h9c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 3 12.5ZM6.5 17a2.5 2.5 0 0 1-2-1h9a3.5 3.5 0 0 0 3.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 0 1-4.5 4.5h-7Z",
    fill: primaryFill
  }));
};

export const SlideTextMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTextMultipleRegularIcon, 'SlideTextMultipleRegular');

const SlideTextPersonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h6.54a2.5 2.5 0 0 1 2.23-2.99 2.99 2.99 0 0 1-.73-2.51H5.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .33.13A3 3 0 0 1 18 9.34V6.5A2.5 2.5 0 0 0 15.5 4h-11ZM5 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm0 5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM17.5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 16.75 12 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const SlideTextPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTextPersonFilledIcon, 'SlideTextPersonFilled');

const SlideTextPersonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 7.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM5 10c0-.28.22-.5.5-.5h7a.5.5 0 0 1 .33.13c-.14.27-.24.56-.29.87H5.5A.5.5 0 0 1 5 10Zm6.05 5H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v1.9c.4.23.74.56 1 .94V6.5A2.5 2.5 0 0 0 15.5 4h-11A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h6.54a3.3 3.3 0 0 1 .01-1ZM5.5 12a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm12-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 16.75 12 15.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const SlideTextPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTextPersonRegularIcon, 'SlideTextPersonRegular');

const SlideTransitionFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25v-6.5ZM6 5H5v10h1V5Zm3 0H8v10h1V5Zm3 0v10h1V5h-1Z",
    fill: primaryFill
  }));
};

export const SlideTransitionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTransitionFilledIcon, 'SlideTransitionFilled');

const SlideTransitionRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4H4.75ZM12 5v10H9V5h3Zm1 10V5h2.25c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H13Zm-5 0H6V5h2v10ZM5 5v10h-.25C3.78 15 3 14.22 3 13.25v-6.5C3 5.78 3.78 5 4.75 5H5Z",
    fill: primaryFill
  }));
};

export const SlideTransitionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SlideTransitionRegularIcon, 'SlideTransitionRegular');

const SmartwatchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 2a2 2 0 0 0-2 2v.17A3 3 0 0 1 7 4h6a3 3 0 0 1 1 .17V4a2 2 0 0 0-2-2H8ZM7 5a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1V7a2 2 0 0 0-2-2H7Zm0 11a3 3 0 0 1-1-.17V16c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-.17a3 3 0 0 1-1 .17H7Z",
    fill: primaryFill
  }));
};

export const SmartwatchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SmartwatchFilledIcon, 'SmartwatchFilled');

const SmartwatchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5.27V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v1.27c.6.34 1 .99 1 1.73v1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1v2a2 2 0 0 1-1 1.73V16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1.27A2 2 0 0 1 5 13V7a2 2 0 0 1 1-1.73ZM8 3a1 1 0 0 0-1 1v1h6V4a1 1 0 0 0-1-1H8Zm6 10V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1Zm-7 3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1H7v1Z",
    fill: primaryFill
  }));
};

export const SmartwatchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SmartwatchRegularIcon, 'SmartwatchRegular');

const SmartwatchDotFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 2.68A2 2 0 0 0 12 2H8a2 2 0 0 0-2 2v.17A3 3 0 0 1 7 4h6.04c.06-.48.23-.92.47-1.32ZM13.05 5H7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2v-2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.34A3.5 3.5 0 0 1 13.04 5ZM7 16a3 3 0 0 1-1-.17V16c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-.17a3 3 0 0 1-1 .17H7ZM19 4.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z",
    fill: primaryFill
  }));
};

export const SmartwatchDotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SmartwatchDotFilledIcon, 'SmartwatchDotFilled');

const SmartwatchDotRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm-3 .68A2 2 0 0 0 12 2H8a2 2 0 0 0-2 2v1.27A2 2 0 0 0 5 7v6a2 2 0 0 0 1 1.73V16c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-1.27A2 2 0 0 0 15 13v-2a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.34a3.5 3.5 0 0 1-1-.71A1 1 0 0 1 14 7v6a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6a1 1 0 0 1 .37.07 3.49 3.49 0 0 1 .14-3.39ZM13 4.5V5H7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v.5ZM7 15h6v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1Z",
    fill: primaryFill
  }));
};

export const SmartwatchDotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SmartwatchDotRegularIcon, 'SmartwatchDotRegular');

const SnoozeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 4a.75.75 0 0 0 0 1.5h3.88l-4.45 5.27a.75.75 0 0 0 .57 1.23h5.5a.75.75 0 0 0 0-1.5h-3.88l4.45-5.27A.75.75 0 0 0 16.25 4h-5.5Zm-7 6a.75.75 0 0 0 0 1.5h1.97l-2.56 3.29A.75.75 0 0 0 3.75 16h3.5a.75.75 0 0 0 0-1.5H5.28l2.56-3.29A.75.75 0 0 0 7.25 10h-3.5Z",
    fill: primaryFill
  }));
};

export const SnoozeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SnoozeFilledIcon, 'SnoozeFilled');

const SnoozeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 4a.5.5 0 0 0 0 1h4.03l-4.44 6.2a.5.5 0 0 0 .41.8h5a.5.5 0 0 0 0-1h-4.03l4.44-6.2a.5.5 0 0 0-.41-.8h-5Zm-6 6a.5.5 0 0 0 0 1h2.96l-3.35 4.19a.5.5 0 0 0 .39.81h4a.5.5 0 0 0 0-1H5.54l3.35-4.19A.5.5 0 0 0 8.5 10h-4Z",
    fill: primaryFill
  }));
};

export const SnoozeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SnoozeRegularIcon, 'SnoozeRegular');

const SoundSourceFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 10a7 7 0 1 1 12.14 4.75l.65.77a8 8 0 1 0-11.58 0l.65-.77A6.97 6.97 0 0 1 3 10Zm11.16 3.6a5.5 5.5 0 1 0-8.32 0l.65-.78a4.5 4.5 0 1 1 7.01 0l.66.78Zm-1.65-1.96a3 3 0 1 0-5.02 0l.69-.81a2 2 0 1 1 3.64 0l.69.81Zm-2.13-.96a.5.5 0 0 0-.76 0l-5.5 6.5a.5.5 0 0 0 .38.82h11a.5.5 0 0 0 .38-.82l-5.5-6.5Z",
    fill: primaryFill
  }));
};

export const SoundSourceFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SoundSourceFilledIcon, 'SoundSourceFilled');

const SoundSourceRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 10a7 7 0 1 1 12.14 4.75l.65.77a8 8 0 1 0-11.58 0l.65-.77A6.97 6.97 0 0 1 3 10Zm11.16 3.6a5.5 5.5 0 1 0-8.32 0l.65-.78a4.5 4.5 0 1 1 7.01 0l.66.78Zm-1.65-1.96a3 3 0 1 0-5.02 0l.69-.81a2 2 0 1 1 3.64 0l.69.81Zm-2.13-.96a.5.5 0 0 0-.76 0l-5.5 6.5a.5.5 0 0 0 .38.82h11a.5.5 0 0 0 .38-.82l-5.5-6.5ZM14.42 17H5.58L10 11.77 14.42 17Z",
    fill: primaryFill
  }));
};

export const SoundSourceRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SoundSourceRegularIcon, 'SoundSourceRegular');

const SoundWaveCircleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm7-2.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5ZM6 8a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2A.5.5 0 0 0 6 8Zm5 0a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2A.5.5 0 0 0 11 8Zm2.5-1a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const SoundWaveCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SoundWaveCircleFilledIcon, 'SoundWaveCircleFilled');

const SoundWaveCircleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 7.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5ZM6 8c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5Zm5 0c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5Zm2.5-1c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z",
    fill: primaryFill
  }));
};

export const SoundWaveCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SoundWaveCircleRegularIcon, 'SoundWaveCircleRegular');

const Space3DFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v6.5h-.71L14.86 10H16V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4h1.14L3.7 12.5H3V6Zm0 8v-.5h4.34l-.82 2.86-.2.64H6a3 3 0 0 1-3-3Zm4.48 2.64.9-3.14h3.24l.9 3.13.1.37H7.37l.1-.36h.01Zm1.18-4.14h2.68l-.72-2.5H9.38l-.72 2.5Zm4.82 3.86-.82-2.86H17v.5a3 3 0 0 1-3 3h-.35l-.17-.63Zm-1.1-3.86h2.76L13.7 10h-2.05l.72 2.5Zm-7.52 0h2.76l.72-2.5H6.29l-1.43 2.5Z",
    fill: primaryFill
  }));
};

export const Space3DFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Space3DFilledIcon, 'Space3DFilled');

const Space3DRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm13 0a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3h12V6ZM4 12l1.14-2H4v2Zm.86.5h2.76l.72-2.5H6.29l-1.43 2.5Zm-.86 1v.5c0 1.1.9 2 2 2h.62l.72-2.5H4Zm4.38 0L7.66 16h4.68l-.72-2.5H8.38Zm4.28 0 .72 2.5H14a2 2 0 0 0 2-2v-.5h-3.34Zm2.48-1L13.7 10h-2.05l.72 2.5h2.76Zm-3.8 0-.72-2.5H9.38l-.72 2.5h2.68ZM16 12v-2h-1.14L16 12Z",
    fill: primaryFill
  }));
};

export const Space3DRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Space3DRegularIcon, 'Space3DRegular');

const SpacebarFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 7.75c.41 0 .75.34.75.75v2h13v-2a.75.75 0 0 1 1.5 0v2c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 10.5v-2c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const SpacebarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpacebarFilledIcon, 'SpacebarFilled');

const SpacebarRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 8c.28 0 .5.22.5.5v2c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 10.5v-2c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const SpacebarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpacebarRegularIcon, 'SpacebarRegular');

const SparkleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 0 0 1.59-.51l.45-1.37a2.34 2.34 0 0 1 1.47-1.48l1.4-.45A1.04 1.04 0 0 0 12.25 7l-1.37-.45A2.34 2.34 0 0 1 9.4 5.08L8.95 3.7a1.03 1.03 0 0 0-.82-.68 1.04 1.04 0 0 0-1.15.7l-.46 1.4a2.34 2.34 0 0 1-1.44 1.45L3.7 7a1.04 1.04 0 0 0 .02 1.97l1.37.45a2.33 2.33 0 0 1 1.48 1.48l.46 1.4c.07.2.2.37.38.5Zm6.14 4.05a.8.8 0 0 0 1.22-.4l.25-.76a1.09 1.09 0 0 1 .68-.68l.77-.25a.8.8 0 0 0-.02-1.52l-.77-.25a1.08 1.08 0 0 1-.68-.68l-.25-.77a.8.8 0 0 0-1.52.01l-.24.76a1.1 1.1 0 0 1-.67.68l-.77.25a.8.8 0 0 0 0 1.52l.77.25a1.09 1.09 0 0 1 .68.68l.25.77c.06.16.16.3.3.4Z",
    fill: primaryFill
  }));
};

export const SparkleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SparkleFilledIcon, 'SparkleFilled');

const SparkleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 0 0 1.59-.51l.45-1.37a2.34 2.34 0 0 1 1.47-1.48l1.4-.45A1.04 1.04 0 0 0 12.25 7l-1.37-.45A2.34 2.34 0 0 1 9.4 5.08L8.95 3.7a1.03 1.03 0 0 0-.82-.68 1.04 1.04 0 0 0-1.15.7l-.46 1.4a2.34 2.34 0 0 1-1.44 1.45L3.7 7a1.04 1.04 0 0 0 .02 1.97l1.37.45a2.33 2.33 0 0 1 1.48 1.48l.46 1.4c.07.2.2.37.38.5Zm.08-7.4.53-1.38.44 1.37a3.33 3.33 0 0 0 2.12 2.12l1.4.53-1.38.45a3.34 3.34 0 0 0-2.11 2.11l-.53 1.38-.45-1.38a3.34 3.34 0 0 0-2.1-2.12L4 7.96 5.4 7.5a3.36 3.36 0 0 0 2.08-2.12Zm6.06 11.45a.8.8 0 0 0 1.22-.4l.25-.76a1.09 1.09 0 0 1 .68-.68l.77-.25a.8.8 0 0 0-.02-1.52l-.77-.25a1.08 1.08 0 0 1-.68-.68l-.25-.77a.8.8 0 0 0-1.52.01l-.24.76a1.1 1.1 0 0 1-.67.68l-.77.25a.8.8 0 0 0 0 1.52l.77.25a1.09 1.09 0 0 1 .68.68l.25.77c.06.16.16.3.3.4Zm-.92-2.8-.18-.05.19-.06a2.09 2.09 0 0 0 1.3-1.32l.06-.18.05.18a2.08 2.08 0 0 0 1.32 1.32l.2.06-.18.06a2.08 2.08 0 0 0-1.32 1.32l-.06.18-.06-.18a2.07 2.07 0 0 0-1.32-1.32Z",
    fill: primaryFill
  }));
};

export const SparkleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SparkleRegularIcon, 'SparkleRegular');

const SparkleCircleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM8.82 5.58l.26.73c.1.28.33.5.61.6l.73.26a.87.87 0 0 1 0 1.65l-.73.26a1 1 0 0 0-.6.61l-.27.73a.87.87 0 0 1-1.65 0l-.25-.73a1 1 0 0 0-.61-.6l-.73-.27a.88.88 0 0 1 0-1.65l.73-.25a1 1 0 0 0 .6-.61l.26-.73a.87.87 0 0 1 1.65 0ZM11.33 10a.7.7 0 0 1 1.34 0l.18.6c.08.26.29.47.56.55l.6.18a.7.7 0 0 1 0 1.34l-.6.18a.83.83 0 0 0-.56.56l-.18.6a.7.7 0 0 1-1.34 0l-.18-.6a.83.83 0 0 0-.56-.56l-.59-.18a.7.7 0 0 1 0-1.34l.6-.18a.83.83 0 0 0 .55-.56l.18-.6Z",
    fill: primaryFill
  }));
};

export const SparkleCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SparkleCircleFilledIcon, 'SparkleCircleFilled');

const SparkleCircleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm5.17-4.42a.87.87 0 0 1 1.65 0l.26.73c.1.28.33.5.61.6l.73.26a.87.87 0 0 1 0 1.65l-.73.26a1 1 0 0 0-.6.61l-.27.73a.87.87 0 0 1-1.65 0l-.25-.73a1 1 0 0 0-.61-.6l-.73-.27a.88.88 0 0 1 0-1.65l.73-.25a1 1 0 0 0 .6-.61l.26-.73Zm5.5 4.42a.7.7 0 0 0-1.34 0l-.18.6a.83.83 0 0 1-.56.55l-.59.18a.7.7 0 0 0 0 1.34l.6.18c.26.08.47.29.55.56l.18.6a.7.7 0 0 0 1.34 0l.18-.6a.83.83 0 0 1 .56-.56l.6-.18a.7.7 0 0 0 0-1.34l-.6-.18a.83.83 0 0 1-.56-.56l-.18-.59Z",
    fill: primaryFill
  }));
};

export const SparkleCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SparkleCircleRegularIcon, 'SparkleCircleRegular');

const Speaker0FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.87 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .35.13l3.87 3.6a1 1 0 0 0 1.68-.74V3.01Z",
    fill: primaryFill
  }));
};

export const Speaker0Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker0FilledIcon, 'Speaker0Filled');

const Speaker0RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.88 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V3.01ZM7.12 6.6 11 3v14l-3.88-3.6A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4Z",
    fill: primaryFill
  }));
};

export const Speaker0Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker0RegularIcon, 'Speaker0Regular');

const Speaker1FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.87 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .35.13l3.87 3.6a1 1 0 0 0 1.68-.74V3.01Zm2.08 9.93a.5.5 0 0 1-.19-.68 4.5 4.5 0 0 0 0-4.5.5.5 0 1 1 .87-.5 5.5 5.5 0 0 1 0 5.5.5.5 0 0 1-.68.18Z",
    fill: primaryFill
  }));
};

export const Speaker1Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker1FilledIcon, 'Speaker1Filled');

const Speaker1RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.88 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V3.01ZM7.12 6.6 11 3v14l-3.88-3.6A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4Zm6.96 6.33a.5.5 0 0 1-.18-.68 4.5 4.5 0 0 0 0-4.5.5.5 0 1 1 .86-.5 5.5 5.5 0 0 1 0 5.5.5.5 0 0 1-.68.18Z",
    fill: primaryFill
  }));
};

export const Speaker1Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker1RegularIcon, 'Speaker1Regular');

const Speaker2FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.87 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .35.13l3.87 3.6a1 1 0 0 0 1.68-.74V3.01Zm3.25 1.63a.5.5 0 0 1 .71.04 8 8 0 0 1 0 10.66.5.5 0 1 1-.75-.66 7 7 0 0 0 0-9.34.5.5 0 0 1 .04-.7Zm-1.17 8.3a.5.5 0 0 1-.19-.68 4.5 4.5 0 0 0 0-4.5.5.5 0 1 1 .87-.5 5.5 5.5 0 0 1 0 5.5.5.5 0 0 1-.68.18Z",
    fill: primaryFill
  }));
};

export const Speaker2Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker2FilledIcon, 'Speaker2Filled');

const Speaker2RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.88 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V3.01ZM7.12 6.6 11 3v14l-3.88-3.6A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4Zm8.14-1.97a.5.5 0 0 1 .7.04 8 8 0 0 1 0 10.66.5.5 0 0 1-.74-.66 7 7 0 0 0 0-9.34.5.5 0 0 1 .04-.7Zm-1.18 8.3a.5.5 0 0 1-.18-.68 4.5 4.5 0 0 0 0-4.5.5.5 0 1 1 .86-.5 5.5 5.5 0 0 1 0 5.5.5.5 0 0 1-.68.18Z",
    fill: primaryFill
  }));
};

export const Speaker2Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Speaker2RegularIcon, 'Speaker2Regular');

const SpeakerBluetoothFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.32 2.27a1 1 0 0 1 1.68.74v13.98a1 1 0 0 1-1.68.74l-3.87-3.6A.5.5 0 0 0 6.1 14H3.5A1.5 1.5 0 0 1 2 12.5v-5C2 6.67 2.67 6 3.5 6h2.6a.5.5 0 0 0 .35-.13l3.87-3.6Zm5.53 2.88a.5.5 0 0 0-.85.35v3.46l-1.19-.95a.5.5 0 1 0-.62.78L14.7 10l-1.51 1.21a.5.5 0 1 0 .62.78l1.19-.95v3.46a.5.5 0 0 0 .85.35l2.5-2.5a.5.5 0 0 0-.04-.74L16.3 10l2.01-1.61a.5.5 0 0 0 .04-.74l-2.5-2.5Zm1.4 6.9L16 13.28v-2.25l1.25 1ZM16 6.7l1.25 1.25-1.25 1V6.71Z",
    fill: primaryFill
  }));
};

export const SpeakerBluetoothFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerBluetoothFilledIcon, 'SpeakerBluetoothFilled');

const SpeakerBluetoothRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.32 2.27a1 1 0 0 1 1.68.74v13.98a1 1 0 0 1-1.68.74l-3.88-3.6A.5.5 0 0 0 6.1 14H3.5A1.5 1.5 0 0 1 2 12.5v-5C2 6.67 2.67 6 3.5 6h2.6a.5.5 0 0 0 .34-.13l3.88-3.6Zm.68.74L7.12 6.6c-.27.26-.64.4-1.02.4H3.5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h2.6c.38 0 .75.14 1.02.4L11 17V3Zm4.85 2.14a.5.5 0 0 0-.85.35v3.46l-1.19-.95a.5.5 0 1 0-.62.78L14.7 10l-1.51 1.21a.5.5 0 1 0 .62.78l1.19-.95v3.46a.5.5 0 0 0 .85.35l2.5-2.5a.5.5 0 0 0-.04-.74L16.3 10l2.01-1.61a.5.5 0 0 0 .04-.74l-2.5-2.5Zm1.4 6.9L16 13.28v-2.25l1.25 1ZM16 6.7l1.25 1.25-1.25 1V6.71Z",
    fill: primaryFill
  }));
};

export const SpeakerBluetoothRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerBluetoothRegularIcon, 'SpeakerBluetoothRegular');

const SpeakerEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.87 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .35.13l2.83 2.63.15-.6a3.2 3.2 0 0 1 .84-1.5L12 12.95V3Zm3.96 1.66a7.97 7.97 0 0 1 1.99 4.46c-.34-.1-.68-.14-1.02-.12a6.97 6.97 0 0 0-1.72-3.67.5.5 0 0 1 .75-.67Zm-1.2 2.59c.41.72.65 1.5.72 2.27-.14.1-.26.2-.38.32l-.63.63c.1-.92-.08-1.87-.58-2.72a.5.5 0 0 1 .87-.5Zm-3.78 8.12 4.83-4.83a1.87 1.87 0 1 1 2.64 2.65l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.02Z",
    fill: primaryFill
  }));
};

export const SpeakerEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerEditFilledIcon, 'SpeakerEditFilled');

const SpeakerEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.87 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .35.13l2.83 2.63.15-.6c.04-.17.1-.32.16-.48L7.13 13.4A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.15 1.03-.4L11 3v10.94l1-1V3Zm3.96 1.66a7.97 7.97 0 0 1 1.99 4.46c-.33-.1-.68-.14-1.02-.12a6.97 6.97 0 0 0-1.71-3.67.5.5 0 0 1 .74-.67Zm-1.2 2.59c.42.72.65 1.5.72 2.27-.13.1-.26.2-.38.32l-.62.62c.1-.9-.09-1.86-.58-2.71a.5.5 0 0 1 .86-.5Zm-3.78 8.12 4.83-4.83a1.87 1.87 0 1 1 2.64 2.65l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.02Z",
    fill: primaryFill
  }));
};

export const SpeakerEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerEditRegularIcon, 'SpeakerEditRegular');

const SpeakerMuteFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.88 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V3.01Zm1.14 4.65c.2-.2.51-.2.71 0l1.65 1.64 1.64-1.64a.5.5 0 1 1 .71.7L16.2 10l1.65 1.65a.5.5 0 1 1-.7.7l-1.65-1.64-1.65 1.64a.5.5 0 1 1-.7-.7L14.78 10l-1.65-1.65a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const SpeakerMuteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerMuteFilledIcon, 'SpeakerMuteFilled');

const SpeakerMuteRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.88 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V3.01ZM7.12 6.6 11 3v14l-3.88-3.6A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4Zm6.02 1.05c.2-.2.51-.2.71 0l1.65 1.64 1.64-1.64a.5.5 0 1 1 .71.7L16.2 10l1.65 1.65a.5.5 0 1 1-.7.7l-1.65-1.64-1.65 1.64a.5.5 0 1 1-.7-.7L14.78 10l-1.65-1.65a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const SpeakerMuteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerMuteRegularIcon, 'SpeakerMuteRegular');

const SpeakerOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7L5.29 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .35.13l3.87 3.6a1 1 0 0 0 1.68-.74v-4.28l5.15 5.14a.5.5 0 0 0 .7-.7l-2.56-2.57L2.85 2.15Zm13.11 2.52a8 8 0 0 1 .66 9.83l-.73-.73a7 7 0 0 0-.68-8.44.5.5 0 1 1 .75-.66Zm-1.2 2.58c1 1.74.95 3.8.04 5.43l-.74-.74a4.5 4.5 0 0 0-.17-4.19.5.5 0 1 1 .87-.5ZM12 3.01v6.87L7.25 5.13l3.07-2.86a1 1 0 0 1 1.68.74Z",
    fill: primaryFill
  }));
};

export const SpeakerOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerOffFilledIcon, 'SpeakerOffFilled');

const SpeakerOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7L5.29 6H3.5C2.68 6 2 6.67 2 7.5v5c0 .83.68 1.5 1.5 1.5H6.1a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V12.7l5.15 5.15a.5.5 0 0 0 .7-.7l-2.56-2.57L2.85 2.15ZM11 11.7V17l-3.88-3.6A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6l.18-.01L11 11.7ZM11 3v5.88l1 1V3a1 1 0 0 0-1.68-.74L7.24 5.12l.71.71L11 3.01Zm3.06 8.94.74.74a5.5 5.5 0 0 0-.04-5.43.5.5 0 1 0-.86.5 4.5 4.5 0 0 1 .16 4.19Zm1.84 1.84.72.72a8 8 0 0 0-.66-9.83.5.5 0 1 0-.74.66 7 7 0 0 1 .68 8.45Z",
    fill: primaryFill
  }));
};

export const SpeakerOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerOffRegularIcon, 'SpeakerOffRegular');

const SpeakerSettingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.87 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .35.13l3.21 2.98A5.48 5.48 0 0 1 12 9.6V3Zm.07 8.44-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a4.7 4.7 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a4.71 4.71 0 0 1 0-1.01l.45-.12a2 2 0 0 0 1.44-2.48Zm2.43 4.06a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const SpeakerSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerSettingsFilledIcon, 'SpeakerSettingsFilled');

const SpeakerSettingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3a1 1 0 0 0-1.68-.73l-3.88 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .34.13l3.22 2.99a5.46 5.46 0 0 1-.62-1.94L7.12 13.4A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4L11 3v7.26c.3-.25.64-.48 1-.66V3Zm.06 8.44a2 2 0 0 1-1.43 2.48l-.46.12a4.7 4.7 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 0 1 1.43-2.48l.47-.12a4.7 4.7 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55Zm2.44 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const SpeakerSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerSettingsRegularIcon, 'SpeakerSettingsRegular');

const SpeakerUsbFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.32 2.27a1 1 0 0 1 1.68.74v13.98a1 1 0 0 1-1.68.74l-3.87-3.6A.5.5 0 0 0 6.1 14H3.5A1.5 1.5 0 0 1 2 12.5v-5C2 6.67 2.67 6 3.5 6h2.6a.5.5 0 0 0 .35-.13l3.87-3.6ZM14 8V6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 1 1v2.2a1 1 0 0 1-.2.6l-1.3 1.8V15a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1.4l-1.31-1.84a1 1 0 0 1-.19-.58V9a1 1 0 0 1 1-1Zm1 0h2V6h-2v2Z",
    fill: primaryFill
  }));
};

export const SpeakerUsbFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerUsbFilledIcon, 'SpeakerUsbFilled');

const SpeakerUsbRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.32 2.27a1 1 0 0 1 1.68.74v13.98a1 1 0 0 1-1.68.74l-3.88-3.6A.5.5 0 0 0 6.1 14H3.5A1.5 1.5 0 0 1 2 12.5v-5C2 6.67 2.67 6 3.5 6h2.6a.5.5 0 0 0 .34-.13l3.88-3.6Zm.68.74L7.12 6.6c-.27.26-.64.4-1.02.4H3.5a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h2.6c.38 0 .75.14 1.02.4L11 17V3ZM14 8V6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 1 1v2.2a1 1 0 0 1-.2.6l-1.3 1.8V15a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1.4l-1.31-1.84a1 1 0 0 1-.19-.58V9a1 1 0 0 1 1-1Zm1 0h2V6h-2v2Z",
    fill: primaryFill
  }));
};

export const SpeakerUsbRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpeakerUsbRegularIcon, 'SpeakerUsbRegular');

const SpinnerIosFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 3.5A6.5 6.5 0 0 0 3.5 10 .75.75 0 0 1 2 10a8 8 0 1 1 8 8 .75.75 0 0 1 0-1.5 6.5 6.5 0 1 0 0-13Z",
    fill: primaryFill
  }));
};

export const SpinnerIosFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpinnerIosFilledIcon, 'SpinnerIosFilled');

const SpinnerIosRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 3a7 7 0 0 0-7 7 .5.5 0 0 1-1 0 8 8 0 1 1 8 8 .5.5 0 0 1 0-1 7 7 0 1 0 0-14Z",
    fill: primaryFill
  }));
};

export const SpinnerIosRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SpinnerIosRegularIcon, 'SpinnerIosRegular');

const SplitHintFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h4V4H4Zm11 1a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V6a2 2 0 0 0-2-2h-.5a.5.5 0 0 0 0 1h.5Zm0 10a1 1 0 0 0 1-1v-.5a.5.5 0 0 1 1 0v.5a2 2 0 0 1-2 2h-.5a.5.5 0 0 1 0-1h.5Zm1.5-7a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5Zm-4-4a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm.5 11.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 .5-.5Z",
    fill: primaryFill
  }));
};

export const SplitHintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitHintFilledIcon, 'SplitHintFilled');

const SplitHintRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5ZM2 6c0-1.1.9-2 2-2h4v1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4v1H4a2 2 0 0 1-2-2V6Zm13-1a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V6a2 2 0 0 0-2-2h-.5a.5.5 0 0 0 0 1h.5Zm0 10a1 1 0 0 0 1-1v-.5a.5.5 0 0 1 1 0v.5a2 2 0 0 1-2 2h-.5a.5.5 0 0 1 0-1h.5Zm1.5-7a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5Zm-4-4a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm.5 11.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 .5-.5Z",
    fill: primaryFill
  }));
};

export const SplitHintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitHintRegularIcon, 'SplitHintRegular');

const SplitHorizontalFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 10a.5.5 0 0 0 0-1h-15a.5.5 0 0 0 0 1h15ZM14 2a2 2 0 0 1 2 2v4H4V4c0-1.1.9-2 2-2h8ZM4 11v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-4H4Z",
    fill: primaryFill
  }));
};

export const SplitHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitHorizontalFilledIcon, 'SplitHorizontalFilled');

const SplitHorizontalRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 10a.5.5 0 0 0 0-1h-15a.5.5 0 0 0 0 1h15ZM16 4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4h1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4h1V4Zm0 7h-1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4H4v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-4Z",
    fill: primaryFill
  }));
};

export const SplitHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitHorizontalRegularIcon, 'SplitHorizontalRegular');

const SplitVerticalFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0v-15ZM2 6c0-1.1.9-2 2-2h4v12H4a2 2 0 0 1-2-2V6Zm9 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v12Z",
    fill: primaryFill
  }));
};

export const SplitVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitVerticalFilledIcon, 'SplitVerticalFilled');

const SplitVerticalRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.5a.5.5 0 0 0-1 0v15a.5.5 0 0 0 1 0v-15ZM4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h4v-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4V4H4Zm7 0v1h4a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4Z",
    fill: primaryFill
  }));
};

export const SplitVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SplitVerticalRegularIcon, 'SplitVerticalRegular');

const SportFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.58 4.13c.34.4.62.83.84 1.28a2 2 0 0 1-2.44.31l1.6-1.6Zm-.7-.71-1.6 1.6a2 2 0 0 1 .3-2.43c.46.21.9.49 1.3.83Zm1.04 8.02a6 6 0 0 0 .87-5.03 3 3 0 0 1-3.53.04L13.1 7.6l3.82 3.83Zm-3.37-5.7a3 3 0 0 1 .04-3.53 6 6 0 0 0-5.03.87L12.4 6.9l1.16-1.16ZM7.8 3.72l-.03.04a5.97 5.97 0 0 0-1.52 2.57c.46.14.93.3 1.4.5 1.04.41 2.15.98 3.06 1.77l.98-.99L7.8 3.72Zm5.9 10.04a5.97 5.97 0 0 0 2.55-1.52l.04-.03-3.9-3.9-.97.99c.8.92 1.39 2.05 1.8 3.1.19.46.34.91.48 1.36Zm-.44 2.57a1.7 1.7 0 0 1-2.1 1.65c-1.76-.4-4.54-1.23-6.2-2.89-1.65-1.65-2.5-4.44-2.9-6.2A1.7 1.7 0 0 1 4.08 6.8c.9.19 2.06.49 3.19.94a9.3 9.3 0 0 1 3.1 1.91 9.2 9.2 0 0 1 1.9 3.1c.45 1.14.75 2.29.93 3.2.03.12.04.25.04.37Zm-6.4-5.18a.5.5 0 0 0-.7.7l2 2a.5.5 0 1 0 .7-.7l-2-2Z",
    fill: primaryFill
  }));
};

export const SportFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportFilledIcon, 'SportFilled');

const SportRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.44 5.75c-.08.2-.15.38-.2.58.3.1.63.2.95.32.18-.65.5-1.27.94-1.81L11.29 8l-.6.6a7.16 7.16 0 0 1 .72.7l.59-.6 3.16 3.17c-.54.44-1.15.76-1.79.94.12.32.22.64.32.95a5.97 5.97 0 0 0 4.1-7.32 6.01 6.01 0 0 0-11.35-.69Zm10.2.38a2 2 0 0 1-2.12.06l1.35-1.35c.33.4.58.83.77 1.3Zm-2.84.78a3 3 0 0 0 3.12.21 5 5 0 0 1-1.05 4.04L12.71 8l1.09-1.09Zm-.71-.7L12 7.28 8.84 4.13a5 5 0 0 1 4.04-1.05 3 3 0 0 0 .21 3.12Zm.72-.73a2 2 0 0 1 .06-2.12c.46.19.9.44 1.3.77L13.8 5.48Zm-7.66 5.67c.2-.2.5-.2.7 0l2 2a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7Zm-4.1-2.27a1.7 1.7 0 0 1 2.03-2.07c.91.19 2.07.49 3.2.94a9.3 9.3 0 0 1 3.1 1.91 9.2 9.2 0 0 1 1.9 3.1c.45 1.14.75 2.29.93 3.2a1.7 1.7 0 0 1-2.07 2.02c-1.75-.4-4.53-1.23-6.19-2.89-1.65-1.65-2.5-4.44-2.9-6.2Zm1.82-1.1a.7.7 0 0 0-.85.88c.4 1.76 1.2 4.29 2.64 5.72 1.44 1.44 3.96 2.23 5.7 2.63a.7.7 0 0 0 .87-.85c-.18-.88-.45-1.97-.87-3.02a8.21 8.21 0 0 0-1.69-2.77c-.7-.7-1.7-1.26-2.77-1.69a18.53 18.53 0 0 0-3.03-.9Z",
    fill: primaryFill
  }));
};

export const SportRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportRegularIcon, 'SportRegular');

const SportAmericanFootballFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.94 2.64A11.63 11.63 0 0 0 2.6 10.9l6.6 6.6a10.9 10.9 0 0 0 6.08-4.08 13.32 13.32 0 0 0 2.07-4.35l-6.42-6.43Zm.91 5.5c.2.2.2.52 0 .71l-3 3a.5.5 0 0 1-.7-.7l3-3c.2-.2.5-.2.7 0Zm5.8-.2c.26-1.3.36-2.56.35-3.71A2.25 2.25 0 0 0 15.7 2c-1.32.02-2.53.15-3.62.37l5.56 5.56Zm-9.6 9.81-5.72-5.72A16.1 16.1 0 0 0 2 15.84c.04 1.18 1 2.09 2.15 2.14 1.43.07 2.72-.02 3.89-.23Z",
    fill: primaryFill
  }));
};

export const SportAmericanFootballFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportAmericanFootballFilledIcon, 'SportAmericanFootballFilled');

const SportAmericanFootballRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.85 8.85a.5.5 0 1 0-.7-.7l-3 3a.5.5 0 1 0 .7.7l3-3ZM18 4.23A2.25 2.25 0 0 0 15.7 2c-5.62.07-9.12 2.15-11.18 4.96-2.04 2.78-2.6 6.2-2.51 8.88.04 1.18 1 2.09 2.15 2.14 5.53.26 9.03-1.73 11.13-4.56 2.07-2.8 2.73-6.36 2.71-9.2ZM15.71 3c.72 0 1.29.54 1.3 1.23 0 .9-.07 1.86-.23 2.84l-3.84-3.84C13.79 3.09 14.7 3 15.7 3Zm-3.95.46 4.79 4.8c-.39 1.6-1.04 3.19-2.07 4.56a10.01 10.01 0 0 1-6.1 3.85.5.5 0 0 0-.03-.02l-4.93-4.93a11.8 11.8 0 0 1 1.9-4.17 10.8 10.8 0 0 1 6.44-4.09ZM3.19 12.9l3.98 3.99c-.9.11-1.89.15-2.96.1A1.24 1.24 0 0 1 3 15.81c-.03-.91.02-1.9.18-2.92Z",
    fill: primaryFill
  }));
};

export const SportAmericanFootballRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportAmericanFootballRegularIcon, 'SportAmericanFootballRegular');

const SportBaseballFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 10c0 1.55-.44 3-1.2 4.22-.95-.7-2-1.24-3.14-1.63a.5.5 0 1 0-.32.95c1.04.35 2 .86 2.88 1.5a7.98 7.98 0 0 1-12.44 0c.87-.64 1.84-1.15 2.88-1.5a.5.5 0 0 0-.32-.95c-1.13.39-2.2.94-3.14 1.63a7.96 7.96 0 0 1 0-8.43c.94.7 2 1.25 3.14 1.63a.5.5 0 1 0 .32-.95 10.47 10.47 0 0 1-2.88-1.5 7.98 7.98 0 0 1 12.44 0c-.87.64-1.84 1.15-2.88 1.5a.5.5 0 1 0 .32.95c1.14-.38 2.2-.94 3.14-1.63A7.96 7.96 0 0 1 18 10Zm-8 3c.49 0 .96.03 1.43.1a.5.5 0 1 0 .14-1 11.6 11.6 0 0 0-3.14 0 .5.5 0 0 0 .14 1c.47-.07.94-.1 1.43-.1ZM8.57 6.92a.5.5 0 0 0-.14.99 11.6 11.6 0 0 0 3.14 0 .5.5 0 1 0-.14-1 10.6 10.6 0 0 1-2.86 0Z",
    fill: primaryFill
  }));
};

export const SportBaseballFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportBaseballFilledIcon, 'SportBaseballFilled');

const SportBaseballRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.61 5.53a6.99 6.99 0 0 1 10.78 0c-.64.38-1.33.7-2.05.94a.5.5 0 0 0 .32.95c.81-.27 1.59-.64 2.31-1.08a6.97 6.97 0 0 1 0 7.33c-.73-.44-1.5-.8-2.31-1.08a.5.5 0 0 0-.32.95c.72.24 1.4.56 2.04.94a6.99 6.99 0 0 1-10.76 0c.64-.38 1.32-.7 2.04-.94a.5.5 0 1 0-.32-.95c-.81.28-1.58.64-2.3 1.08a6.97 6.97 0 0 1-.01-7.33c.72.44 1.5.8 2.31 1.08a.5.5 0 0 0 .32-.95c-.72-.24-1.4-.56-2.05-.94ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM8.57 6.92a10.6 10.6 0 0 0 2.86 0 .5.5 0 0 1 .14.99 11.6 11.6 0 0 1-3.14 0 .5.5 0 0 1 .14-1Zm0 6.18a10.6 10.6 0 0 1 2.86 0 .5.5 0 0 0 .14-1 11.6 11.6 0 0 0-3.14 0 .5.5 0 1 0 .14 1Z",
    fill: primaryFill
  }));
};

export const SportBaseballRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportBaseballRegularIcon, 'SportBaseballRegular');

const SportBasketballFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.7 4A7.97 7.97 0 0 1 9 2.06c.07.43.14.91.24 1.4.18.9.43 1.89.78 2.79.28.71.62 1.4 1.06 1.96L10 9.3 4.7 4Zm-.7.7A7.97 7.97 0 0 0 2.06 9c.43.07.9.14 1.4.24.9.18 1.89.43 2.79.78.71.28 1.4.62 1.96 1.06L9.29 10 4 4.7Zm3.5 7.1c-.43-.32-.99-.6-1.61-.85-.83-.31-1.75-.55-2.62-.72-.45-.1-.88-.17-1.27-.22 0 2.02.76 3.87 2 5.28l3.5-3.5ZM4.7 16l3.5-3.5c.32.43.6.98.85 1.61.31.83.55 1.75.72 2.62.1.45.17.88.22 1.27a7.97 7.97 0 0 1-5.28-2Zm4.22-4.21L10 10.71 15.3 16a7.97 7.97 0 0 1-4.3 1.94c-.07-.43-.15-.91-.25-1.4-.18-.9-.43-1.89-.77-2.79a7.57 7.57 0 0 0-1.06-1.96Zm7.08 3.5a7.97 7.97 0 0 0 1.94-4.3 17.37 17.37 0 0 1-4.18-1.02 7.57 7.57 0 0 1-1.97-1.05L10.7 10 16 15.3ZM12.5 8.2c.43.33.98.6 1.61.85.83.32 1.75.55 2.62.72.45.1.88.17 1.27.22 0-2.02-.76-3.87-2-5.28l-3.5 3.5ZM15.3 4A7.97 7.97 0 0 0 10 2c.06.4.14.82.23 1.27.17.87.4 1.8.72 2.62.24.63.53 1.18.85 1.6L15.3 4Z",
    fill: primaryFill
  }));
};

export const SportBasketballFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportBasketballFilledIcon, 'SportBasketballFilled');

const SportBasketballRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m10 9.3 1.08-1.09a7.57 7.57 0 0 1-1.06-1.96 17.37 17.37 0 0 1-.85-3.2 6.97 6.97 0 0 0-3.75 1.66L10 9.29Zm1.79-.38L10.71 10l4.58 4.58a6.97 6.97 0 0 0 1.66-3.75l-.42-.07c-.9-.18-1.88-.43-2.77-.78a7.57 7.57 0 0 1-1.97-1.06Zm5.2.9a6.97 6.97 0 0 0-1.7-4.4L12.5 8.2c.43.32.99.6 1.61.85a16.39 16.39 0 0 0 2.89.78ZM11.8 7.5l2.8-2.8A6.98 6.98 0 0 0 10.16 3l.06.27c.17.87.4 1.8.72 2.62.25.62.53 1.18.85 1.6ZM10 10.7 8.92 11.8c.44.55.79 1.25 1.06 1.96a17.37 17.37 0 0 1 .86 3.2 6.97 6.97 0 0 0 3.74-1.66L10 10.71Zm-1.8 1.8-2.78 2.8a6.97 6.97 0 0 0 4.4 1.7c0-.1-.03-.18-.04-.27-.18-.87-.41-1.8-.73-2.62a6.83 6.83 0 0 0-.84-1.6Zm-.7-.7c-.43-.33-.98-.6-1.61-.85A16.38 16.38 0 0 0 3 10.17c.04 1.58.61 3.15 1.7 4.41l2.8-2.79Zm.71-.72L9.3 10 4.71 5.42a6.97 6.97 0 0 0-1.66 3.74l.42.08c.9.18 1.88.43 2.78.78.72.28 1.4.62 1.96 1.06Zm7.45 4.58A8 8 0 1 1 4.34 4.34a8 8 0 0 1 11.32 11.32Z",
    fill: primaryFill
  }));
};

export const SportBasketballRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportBasketballRegularIcon, 'SportBasketballRegular');

const SportHockeyFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.97 2.06a3.7 3.7 0 0 1 3.45 1.3l1.71 1.93c.75.84 1.08 2.02.73 3.13-2.1 6.7-7.03 9.08-10.19 9.55-.9.14-1.76-.22-2.39-.78l-1.8-1.6A4.07 4.07 0 0 1 2.2 11.2c2.12-5.99 6.46-8.47 9.76-9.15Zm2.52 3.52a.5.5 0 1 0-.98-.16 10.9 10.9 0 0 1-3.05 5.9 10.32 10.32 0 0 1-4.1 2.7.5.5 0 1 0 .28.96c1.25-.36 3-1.38 4.53-2.96a11.89 11.89 0 0 0 3.32-6.44Z",
    fill: primaryFill
  }));
};

export const SportHockeyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportHockeyFilledIcon, 'SportHockeyFilled');

const SportHockeyRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.97 2.06a3.7 3.7 0 0 1 3.45 1.3l1.71 1.93c.75.84 1.08 2.02.73 3.13-2.1 6.7-7.03 9.08-10.19 9.55-.9.14-1.76-.22-2.39-.78l-1.8-1.6A4.07 4.07 0 0 1 2.2 11.2c2.12-5.99 6.46-8.47 9.76-9.15Zm2.7 1.97c-.68-.76-1.6-1.17-2.5-.99-3 .61-7.03 2.89-9.02 8.5-.4 1.15.02 2.44.98 3.3l1.82 1.6c.46.41 1.03.63 1.57.54 2.85-.42 7.41-2.57 9.39-8.86.23-.73.02-1.55-.53-2.16l-1.71-1.93Zm-.6.98c.28.04.47.3.42.57a11.89 11.89 0 0 1-3.32 6.44 11.28 11.28 0 0 1-4.53 2.96.5.5 0 0 1-.28-.96c1.05-.3 2.66-1.22 4.1-2.7a10.9 10.9 0 0 0 3.05-5.9.5.5 0 0 1 .57-.41Z",
    fill: primaryFill
  }));
};

export const SportHockeyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportHockeyRegularIcon, 'SportHockeyRegular');

const SportSoccerFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM7.1 3.63l2.4 1.4v1.7L6.73 8.7l-1.56-.57-.62-2.51a7.02 7.02 0 0 1 2.54-1.98ZM3.02 10.7l1.83-1.62 1.55.56 1.04 3.3L6.73 14H4.25a6.96 6.96 0 0 1-1.22-3.3Zm5.34 6.12-.81-2.25.7-1.06h3.47l.72 1.06-.82 2.25a7.02 7.02 0 0 1-3.26 0ZM15.75 14h-2.48l-.72-1.08 1.02-3.29 1.57-.56 1.83 1.62a6.96 6.96 0 0 1-1.22 3.3Zm-.3-8.38-.62 2.5-1.58.57-2.75-1.95v-1.7l2.4-1.4c1 .45 1.88 1.13 2.56 1.98Z",
    fill: primaryFill
  }));
};

export const SportSoccerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportSoccerFilledIcon, 'SportSoccerFilled');

const SportSoccerRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM8.34 3.2a7.02 7.02 0 0 1 3.33 0L10 4.17 8.34 3.2Zm-1.25.43 2.41 1.4v1.7L6.73 8.7l-1.56-.57-.62-2.51a7.02 7.02 0 0 1 2.54-1.98ZM3.8 6.75l.4 1.58-1.17 1.03c.08-.94.35-1.82.77-2.61Zm-.77 3.94 1.83-1.62 1.55.56 1.04 3.3L6.73 14H4.25a6.96 6.96 0 0 1-1.22-3.3ZM5.1 15h1.55l.51 1.41A7.01 7.01 0 0 1 5.1 15Zm3.27 1.82-.81-2.25.7-1.06h3.47l.72 1.06-.82 2.25a7.02 7.02 0 0 1-3.26 0Zm4.47-.41.51-1.4h1.55a7.02 7.02 0 0 1-2.06 1.4Zm2.9-2.4h-2.47l-.72-1.08 1.02-3.29 1.57-.56 1.83 1.62a6.96 6.96 0 0 1-1.22 3.3Zm1.23-4.64-1.16-1.03.4-1.58c.4.8.68 1.68.76 2.6Zm-1.51-3.74-.63 2.5-1.58.57-2.75-1.95v-1.7l2.4-1.4c1 .45 1.88 1.13 2.56 1.98ZM7.4 9.45 10 7.6l2.59 1.84-.96 3.05H8.37L7.4 9.45Z",
    fill: primaryFill
  }));
};

export const SportSoccerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SportSoccerRegularIcon, 'SportSoccerRegular');

const SquareFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Z",
    fill: primaryFill
  }));
};

export const SquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareFilledIcon, 'SquareFilled');

const SquareRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z",
    fill: primaryFill
  }));
};

export const SquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareRegularIcon, 'SquareRegular');

const SquareAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6A5.5 5.5 0 0 1 17 9.6V6a3 3 0 0 0-3-3H6Zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const SquareAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareAddFilledIcon, 'SquareAddFilled');

const SquareAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6c-.16-.32-.3-.65-.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.2c.35.1.68.24 1 .4V6a3 3 0 0 0-3-3H6Zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const SquareAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareAddRegularIcon, 'SquareAddRegular');

const SquareArrowForwardFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6A5.5 5.5 0 0 1 17 9.6V6a3 3 0 0 0-3-3H6Zm8.5 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 11.9a.5.5 0 0 0-.7.7Z",
    fill: primaryFill
  }));
};

export const SquareArrowForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareArrowForwardFilledIcon, 'SquareArrowForwardFilled');

const SquareArrowForwardRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6c-.32-.16-.65-.3-1-.4V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3.2c.1.35.24.68.4 1H6a3 3 0 0 1-3-3V6Zm11.5 13a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm.9-6.4.9.9h-1.55A2.75 2.75 0 0 0 12 16.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 11.9a.5.5 0 0 0-.7.7Z",
    fill: primaryFill
  }));
};

export const SquareArrowForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareArrowForwardRegularIcon, 'SquareArrowForwardRegular');

const SquareDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6A5.5 5.5 0 0 1 17 9.6V6a3 3 0 0 0-3-3H6Zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0Z",
    fill: primaryFill
  }));
};

export const SquareDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareDismissFilledIcon, 'SquareDismissFilled');

const SquareDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6c-.16-.32-.3-.65-.4-1H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.2c.35.1.68.24 1 .4V6a3 3 0 0 0-3-3H6Zm8.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm1.85-6.35c.2.2.2.5 0 .7l-1.14 1.15 1.14 1.15a.5.5 0 0 1-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 0 1-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 0 1 .7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0Z",
    fill: primaryFill
  }));
};

export const SquareDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareDismissRegularIcon, 'SquareDismissRegular');

const SquareEraserFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m8.73 13.64 4.9-4.9A2.48 2.48 0 0 1 17 8.59V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2.6a2.5 2.5 0 0 1 .13-3.36Zm7.74-4.2 2.1 2.1a1.5 1.5 0 0 1 0 2.12l-3.6 3.6-4.22-4.22 3.6-3.6a1.5 1.5 0 0 1 2.12 0Zm-2.21 8.52-4.22-4.22-.6.6a1.5 1.5 0 0 0 0 2.13l2.1 2.1a1.5 1.5 0 0 0 1.12.43h4.09a.5.5 0 0 0 0-1h-2.53l.04-.04Z",
    fill: primaryFill
  }));
};

export const SquareEraserFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareEraserFilledIcon, 'SquareEraserFilled');

const SquareEraserRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.08 16H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2.08c.37.09.71.26 1 .5V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2.6a2.47 2.47 0 0 1-.52-1Zm1.36.47a1.5 1.5 0 0 1 0-2.13l4.9-4.9a1.5 1.5 0 0 1 2.12 0l2.1 2.1a1.5 1.5 0 0 1 0 2.13L14.22 18h2.53a.5.5 0 0 1 0 1h-4.1a1.5 1.5 0 0 1-1.12-.44l-2.1-2.1Zm5.61-6.32-3.6 3.6 2.8 2.8 3.6-3.6a.5.5 0 0 0 0-.71l-2.1-2.1a.5.5 0 0 0-.7 0Zm-1.5 7.1-2.8-2.8-.6.6a.5.5 0 0 0 0 .71l2.1 2.1a.5.5 0 0 0 .7 0l.6-.6Z",
    fill: primaryFill
  }));
};

export const SquareEraserRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareEraserRegularIcon, 'SquareEraserRegular');

const SquareHintFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.25 3a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5ZM3 10.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0v1.5Zm5.5 5.5c0-.41.34-.75.75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm7-5.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0v1.5Zm-9.5-7A.75.75 0 0 0 5.25 3C4.01 3 3 4 3 5.25a.75.75 0 0 0 1.5 0c0-.41.34-.75.75-.75S6 4.16 6 3.75ZM5.25 17a.75.75 0 0 0 0-1.5.75.75 0 0 1-.75-.75.75.75 0 0 0-1.5 0C3 15.99 4 17 5.25 17ZM14 3.75c0-.41.34-.75.75-.75C15.99 3 17 4 17 5.25a.75.75 0 0 1-1.5 0 .75.75 0 0 0-.75-.75.75.75 0 0 1-.75-.75ZM14.75 17a.75.75 0 0 1 0-1.5c.41 0 .75-.34.75-.75a.75.75 0 0 1 1.5 0c0 1.24-1 2.25-2.25 2.25Z",
    fill: primaryFill
  }));
};

export const SquareHintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintFilledIcon, 'SquareHintFilled');

const SquareHintRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3.5a.5.5 0 0 0-.5-.5A2.5 2.5 0 0 0 3 5.5a.5.5 0 0 0 1 0C4 4.67 4.67 4 5.5 4a.5.5 0 0 0 .5-.5ZM16.5 6a.5.5 0 0 0 .5-.5A2.5 2.5 0 0 0 14.5 3a.5.5 0 0 0 0 1c.83 0 1.5.67 1.5 1.5 0 .28.22.5.5.5Zm-2 11a.5.5 0 0 1 0-1c.83 0 1.5-.67 1.5-1.5a.5.5 0 0 1 1 0 2.5 2.5 0 0 1-2.5 2.5Zm-11-3a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 5.5 17a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 4 14.5a.5.5 0 0 0-.5-.5ZM3 9a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0V9Zm13.5-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5Zm-8-5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5ZM9 16a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H9Z",
    fill: primaryFill
  }));
};

export const SquareHintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintRegularIcon, 'SquareHintRegular');

const SquareHintAppsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM4.05 5.54a2 2 0 0 1 1.55-1.5.5.5 0 0 0 .4-.59.5.5 0 0 0-.66-.38 3 3 0 0 0-2.29 2.34.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47Zm0 8.92a2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.66.38 3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47ZM14.66 3.07a.5.5 0 0 0-.66.38.5.5 0 0 0 .46.6 2 2 0 0 1 1.5 1.55.5.5 0 0 0 .59.4.5.5 0 0 0 .38-.66 3 3 0 0 0-2.27-2.27ZM3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3ZM6.5 5C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5H7v-.25A2.75 2.75 0 0 1 9.75 12H12V9.75A2.75 2.75 0 0 1 14.75 7H15v-.5c0-.83-.67-1.5-1.5-1.5h-7ZM19 9.75C19 8.78 18.22 8 17.25 8h-2.5C13.78 8 13 8.78 13 9.75V13H9.75C8.78 13 8 13.78 8 14.75v2.5c0 .97.78 1.75 1.75 1.75h6.75a2.5 2.5 0 0 0 2.5-2.5V9.75ZM14 13V9.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75V13h-4Zm2.5 5H14v-4h4v2.5c0 .83-.67 1.5-1.5 1.5Zm-6.75-4H13v4H9.75a.75.75 0 0 1-.75-.75v-2.5c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const SquareHintAppsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintAppsFilledIcon, 'SquareHintAppsFilled');

const SquareHintAppsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM4.05 5.54a2 2 0 0 1 1.55-1.5.5.5 0 0 0 .4-.59.5.5 0 0 0-.66-.38 3 3 0 0 0-2.29 2.34.5.5 0 0 0 .4.6.5.5 0 0 0 .6-.47Zm0 8.92a2 2 0 0 0 1.55 1.5.5.5 0 0 1 .4.59.5.5 0 0 1-.66.38 3 3 0 0 1-2.29-2.34.5.5 0 0 1 .4-.6.5.5 0 0 1 .6.47ZM14.66 3.07a.5.5 0 0 0-.66.38.5.5 0 0 0 .46.6 2 2 0 0 1 1.5 1.55.5.5 0 0 0 .59.4.5.5 0 0 0 .38-.66 3 3 0 0 0-2.27-2.27ZM3 11.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3Zm16-1.75C19 8.78 18.22 8 17.25 8h-2.5C13.78 8 13 8.78 13 9.75V13H9.75C8.78 13 8 13.78 8 14.75v2.5c0 .97.78 1.75 1.75 1.75h6.75a2.5 2.5 0 0 0 2.5-2.5V9.75ZM14 13V9.75c0-.41.34-.75.75-.75h2.5c.41 0 .75.34.75.75V13h-4Zm2.5 5H14v-4h4v2.5c0 .83-.67 1.5-1.5 1.5Zm-6.75-4H13v4H9.75a.75.75 0 0 1-.75-.75v-2.5c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const SquareHintAppsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintAppsRegularIcon, 'SquareHintAppsRegular');

const SquareHintArrowBackFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.25 3a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5ZM3 10.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0v1.5Zm4.5 5.5c0-.41.34-.75.75-.75h.84c.1.53.27 1.03.51 1.5H8.25a.75.75 0 0 1-.75-.75Zm8-7.16c.53.1 1.03.27 1.5.51V8.25a.75.75 0 0 0-1.5 0v.84ZM6 3.75A.75.75 0 0 0 5.25 3C4.01 3 3 4 3 5.25a.75.75 0 0 0 1.5 0c0-.41.34-.75.75-.75S6 4.16 6 3.75ZM5.25 17a.75.75 0 0 0 0-1.5.75.75 0 0 1-.75-.75.75.75 0 0 0-1.5 0C3 15.99 4 17 5.25 17ZM14 3.75c0-.41.34-.75.75-.75C15.99 3 17 4 17 5.25a.75.75 0 0 1-1.5 0 .75.75 0 0 0-.75-.75.75.75 0 0 1-.75-.75ZM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z",
    fill: primaryFill
  }));
};

export const SquareHintArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintArrowBackFilledIcon, 'SquareHintArrowBackFilled');

const SquareHintArrowBackRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3.5a.5.5 0 0 0-.5-.5A2.5 2.5 0 0 0 3 5.5a.5.5 0 0 0 1 0C4 4.67 4.67 4 5.5 4a.5.5 0 0 0 .5-.5ZM16.5 6a.5.5 0 0 0 .5-.5A2.5 2.5 0 0 0 14.5 3a.5.5 0 0 0 0 1c.83 0 1.5.67 1.5 1.5 0 .28.22.5.5.5Zm-13 8a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 5.5 17a.5.5 0 0 0 0-1A1.5 1.5 0 0 1 4 14.5a.5.5 0 0 0-.5-.5ZM3 9a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0V9Zm13.5-1.5a.5.5 0 0 0-.5.5v1.2c.35.1.68.24 1 .4V8a.5.5 0 0 0-.5-.5ZM9.6 17c-.16-.32-.3-.65-.4-1H8a.5.5 0 0 0 0 1h1.6ZM8.5 3.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5Zm6 15.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z",
    fill: primaryFill
  }));
};

export const SquareHintArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintArrowBackRegularIcon, 'SquareHintArrowBackRegular');

const SquareHintSparklesFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM10 3.5c0-.17.04-.34.1-.5h-.85a.75.75 0 0 0 0 1.5h1.18a1.43 1.43 0 0 1-.43-1Zm-6.25 8a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 1.5 0v1.5c0 .41-.34.75-.75.75Zm5.5 4a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5ZM5.25 3a.75.75 0 0 1 0 1.5.75.75 0 0 0-.75.75.75.75 0 0 1-1.5 0C3 4.01 4 3 5.25 3ZM6 16.25c0 .41-.34.75-.75.75C4.01 17 3 16 3 14.75a.75.75 0 0 1 1.5 0c0 .41.34.75.75.75s.75.34.75.75Zm8 0c0 .41.34.75.75.75 1.24 0 2.25-1 2.25-2.25a.75.75 0 0 0-1.5 0c0 .41-.34.75-.75.75a.75.75 0 0 0-.75.75Z",
    fill: primaryFill
  }));
};

export const SquareHintSparklesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintSparklesFilledIcon, 'SquareHintSparklesFilled');

const SquareHintSparklesRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m14.88.28.35 1.07a2.2 2.2 0 0 0 1.4 1.4l1.07.35h.02a.42.42 0 0 1 0 .8l-1.07.35a2.2 2.2 0 0 0-1.4 1.4l-.35 1.07a.42.42 0 0 1-.8 0l-.35-1.07a2.23 2.23 0 0 0-1.4-1.4l-1.07-.35a.42.42 0 0 1 0-.8l1.07-.35a2.2 2.2 0 0 0 1.38-1.4l.35-1.07a.42.42 0 0 1 .8 0Zm4.9 7.93-.76-.25a1.58 1.58 0 0 1-1-1l-.25-.76a.3.3 0 0 0-.57 0l-.25.77a1.58 1.58 0 0 1-.98 1l-.77.24a.3.3 0 0 0 0 .57l.77.25a1.58 1.58 0 0 1 1 1l.24.77a.3.3 0 0 0 .58 0l.24-.77a1.58 1.58 0 0 1 1-1l.77-.24a.3.3 0 0 0 0-.57h-.02ZM10 3.5c0-.17.04-.34.1-.5H9a.5.5 0 0 0 0 1h1.1c-.06-.16-.1-.33-.1-.5ZM5.5 3a.5.5 0 0 1 0 1C4.67 4 4 4.67 4 5.5a.5.5 0 0 1-1 0A2.5 2.5 0 0 1 5.5 3ZM14 16.5c0 .28.22.5.5.5a2.5 2.5 0 0 0 2.5-2.5.5.5 0 0 0-1 0c0 .83-.67 1.5-1.5 1.5a.5.5 0 0 0-.5.5Zm-11-2a.5.5 0 0 1 1 0c0 .83.67 1.5 1.5 1.5a.5.5 0 0 1 0 1A2.5 2.5 0 0 1 3 14.5Zm.5-6A.5.5 0 0 0 3 9v2a.5.5 0 0 0 1 0V9a.5.5 0 0 0-.5-.5Zm5 8c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const SquareHintSparklesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareHintSparklesRegularIcon, 'SquareHintSparklesRegular');

const SquareMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.09 4H5.05A2.5 2.5 0 0 1 7.5 2H14a4 4 0 0 1 4 4v6.5a2.5 2.5 0 0 1-2 2.45v-1.04c.58-.2 1-.76 1-1.41V6a3 3 0 0 0-3-3H7.5c-.65 0-1.2.42-1.41 1ZM2 7.5A2.5 2.5 0 0 1 4.5 5h8A2.5 2.5 0 0 1 15 7.5v8a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 2 15.5v-8Z",
    fill: primaryFill
  }));
};

export const SquareMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareMultipleFilledIcon, 'SquareMultipleFilled');

const SquareMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.09 4H5.05A2.5 2.5 0 0 1 7.5 2H14a4 4 0 0 1 4 4v6.5a2.5 2.5 0 0 1-2 2.45v-1.04c.58-.2 1-.76 1-1.41V6a3 3 0 0 0-3-3H7.5c-.65 0-1.2.42-1.41 1ZM4.5 5A2.5 2.5 0 0 0 2 7.5v8A2.5 2.5 0 0 0 4.5 18h8a2.5 2.5 0 0 0 2.5-2.5v-8A2.5 2.5 0 0 0 12.5 5h-8ZM3 7.5C3 6.67 3.67 6 4.5 6h8c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 0 1 3 15.5v-8Z",
    fill: primaryFill
  }));
};

export const SquareMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareMultipleRegularIcon, 'SquareMultipleRegular');

const SquareShadowFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14H6v1.5A2.5 2.5 0 0 0 8.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 6H14V4.5A2.5 2.5 0 0 0 11.5 2h-7Zm-1 2.5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7Z",
    fill: primaryFill
  }));
};

export const SquareShadowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareShadowFilledIcon, 'SquareShadowFilled');

const SquareShadowRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14H6v1.5A2.5 2.5 0 0 0 8.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 6H14V4.5A2.5 2.5 0 0 0 11.5 2h-7ZM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 3 11.5v-7Z",
    fill: primaryFill
  }));
};

export const SquareShadowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquareShadowRegularIcon, 'SquareShadowRegular');

const SquaresNestedFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1.76A2.99 2.99 0 0 0 15 7h-5a3 3 0 0 0-3 3v5c0 .77.29 1.47.76 2H6a3 3 0 0 1-3-3V6Zm7 11h4a3 3 0 0 0 3-3v-4a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v5c0 1.1.9 2 2 2Z",
    fill: primaryFill
  }));
};

export const SquaresNestedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquaresNestedFilledIcon, 'SquaresNestedFilled');

const SquaresNestedRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm10 4.76A2.99 2.99 0 0 0 14 7h-4a3 3 0 0 0-3 3v4c0 .77.29 1.47.76 2H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v1.76ZM10 16a2 2 0 0 1-2-2v-4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4Z",
    fill: primaryFill
  }));
};

export const SquaresNestedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SquaresNestedRegularIcon, 'SquaresNestedRegular');

const StackFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm.27 11c.34.6.99 1 1.73 1h6a4 4 0 0 0 4-4V7a2 2 0 0 0-1-1.73V11a3 3 0 0 1-3 3H4.27Zm2 2c.34.6.99 1 1.73 1h4a6 6 0 0 0 6-6V9a2 2 0 0 0-1-1.73V11a5 5 0 0 1-5 5H6.27Z",
    fill: primaryFill
  }));
};

export const StackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackFilledIcon, 'StackFilled');

const StackRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H4Zm2 11a2 2 0 0 1-1.73-1H12a3 3 0 0 0 3-3V5.27c.6.34 1 .99 1 1.73v4a4 4 0 0 1-4 4H6Zm2 2a2 2 0 0 1-1.73-1H12a5 5 0 0 0 5-5V7.27c.6.34 1 .99 1 1.73v2a6 6 0 0 1-6 6H8Z",
    fill: primaryFill
  }));
};

export const StackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackRegularIcon, 'StackRegular');

const StackArrowForwardFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm1.6-7.1a.5.5 0 0 0-.7.7l.9.9h-1.55A2.75 2.75 0 0 0 12 7.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 2.9ZM4 3h5.6a5.5 5.5 0 0 0 4.4 7.98V11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2Zm11 7.98c.34-.03.68-.1 1-.19V11a4 4 0 0 1-4 4H6a2 2 0 0 1-1.73-1H12a3 3 0 0 0 3-3v-.02Zm3-1.24c-.3.26-.64.48-1 .66v.6a5 5 0 0 1-5 5H6.27c.34.6.99 1 1.73 1h4a6 6 0 0 0 6-6V9.74Z",
    fill: primaryFill
  }));
};

export const StackArrowForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackArrowForwardFilledIcon, 'StackArrowForwardFilled');

const StackArrowForwardRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm1.6-7.1a.5.5 0 0 0-.7.7l.9.9h-1.55A2.75 2.75 0 0 0 12 7.25v.25a.5.5 0 0 0 1 0v-.25c0-.97.78-1.75 1.75-1.75h1.54l-.9.9a.5.5 0 0 0 .71.7l1.76-1.75a.5.5 0 0 0 0-.7L16.1 2.9ZM14 11v-.02c-.34-.03-.68-.1-1-.19V11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5.2c.1-.35.24-.68.4-1H4a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2Zm1-.02c.34-.03.68-.1 1-.19V11a4 4 0 0 1-4 4H6a2 2 0 0 1-1.73-1H12a3 3 0 0 0 3-3v-.02Zm3-1.24c-.3.26-.64.48-1 .66v.6a5 5 0 0 1-5 5H6.27c.34.6.99 1 1.73 1h4a6 6 0 0 0 6-6V9.74Z",
    fill: primaryFill
  }));
};

export const StackArrowForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackArrowForwardRegularIcon, 'StackArrowForwardRegular');

const StackStarFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm4.33 2.08.91 1.73 1.8.22a.38.38 0 0 1 .2.67L9.91 8.74l.45 1.93a.38.38 0 0 1-.56.4L8 10l-1.8 1.08a.38.38 0 0 1-.57-.4l.45-1.93L4.77 7.7a.38.38 0 0 1 .19-.67l1.8-.22.9-1.73a.38.38 0 0 1 .67 0ZM4.27 14c.34.6.99 1 1.73 1h6a4 4 0 0 0 4-4V7a2 2 0 0 0-1-1.73V11a3 3 0 0 1-3 3H4.27Zm2 2c.34.6.99 1 1.73 1h4a6 6 0 0 0 6-6V9a2 2 0 0 0-1-1.73V11a5 5 0 0 1-5 5H6.27Z",
    fill: primaryFill
  }));
};

export const StackStarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackStarFilledIcon, 'StackStarFilled');

const StackStarRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 4.75c.19 0 .36.1.44.27l.88 1.68 1.74.2a.5.5 0 0 1 .25.9l-1.25 1 .43 1.84a.5.5 0 0 1-.75.54L8 10.14l-1.74 1.04a.5.5 0 0 1-.75-.54l.43-1.85-1.25-1a.5.5 0 0 1 .25-.88l1.74-.21.88-1.68A.5.5 0 0 1 8 4.75ZM2 5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H4Zm2 11a2 2 0 0 1-1.73-1H12a3 3 0 0 0 3-3V5.27c.6.34 1 .99 1 1.73v4a4 4 0 0 1-4 4H6Zm2 2a2 2 0 0 1-1.73-1H12a5 5 0 0 0 5-5V7.27c.6.34 1 .99 1 1.73v2a6 6 0 0 1-6 6H8Z",
    fill: primaryFill
  }));
};

export const StackStarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StackStarRegularIcon, 'StackStarRegular');

const StarFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-3.12 3.05.73 4.3a1 1 0 0 1-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9Z",
    fill: primaryFill
  }));
};

export const StarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarFilledIcon, 'StarFilled');

const StarRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-3.12 3.05.73 4.3a1 1 0 0 1-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9Zm.9.44L8.07 7.25a1 1 0 0 1-.75.55L3 8.43l3.12 3.04a1 1 0 0 1 .3.89l-.75 4.3 3.87-2.03a1 1 0 0 1 .93 0l3.86 2.03-.74-4.3a1 1 0 0 1 .29-.89L17 8.43l-4.32-.63a1 1 0 0 1-.75-.55L10 3.35Z",
    fill: primaryFill
  }));
};

export const StarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarRegularIcon, 'StarRegular');

const StarAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-.55.54a5.5 5.5 0 0 0-7.96 6.26l-3.05 1.6a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 1 0 0 1H14v1.5a.5.5 0 1 0 1 0V15h1.5a.5.5 0 1 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const StarAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarAddFilledIcon, 'StarAddFilled');

const StarAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-.55.54a5.46 5.46 0 0 0-1-.43l.85-.82-4.32-.63a1 1 0 0 1-.75-.55L10 3.35l-1.93 3.9a1 1 0 0 1-.75.55L3 8.43l3.12 3.04a1 1 0 0 1 .3.89l-.75 4.3 3.35-1.76c.02.36.08.7.17 1.04l-3.05 1.6a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 1 0 0 1H14v1.5a.5.5 0 1 0 1 0V15h1.5a.5.5 0 1 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const StarAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarAddRegularIcon, 'StarAddRegular');

const StarArrowBackFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-.55.54a5.5 5.5 0 0 0-7.96 6.26l-3.05 1.6a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9ZM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z",
    fill: primaryFill
  }));
};

export const StarArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowBackFilledIcon, 'StarArrowBackFilled');

const StarArrowBackRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-.55.54a5.47 5.47 0 0 0-1-.43l.85-.82-4.32-.63a1 1 0 0 1-.75-.55L10 3.35l-1.93 3.9a1 1 0 0 1-.75.55L3 8.43l3.12 3.04a1 1 0 0 1 .3.89l-.75 4.3 3.34-1.76c.03.36.09.7.18 1.04l-3.05 1.6a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9ZM14.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z",
    fill: primaryFill
  }));
};

export const StarArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowBackRegularIcon, 'StarArrowBackRegular');

const StarArrowRightEndFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 2.56a1 1 0 0 0-1.8 0L7.17 6.45l-4.31.62a1 1 0 0 0-.56 1.7l3.13 3.03-.74 4.28a1 1 0 0 0 1.45 1.05l3.05-1.6a5.46 5.46 0 0 1 5.31-6.9c.96 0 1.86.24 2.65.67l.55-.53a1 1 0 0 0-.56-1.7l-4.31-.62-1.93-3.9ZM19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-4.15 2.35a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z",
    fill: primaryFill
  }));
};

export const StarArrowRightEndFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowRightEndFilledIcon, 'StarArrowRightEndFilled');

const StarArrowRightEndRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 2.56a1 1 0 0 0-1.8 0L7.17 6.45l-4.31.62a1 1 0 0 0-.56 1.7l3.13 3.03-.74 4.28a1 1 0 0 0 1.45 1.05l3.05-1.6a5.44 5.44 0 0 1-.17-1.03l-3.35 1.75.74-4.28a1 1 0 0 0-.29-.88L3 8.06l4.32-.63a1 1 0 0 0 .75-.54L10 2.99l1.93 3.9c.15.3.43.5.75.54l4.32.63-.85.82c.35.11.69.25 1 .42l.55-.53a1 1 0 0 0-.56-1.7l-4.31-.62-1.93-3.9ZM19 14.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-4.15 2.35a.5.5 0 0 1-.7-.7L15.29 15H12.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z",
    fill: primaryFill
  }));
};

export const StarArrowRightEndRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowRightEndRegularIcon, 'StarArrowRightEndRegular');

const StarArrowRightStartFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.56a1 1 0 0 1 1.8 0l1.93 3.9 4.31.64a1 1 0 0 1 .56 1.7l-3.13 3.05.74 4.3a1 1 0 0 1-1.45 1.05l-2.98-1.57a5.52 5.52 0 0 0-7.8-6.07L2.3 8.8a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.56ZM5.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85A.5.5 0 0 0 8 14.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L6.29 14H3.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const StarArrowRightStartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowRightStartFilledIcon, 'StarArrowRightStartFilled');

const StarArrowRightStartRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.56a1 1 0 0 1 1.8 0l1.93 3.89 4.31.62a1 1 0 0 1 .56 1.7l-3.13 3.03.74 4.28a1 1 0 0 1-1.45 1.05l-2.97-1.55c.07-.35.1-.7.11-1.07l3.33 1.74-.74-4.28a1 1 0 0 1 .29-.88L17 8.06l-4.32-.63a1 1 0 0 1-.75-.54L10 2.99 8.07 6.9a1 1 0 0 1-.75.54L3 8.06l1.14 1.1c-.36.1-.7.23-1.04.39l-.8-.78a1 1 0 0 1 .56-1.7l4.31-.62 1.93-3.9ZM5.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85A.5.5 0 0 0 8 14.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L6.29 14H3.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const StarArrowRightStartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarArrowRightStartRegularIcon, 'StarArrowRightStartRegular');

const StarDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-.55.54a5.5 5.5 0 0 0-7.96 6.26l-3.05 1.6a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const StarDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarDismissFilledIcon, 'StarDismissFilled');

const StarDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-.55.54a5.47 5.47 0 0 0-1-.43l.85-.82-4.32-.63a1 1 0 0 1-.75-.55L10 3.35l-1.93 3.9a1 1 0 0 1-.75.55L3 8.43l3.12 3.04a1 1 0 0 1 .3.89l-.75 4.3 3.34-1.76c.03.36.09.7.18 1.04l-3.05 1.6a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const StarDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarDismissRegularIcon, 'StarDismissRegular');

const StarEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 2.9a1 1 0 0 0-1.8 0L7.17 6.8l-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05l3.43-1.8c.16-.4.4-.76.7-1.07l4.83-4.83a2.87 2.87 0 0 1 2.67-.77 1 1 0 0 0-.63-1.63l-4.31-.63L10.9 2.9Zm4.9 7.65-4.82 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64Z",
    fill: primaryFill
  }));
};

export const StarEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarEditFilledIcon, 'StarEditFilled');

const StarEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 2.9a1 1 0 0 0-1.8 0L7.17 6.8l-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05l3.43-1.8c.16-.4.4-.76.7-1.07l.1-.09a1 1 0 0 0-.83.05l-3.87 2.03.74-4.3a1 1 0 0 0-.29-.89L3 8.43l4.32-.63a1 1 0 0 0 .75-.55L10 3.35l1.93 3.9c.15.3.43.5.75.55l4.32.63-.72.7c.48-.15 1-.17 1.49-.06a1 1 0 0 0-.63-1.63l-4.31-.63L10.9 2.9Zm4.9 7.65-4.82 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64Z",
    fill: primaryFill
  }));
};

export const StarEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarEditRegularIcon, 'StarEditRegular');

const StarEmphasisFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-3.12 3.05.73 4.3a1 1 0 0 1-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9ZM4.4 12.69a.5.5 0 0 1-.08.7l-2.5 2a.5.5 0 1 1-.62-.78l2.5-2a.5.5 0 0 1 .7.08ZM4.31 5.1a.5.5 0 1 1-.62.78l-2.5-2a.5.5 0 1 1 .62-.78l2.5 2Zm11.3 7.58a.5.5 0 0 0 .08.7l2.5 2a.5.5 0 1 0 .62-.78l-2.5-2a.5.5 0 0 0-.7.08Zm.08-7.58a.5.5 0 0 0 .62.78l2.5-2a.5.5 0 1 0-.62-.78l-2.5 2Z",
    fill: primaryFill
  }));
};

export const StarEmphasisFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarEmphasisFilledIcon, 'StarEmphasisFilled');

const StarEmphasisRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-3.12 3.05.73 4.3a1 1 0 0 1-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9Zm.9.44L8.07 7.25a1 1 0 0 1-.75.55L3 8.43l3.12 3.04a1 1 0 0 1 .3.89l-.75 4.3 3.87-2.03a1 1 0 0 1 .93 0l3.86 2.03-.74-4.3a1 1 0 0 1 .29-.89L17 8.43l-4.32-.63a1 1 0 0 1-.75-.55L10 3.35ZM4.4 12.7a.5.5 0 0 1-.08.7l-2.5 2a.5.5 0 1 1-.62-.78l2.5-2a.5.5 0 0 1 .7.08ZM4.31 5.1a.5.5 0 1 1-.62.78l-2.5-2a.5.5 0 1 1 .62-.78l2.5 2Zm11.3 7.58a.5.5 0 0 0 .08.7l2.5 2a.5.5 0 1 0 .62-.78l-2.5-2a.5.5 0 0 0-.7.08Zm.08-7.58a.5.5 0 0 0 .62.78l2.5-2a.5.5 0 1 0-.62-.78l-2.5 2Z",
    fill: primaryFill
  }));
};

export const StarEmphasisRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarEmphasisRegularIcon, 'StarEmphasisRegular');

const StarHalfFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2.34a.99.99 0 0 0-.9.56L7.17 6.8l-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05L10 15.51V2.34Z",
    fill: primaryFill
  }));
};

export const StarHalfFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarHalfFilledIcon, 'StarHalfFilled');

const StarHalfRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a.99.99 0 0 1 .9-.56c.36 0 .71.19.9.56l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-3.12 3.05.73 4.3a1 1 0 0 1-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9ZM10 14.5a1 1 0 0 1 .47.12l3.86 2.03-.74-4.3a1 1 0 0 1 .29-.89L17 8.43l-4.32-.63a1 1 0 0 1-.75-.55L10 3.35V14.5Z",
    fill: primaryFill
  }));
};

export const StarHalfRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarHalfRegularIcon, 'StarHalfRegular');

const StarLineHorizontal3FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 2.9a1 1 0 0 0-1.8 0L7.17 6.8l-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05L11 14.98V13.5c0-.83.67-1.5 1.5-1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1-.07-3L10.9 2.9Zm1.6 7.1a.5.5 0 1 0 0 1h5a.5.5 0 1 0 0-1h-5ZM12 7.5c0-.28.23-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 5.5a.5.5 0 1 0 0 1h5a.5.5 0 1 0 0-1h-5Z",
    fill: primaryFill
  }));
};

export const StarLineHorizontal3Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarLineHorizontal3FilledIcon, 'StarLineHorizontal3Filled');

const StarLineHorizontal3RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0L12.92 7h4.58a.5.5 0 1 1 0 1h-4.58a1 1 0 0 1-.9-.56L10 3.34 8.07 7.25a1 1 0 0 1-.75.55L3 8.43l3.12 3.04a1 1 0 0 1 .3.89l-.75 4.3 4.1-2.16a.5.5 0 0 1 .46.89l-4.09 2.15a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9Zm2.9 7.6c0-.28.22-.5.5-.5h5a.5.5 0 1 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
    fill: primaryFill
  }));
};

export const StarLineHorizontal3Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarLineHorizontal3RegularIcon, 'StarLineHorizontal3Regular');

const StarOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.86 2.15a.5.5 0 1 0-.71.7l4.1 4.1-3.4.49a1 1 0 0 0-.55 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05L10 15.51l3.86 2.03a1 1 0 0 0 1.45-1.05l-.1-.57 1.94 1.93a.5.5 0 0 0 .7-.7l-15-15Zm11.72 10.04.05.32-6.87-6.88L9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-3.12 3.05Z",
    fill: primaryFill
  }));
};

export const StarOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarOffFilledIcon, 'StarOffFilled');

const StarOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.86 2.15a.5.5 0 1 0-.71.7l4.1 4.1-3.4.49a1 1 0 0 0-.55 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05L10 15.51l3.86 2.03a1 1 0 0 0 1.45-1.05l-.1-.57 1.94 1.93a.5.5 0 0 0 .7-.7l-15-15ZM13.99 14.7l.34 1.96-3.86-2.03a1 1 0 0 0-.93 0l-3.87 2.03.74-4.3a1 1 0 0 0-.29-.89L3 8.43l4.12-.6L14 14.7Zm-.11-3.23a1 1 0 0 0-.13.16l.88.88-.05-.32 3.12-3.05a1 1 0 0 0-.56-1.7l-4.31-.63L10.9 2.9a1 1 0 0 0-1.8 0L7.76 5.63l.74.75L10 3.34l1.93 3.91c.15.3.43.5.75.55l4.32.63-3.12 3.04Z",
    fill: primaryFill
  }));
};

export const StarOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarOffRegularIcon, 'StarOffRegular');

const StarOneQuarterFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5.14 7.17 6.8l-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05L8 16.56V5.14Z",
    fill: primaryFill
  }));
};

export const StarOneQuarterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarOneQuarterFilledIcon, 'StarOneQuarterFilled');

const StarOneQuarterRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 2.9a1 1 0 0 0-1.8 0L8 5.13l-.83 1.68-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05L10 15.51l3.86 2.03a1 1 0 0 0 1.45-1.05l-.73-4.3 3.12-3.05a1 1 0 0 0-.55-1.7l-4.32-.63L10.9 2.9ZM8 15.43V7.37a1 1 0 0 0 .07-.12L10 3.35l1.93 3.9c.15.3.43.5.76.55l4.31.63-3.12 3.04a1 1 0 0 0-.29.89l.74 4.3-3.86-2.03a1 1 0 0 0-.93 0l-1.54.8Z",
    fill: primaryFill
  }));
};

export const StarOneQuarterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarOneQuarterRegularIcon, 'StarOneQuarterRegular');

const StarProhibitedFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-.55.54a5.5 5.5 0 0 0-7.96 6.26l-3.05 1.6a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9Zm.9 11.6a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.78 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z",
    fill: primaryFill
  }));
};

export const StarProhibitedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarProhibitedFilledIcon, 'StarProhibitedFilled');

const StarProhibitedRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 2.9a1 1 0 0 1 1.8 0l1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-.55.54a5.46 5.46 0 0 0-1-.43l.85-.82-4.32-.63a1 1 0 0 1-.75-.55L10 3.35l-1.93 3.9a1 1 0 0 1-.75.55L3 8.43l3.12 3.04a1 1 0 0 1 .3.89l-.75 4.3 3.35-1.76c.02.36.08.7.17 1.04l-3.05 1.6a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9Zm.9 11.6a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.78 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z",
    fill: primaryFill
  }));
};

export const StarProhibitedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarProhibitedRegularIcon, 'StarProhibitedRegular');

const StarSettingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 2.9a1 1 0 0 0-1.8 0L7.17 6.8l-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05l3.05-1.6a5.5 5.5 0 0 1 7.96-6.26l.55-.54a1 1 0 0 0-.56-1.7l-4.31-.63L10.9 2.9Zm-.27 11.02-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55a2 2 0 0 1-1.44 2.48Zm4.87.58a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: primaryFill
  }));
};

export const StarSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarSettingsFilledIcon, 'StarSettingsFilled');

const StarSettingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 2.9a1 1 0 0 0-1.8 0L7.17 6.8l-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05l3.05-1.6a5.49 5.49 0 0 1-.18-1.04l-3.34 1.76.74-4.3a1 1 0 0 0-.29-.89L3 8.43l4.32-.63a1 1 0 0 0 .75-.55L10 3.35l1.93 3.9c.15.3.43.5.75.55l4.32.63-.85.82c.35.11.69.26 1 .43l.55-.54a1 1 0 0 0-.56-1.7l-4.31-.63L10.9 2.9Zm-.27 11.02a2 2 0 0 0 1.44-2.48l-.16-.55c.25-.2.53-.37.82-.5l.34.36a2 2 0 0 0 2.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 0 0 1.46 2.52l.35.09a4.7 4.7 0 0 1 0 1.01l-.45.12a2 2 0 0 0-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 0 0-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 0 0-1.46-2.52l-.35-.09a4.71 4.71 0 0 1 0-1.01l.45-.12Zm4.87.58a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
    fill: primaryFill
  }));
};

export const StarSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarSettingsRegularIcon, 'StarSettingsRegular');

const StarThreeQuarterFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5.13 10.9 2.9a1 1 0 0 0-1.8 0L7.17 6.8l-4.31.63a1 1 0 0 0-.56 1.7l3.13 3.05-.74 4.3a1 1 0 0 0 1.45 1.05L10 15.51l2 1.05V5.13Z",
    fill: primaryFill
  }));
};

export const StarThreeQuarterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarThreeQuarterFilledIcon, 'StarThreeQuarterFilled');

const StarThreeQuarterRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m10.9 2.9 1.93 3.91 4.31.63a1 1 0 0 1 .56 1.7l-3.12 3.05.73 4.3a1 1 0 0 1-1.45 1.05L10 15.51l-3.86 2.03a1 1 0 0 1-1.45-1.05l.74-4.3L2.3 9.14a1 1 0 0 1 .56-1.7l4.31-.63L9.1 2.9a1 1 0 0 1 1.8 0ZM12 7.37v8.06l2.33 1.23-.74-4.3a1 1 0 0 1 .29-.89L17 8.43l-4.32-.63a1 1 0 0 1-.68-.43Z",
    fill: primaryFill
  }));
};

export const StarThreeQuarterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StarThreeQuarterRegularIcon, 'StarThreeQuarterRegular');

const StatusFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.35 2.65a2.62 2.62 0 0 0-3.7 0l-5.5 5.5a.5.5 0 0 0-.14.23l-1 4a.5.5 0 0 0 .61.6l4-1a.5.5 0 0 0 .23-.13l5.5-5.5a2.62 2.62 0 0 0 0-3.7Zm-1.4 6.53a6 6 0 1 1-5.12-5.12l.85-.86A7.02 7.02 0 0 0 3 10a7 7 0 1 0 13.8-1.68l-.86.86Z",
    fill: primaryFill
  }));
};

export const StatusFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StatusFilledIcon, 'StatusFilled');

const StatusRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.35 2.65a2.62 2.62 0 0 0-3.7 0l-5.5 5.5a.5.5 0 0 0-.14.23l-1 4a.5.5 0 0 0 .61.6l4-1a.5.5 0 0 0 .23-.13l5.5-5.5a2.62 2.62 0 0 0 0-3.7Zm-3 .7a1.62 1.62 0 0 1 2.3 2.3l-5.4 5.4-3.06.76.76-3.05 5.4-5.4ZM10 4c.28 0 .55.02.82.06l.86-.86A7.02 7.02 0 0 0 3 10a7 7 0 1 0 13.8-1.68l-.86.86A6 6 0 1 1 10 4Z",
    fill: primaryFill
  }));
};

export const StatusRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StatusRegularIcon, 'StatusRegular');

const StepsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4h-1V3h-3v3a1 1 0 0 1-1 1H8v3a1 1 0 0 1-1 1H4v3h4v1H4a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3V7a1 1 0 0 1 1-1h3V3Zm2 6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 1-2.5 2.5H10a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3V9Z",
    fill: primaryFill
  }));
};

export const StepsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StepsFilledIcon, 'StepsFilled');

const StepsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4h-1V3h-3v3a1 1 0 0 1-1 1H8v3a1 1 0 0 1-1 1H4v3h4v1H4a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3V7a1 1 0 0 1 1-1h3V3Zm3 5a1 1 0 0 0-1 1v3h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5.5a2.5 2.5 0 0 0 2.5-2.5V9a1 1 0 0 0-1-1h-3Zm0 1h3v5.5c0 .83-.67 1.5-1.5 1.5H10v-3h3a1 1 0 0 0 1-1V9Z",
    fill: primaryFill
  }));
};

export const StepsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StepsRegularIcon, 'StepsRegular');

const StethoscopeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 2a.75.75 0 0 0-.75.75v5a4.5 4.5 0 0 0 3.75 4.44v1.06a5.25 5.25 0 1 0 10.5 0v-1.1a2.75 2.75 0 1 0-1.5 0v1.1a3.75 3.75 0 1 1-7.5 0v-1.06A4.5 4.5 0 0 0 11 7.75v-5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5h.75v4.25a3 3 0 1 1-6 0V3.5h.75a.75.75 0 0 0 0-1.5h-1.5ZM15.5 8.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z",
    fill: primaryFill
  }));
};

export const StethoscopeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StethoscopeFilledIcon, 'StethoscopeFilled');

const StethoscopeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 2a.5.5 0 0 0-.5.5v5a4.5 4.5 0 0 0 4 4.47V13a5 5 0 0 0 10 0v-1.05a2.5 2.5 0 1 0-1 0V13a4 4 0 1 1-8 0v-1.03a4.5 4.5 0 0 0 4-4.47v-5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1H10v4.5a3.5 3.5 0 0 1-7 0V3h1.5a.5.5 0 0 0 0-1h-2Zm13 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: primaryFill
  }));
};

export const StethoscopeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StethoscopeRegularIcon, 'StethoscopeRegular');

const StickerFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h5v-3.08a5.87 5.87 0 0 1-3.47-.47 4.2 4.2 0 0 1-.86-.57l-.01-.02h-.01a.5.5 0 0 1 .7-.72 1 1 0 0 0 .14.12c.1.07.26.18.48.3A4.5 4.5 0 0 0 10 13c.43 0 .81-.05 1.15-.14a2.75 2.75 0 0 1 2.6-1.86H17V6a3 3 0 0 0-3-3H6Zm1.5 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.7 8.41a2 2 0 0 1-.8.5v-3.16c0-.97.78-1.75 1.75-1.75h3.15a2 2 0 0 1-.49.8L12.8 16.4Z",
    fill: primaryFill
  }));
};

export const StickerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickerFilledIcon, 'StickerFilled');

const StickerRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM3 6v8a3 3 0 0 0 3 3h5.38a1.97 1.97 0 0 0 1.41-.59l3.62-3.62a2 2 0 0 0 .59-1.41V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3Zm13 0v5h-2.25c-1.2 0-2.24.78-2.6 1.86-.34.09-.72.14-1.15.14a4.5 4.5 0 0 1-2.51-.74 1.97 1.97 0 0 1-.14-.11.5.5 0 0 0-.7.7v.01l.02.02a2 2 0 0 0 .22.18 5.5 5.5 0 0 0 4.11.86V16H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2Zm-3.91 9.7a1 1 0 0 1-.09.08v-2.03c0-.97.78-1.75 1.75-1.75h2.03l-.07.09-3.62 3.62Z",
    fill: primaryFill
  }));
};

export const StickerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickerRegularIcon, 'StickerRegular');

const StickerAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6a5.5 5.5 0 0 0-7.78 3.34 4.23 4.23 0 0 1-1.73-.68 1.97 1.97 0 0 1-.14-.11.5.5 0 0 0-.7.7v.01l.02.02a2 2 0 0 0 .22.18 5.22 5.22 0 0 0 2.14.87A5.56 5.56 0 0 0 9.6 17H6a3 3 0 0 1-3-3V6Zm4.5 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6-1a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm5.5 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const StickerAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickerAddFilledIcon, 'StickerAddFilled');

const StickerAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6c-.32-.16-.65-.3-1-.4V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h3.2c.1.35.24.68.4 1H6a3 3 0 0 1-3-3V6Zm4.97 6.55c.3.15.72.31 1.25.4-.09.3-.16.64-.19.97a5.22 5.22 0 0 1-2.14-.86 2.93 2.93 0 0 1-.22-.18l-.01-.02h-.01a.5.5 0 0 1 .7-.72 1 1 0 0 0 .14.12c.1.07.26.18.48.3ZM7.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5.5 6.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const StickerAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickerAddRegularIcon, 'StickerAddRegular');

const StopFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v11c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-11Z",
    fill: primaryFill
  }));
};

export const StopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StopFilledIcon, 'StopFilled');

const StopRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 4c.28 0 .5.22.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11c0-.28.22-.5.5-.5h11Zm-11-1C3.67 3 3 3.67 3 4.5v11c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5h-11Z",
    fill: primaryFill
  }));
};

export const StopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StopRegularIcon, 'StopRegular');

const StorageFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8.5A2.5 2.5 0 0 1 4.5 6h11A2.5 2.5 0 0 1 18 8.5v3a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 11.5v-3ZM13 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
    fill: primaryFill
  }));
};

export const StorageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StorageFilledIcon, 'StorageFilled');

const StorageRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM2 8.5A2.5 2.5 0 0 1 4.5 6h11A2.5 2.5 0 0 1 18 8.5v3a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 11.5v-3ZM4.5 7C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11Z",
    fill: primaryFill
  }));
};

export const StorageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StorageRegularIcon, 'StorageRegular');

const StoreMicrosoftFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5V4H2.5a.5.5 0 0 0-.5.5v10A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5v-10a.5.5 0 0 0-.5-.5H13V2.5c0-.83-.67-1.5-1.5-1.5h-3C7.67 1 7 1.67 7 2.5ZM8.5 2h3c.28 0 .5.22.5.5V4H8V2.5c0-.28.22-.5.5-.5Zm-2 8V7h3v3h-3Zm0 4v-3h3v3h-3Zm7-4h-3V7h3v3Zm-3 4v-3h3v3h-3Z",
    fill: primaryFill
  }));
};

export const StoreMicrosoftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StoreMicrosoftFilledIcon, 'StoreMicrosoftFilled');

const StoreMicrosoftRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 7v3h-3V7h3Zm0 7v-3h-3v3h3Zm4-7v3h-3V7h3Zm0 7v-3h-3v3h3ZM7 4V2.5C7 1.67 7.67 1 8.5 1h3c.83 0 1.5.67 1.5 1.5V4h4.5c.28 0 .5.22.5.5v10a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 14.5v-10c0-.28.22-.5.5-.5H7Zm1-1.5V4h4V2.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Zm-5 12c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V5H3v9.5Z",
    fill: primaryFill
  }));
};

export const StoreMicrosoftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StoreMicrosoftRegularIcon, 'StoreMicrosoftRegular');

const StreamFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 9.25a5.75 5.75 0 0 1 5.75-5.75h.5a.75.75 0 0 0 0-1.5h-.5C9.25 2 6 5.25 6 9.25v1c0 .41-.34.75-.75.75h-2.5a.75.75 0 0 0 0 1.5h2.5c1.24 0 2.25-1 2.25-2.25v-1Zm6.25-3A3.25 3.25 0 0 0 10.5 9.5v1a4.75 4.75 0 0 1-4.75 4.75h-3a.75.75 0 0 1 0-1.5h3c1.8 0 3.25-1.46 3.25-3.25v-1a4.75 4.75 0 0 1 4.75-4.75h3.5a.75.75 0 0 1 0 1.5h-3.5Zm.5 2.75a.75.75 0 0 0-.75.75v1c0 4-3.25 7.25-7.25 7.25h-.5a.75.75 0 0 1 0-1.5h.5A5.75 5.75 0 0 0 12 10.75v-1c0-1.24 1-2.25 2.25-2.25h3a.75.75 0 0 1 0 1.5h-3Z",
    fill: primaryFill
  }));
};

export const StreamFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamFilledIcon, 'StreamFilled');

const StreamRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 9a6 6 0 0 1 6-6h.5a.5.5 0 0 0 0-1H13a7 7 0 0 0-7 7v1a1 1 0 0 1-1 1H2.5a.5.5 0 0 0 0 1H5a2 2 0 0 0 2-2V9Zm6.5-3A3.5 3.5 0 0 0 10 9.5v1A4.5 4.5 0 0 1 5.5 15h-3a.5.5 0 0 1 0-1h3A3.5 3.5 0 0 0 9 10.5v-1A4.5 4.5 0 0 1 13.5 5h4a.5.5 0 0 1 0 1h-4Zm.5 3a1 1 0 0 0-1 1v1a7 7 0 0 1-7 7h-.5a.5.5 0 0 1 0-1H6a6 6 0 0 0 6-6v-1c0-1.1.9-2 2-2h3.5a.5.5 0 0 1 0 1H14Z",
    fill: primaryFill
  }));
};

export const StreamRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamRegularIcon, 'StreamRegular');

const StreamInputFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 9.25a5.75 5.75 0 0 1 5.75-5.75h.5a.75.75 0 0 0 0-1.5h-.5C9.25 2 6 5.25 6 9.25v1c0 .41-.34.75-.75.75H4.9l1.3 1.3a2.25 2.25 0 0 0 1.3-2.05v-1ZM6.4 16.5l-1.23 1.23c.14.16.35.27.58.27h.5c4 0 7.25-3.25 7.25-7.25v-1c0-.41.34-.75.75-.75h3a.75.75 0 0 0 0-1.5h-3c-1.24 0-2.25 1-2.25 2.25v1c0 3.12-2.5 5.67-5.6 5.75Zm.8-3.09c.26.48.34 1.02.23 1.53a4.75 4.75 0 0 0 3.07-4.44v-1c0-1.8 1.46-3.25 3.25-3.25h3.5a.75.75 0 0 0 0-1.5h-3.5A4.75 4.75 0 0 0 9 9.5v1c0 1.28-.74 2.38-1.8 2.91Zm-5.48-2.44c.3-.3.77-.3 1.06 0l3 3c.3.3.3.77 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72H.75a.75.75 0 0 1 0-1.5h2.69l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
    fill: primaryFill,
    opacity: 0.79
  }));
};

export const StreamInputFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamInputFilledIcon, 'StreamInputFilled');

const StreamInputRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 9a6 6 0 0 1 6-6h.5a.5.5 0 0 0 0-1H13a7 7 0 0 0-7 7v1a1 1 0 0 1-1 1h-.9l1 1A2 2 0 0 0 7 10V9ZM.5 14a.5.5 0 0 0 0 1h3.68l-2.14 2.15a.5.5 0 0 0 .7.7l3-2.99a.5.5 0 0 0 0-.72l-3-3a.5.5 0 0 0-.7.71L4.18 14H.5Zm9.5-3.5a4.5 4.5 0 0 1-3.15 4.3c.06-.35.01-.7-.12-1.02A3.5 3.5 0 0 0 9 10.5v-1A4.5 4.5 0 0 1 13.5 5h4a.5.5 0 0 1 0 1h-4A3.5 3.5 0 0 0 10 9.5v1ZM14 9a1 1 0 0 0-1 1v1a7 7 0 0 1-7 7h-.5a.5.5 0 0 1 0-1H6a6 6 0 0 0 6-6v-1c0-1.1.9-2 2-2h3.5a.5.5 0 0 1 0 1H14Z",
    fill: primaryFill
  }));
};

export const StreamInputRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamInputRegularIcon, 'StreamInputRegular');

const StreamInputOutputFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.25 3.5A5.75 5.75 0 0 0 7.5 9.25v1c0 1.24-1 2.25-2.25 2.25h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75-.34.75-.75v-1C6 5.25 9.25 2 13.25 2h.5a.75.75 0 0 1 0 1.5h-.5Zm-2.75 6c0-1.8 1.46-3.25 3.25-3.25h3.5a.75.75 0 0 0 0-1.5h-3.5A4.75 4.75 0 0 0 9 9.5v1c0 1.8-1.46 3.25-3.25 3.25h-3a.75.75 0 0 0 0 1.5h3a4.75 4.75 0 0 0 4.75-4.75v-1Zm3.75-.5a.75.75 0 0 0-.75.75v1c0 .66-.09 1.3-.25 1.9a1.9 1.9 0 0 0-1.59.05c.22-.61.34-1.27.34-1.95v-1c0-1.24 1-2.25 2.25-2.25h3a.75.75 0 0 1 0 1.5h-3Zm-1.4 9.16a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7l-1.14 1.16h5.58l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2c.2.19.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l1.14-1.15h-5.58l1.14 1.14Z",
    fill: primaryFill
  }));
};

export const StreamInputOutputFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamInputOutputFilledIcon, 'StreamInputOutputFilled');

const StreamInputOutputRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 3a6 6 0 0 0-6 6v1a2 2 0 0 1-2 2H2.5a.5.5 0 0 1 0-1H5a1 1 0 0 0 1-1V9a7 7 0 0 1 7-7h.5a.5.5 0 0 1 0 1H13Zm-3 6.5A3.5 3.5 0 0 1 13.5 6h4a.5.5 0 0 0 0-1h-4A4.5 4.5 0 0 0 9 9.5v1A3.5 3.5 0 0 1 5.5 14h-3a.5.5 0 0 0 0 1h3a4.5 4.5 0 0 0 4.5-4.5v-1Zm3 .5c0-.6.4-1 1-1h3.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H14a2 2 0 0 0-2 2v1c0 .9-.2 1.7-.5 2.4.3-.2.6-.4 1-.4h.2c.2-.6.3-1.3.3-2v-1Zm-.15 8.16a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7l-1.14 1.16h5.58l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2c.2.19.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7l1.14-1.15h-5.58l1.14 1.14Z",
    fill: primaryFill
  }));
};

export const StreamInputOutputRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamInputOutputRegularIcon, 'StreamInputOutputRegular');

const StreamOutputFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.78 1.97a.75.75 0 1 0-1.06 1.06l1.72 1.72h-3.69A4.75 4.75 0 0 0 9 9.5v1c0 1.8-1.46 3.25-3.25 3.25h-3a.75.75 0 0 0 0 1.5h3a4.75 4.75 0 0 0 4.75-4.75v-1c0-1.8 1.46-3.25 3.25-3.25h3.69l-1.72 1.72a.75.75 0 0 0 1.06 1.06l3-3c.3-.3.3-.77 0-1.06l-3-3ZM13.25 3.5A5.75 5.75 0 0 0 7.5 9.25v1c0 1.24-1 2.25-2.25 2.25h-2.5a.75.75 0 0 1 0-1.5h2.5c.41 0 .75-.34.75-.75v-1C6 5.25 9.25 2 13.25 2h.5a.75.75 0 0 1 0 1.5h-.5Zm.91 4c-.24.49-.3 1.03-.17 1.54-.28.1-.49.39-.49.71v1c0 4-3.25 7.25-7.25 7.25h-.5a.75.75 0 0 1 0-1.5h.5A5.75 5.75 0 0 0 12 10.75v-1c0-1.21.96-2.2 2.16-2.25Z",
    fill: primaryFill
  }));
};

export const StreamOutputFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamOutputFilledIcon, 'StreamOutputFilled');

const StreamOutputRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.15 2.15c.2-.2.5-.2.7 0l3 2.99a.5.5 0 0 1 0 .72l-3 3a.5.5 0 0 1-.7-.71L18.29 6H13.5C11.6 6 10 7.6 10 9.5v1C10 13 8 15 5.5 15h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3C7.4 14 9 12.4 9 10.5v-1C9 7 11 5 13.5 5h4.8l-2.15-2.15a.5.5 0 0 1 0-.7ZM2.5 12H5a2 2 0 0 0 2-2V9c0-3.3 2.7-6 6-6h.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H13C9.1 2 6 5.1 6 9v1c0 .6-.4 1-1 1H2.5c-.3 0-.5.2-.5.5s.2.5.5.5Zm12.6-4H14a2 2 0 0 0-2 2v1c0 3.3-2.7 6-6 6h-.5c-.3 0-.5.2-.5.5s.2.5.5.5H6c3.9 0 7-3.1 7-7v-1c0-.6.4-1 1-1h1.1c-.1-.3-.1-.7 0-1Z",
    fill: primaryFill
  }));
};

export const StreamOutputRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamOutputRegularIcon, 'StreamOutputRegular');

const StyleGuideFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.82 17.26c.07.27.19.52.33.74H7a2 2 0 0 1-2-2v-5.54l1.82 6.8ZM4 16.5c0 .15.01.3.04.44l-.06-.01a2 2 0 0 1-1.41-2.45l1.42-5.34L4 16.5Zm3.65.02a2 2 0 0 0 2.46 1.41l5.41-1.45a2 2 0 0 0 1.41-2.45L14.1 3.48a2 2 0 0 0-2.45-1.41L6.23 3.52a2 2 0 0 0-1.41 2.45l2.83 10.55ZM9 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    fill: primaryFill
  }));
};

export const StyleGuideFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StyleGuideFilledIcon, 'StyleGuideFilled');

const StyleGuideRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.62 16.26a1 1 0 0 0 1.23.7l5.41-1.45a1 1 0 0 0 .7-1.22L13.14 3.74a1 1 0 0 0-1.22-.7L6.49 4.48a1 1 0 0 0-.7 1.22l2.83 10.55Zm1.49 1.67a2 2 0 0 1-2.46-1.41L4.82 5.97a2 2 0 0 1 1.41-2.45l5.42-1.45a2 2 0 0 1 2.45 1.41l2.83 10.55a2 2 0 0 1-1.4 2.45l-5.42 1.45ZM7 18h.14a2.48 2.48 0 0 1-.33-.74l-.08-.3A1 1 0 0 1 6 16v-1.79l-1-3.73V16a2 2 0 0 0 2 2ZM4 16.5c0 .15.01.3.04.45l-.06-.02a2 2 0 0 1-1.41-2.45l1.42-5.33v3.86l-.46 1.73A1 1 0 0 0 4 15.86v.64Zm4.25-11a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const StyleGuideRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StyleGuideRegularIcon, 'StyleGuideRegular');

const SubGridFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 10.5v2c0 .83.67 1.5 1.5 1.5h2v-3.5H6Zm0-1v-2C6 6.67 6.67 6 7.5 6h2v3.5H6ZM10.5 6v3.5H14v-2c0-.83-.67-1.5-1.5-1.5h-2Zm3.5 4.5h-3.5V14h2c.83 0 1.5-.67 1.5-1.5v-2ZM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm-2 7.5h2v-1H4V6c0-1.1.9-2 2-2h3.5v2h1V4H14a2 2 0 0 1 2 2v3.5h-2v1h2V14a2 2 0 0 1-2 2h-3.5v-2h-1v2H6a2 2 0 0 1-2-2v-3.5Z",
    fill: primaryFill
  }));
};

export const SubGridFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubGridFilledIcon, 'SubGridFilled');

const SubGridRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 14v-3.5h2v2c0 .83.67 1.5 1.5 1.5h2v2H6a2 2 0 0 1-2-2Zm6.5 0h2c.83 0 1.5-.67 1.5-1.5v-2h2V14a2 2 0 0 1-2 2h-3.5v-2Zm2.5-3.5v2a.5.5 0 0 1-.5.5h-2v-2.5H13Zm1-1v-2c0-.83-.67-1.5-1.5-1.5h-2V4H14a2 2 0 0 1 2 2v3.5h-2ZM10.5 7h2c.28 0 .5.22.5.5v2h-2.5V7Zm-1-1h-2C6.67 6 6 6.67 6 7.5v2H4V6c0-1.1.9-2 2-2h3.5v2ZM7 9.5v-2c0-.28.22-.5.5-.5h2v2.5H7Zm0 1h2.5V13h-2a.5.5 0 0 1-.5-.5v-2Z",
    fill: primaryFill
  }));
};

export const SubGridRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubGridRegularIcon, 'SubGridRegular');

const SubtitlesFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25v-6.5Zm2 4.75c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5Zm.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm8.5-1.5c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5ZM9.5 13a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z",
    fill: primaryFill
  }));
};

export const SubtitlesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtitlesFilledIcon, 'SubtitlesFilled');

const SubtitlesRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25v-6.5ZM4.75 5C3.78 5 3 5.78 3 6.75v6.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75v-6.5C17 5.78 16.22 5 15.25 5H4.75ZM4 11.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm8.5-1.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM9.5 13a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z",
    fill: primaryFill
  }));
};

export const SubtitlesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtitlesRegularIcon, 'SubtitlesRegular');

const SubtractFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("rect", {
    x: 3,
    y: 9.25,
    width: 14,
    height: 1.5,
    rx: 0.75,
    fill: primaryFill
  }));
};

export const SubtractFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractFilledIcon, 'SubtractFilled');

const SubtractRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("rect", {
    x: 3,
    y: 9.5,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: primaryFill
  }));
};

export const SubtractRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractRegularIcon, 'SubtractRegular');

const SubtractCircleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM6 10c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5Z",
    fill: primaryFill
  }));
};

export const SubtractCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleFilledIcon, 'SubtractCircleFilled');

const SubtractCircleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 10c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 6 10Zm4 8a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-1a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z",
    fill: primaryFill
  }));
};

export const SubtractCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleRegularIcon, 'SubtractCircleRegular');

const SubtractCircleArrowBackFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.98 9.59 17 9a8 8 0 1 0-7.41 7.98A5.48 5.48 0 0 1 12.2 9.5H5.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .45.72 5.5 5.5 0 0 1 4.03.37ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.4-2.6a.5.5 0 0 0-.7 0l-1.75 1.75a.5.5 0 0 0 0 .7l1.75 1.75a.5.5 0 0 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75h-1.54l.9-.9a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const SubtractCircleArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleArrowBackFilledIcon, 'SubtractCircleArrowBackFilled');

const SubtractCircleArrowBackRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 8.5a.5.5 0 0 0 0 1h6.7c.24-.11.5-.2.75-.28a.5.5 0 0 0-.45-.72h-7Zm10.5.7V9a7 7 0 1 0-6.8 7c.1.34.23.67.39.98L9 17a8 8 0 1 1 7.98-7.41A5.46 5.46 0 0 0 16 9.2Zm3 5.3a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.4-2.6a.5.5 0 0 0-.7 0l-1.75 1.75a.5.5 0 0 0 0 .7l1.75 1.75a.5.5 0 0 0 .7-.7l-.9-.9h1.55c.97 0 1.75.78 1.75 1.75v.25a.5.5 0 0 0 1 0v-.25a2.75 2.75 0 0 0-2.75-2.75h-1.54l.9-.9a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const SubtractCircleArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleArrowBackRegularIcon, 'SubtractCircleArrowBackRegular');

const SubtractCircleArrowForwardFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.98 9.59 17 9a8 8 0 1 0-7.41 7.98A5.48 5.48 0 0 1 12.2 9.5H5.5a.5.5 0 0 1 0-1h7a.5.5 0 0 1 .45.72 5.5 5.5 0 0 1 4.03.37ZM10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 0 1 0 .7L16.1 16.1a.5.5 0 0 1-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 0 1-1 0v-.25a2.75 2.75 0 0 1 2.75-2.75h1.54l-.9-.9a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const SubtractCircleArrowForwardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleArrowForwardFilledIcon, 'SubtractCircleArrowForwardFilled');

const SubtractCircleArrowForwardRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 8.5a.5.5 0 0 0 0 1h6.7c.24-.11.5-.2.75-.28a.5.5 0 0 0-.45-.72h-7Zm10.5.7V9a7 7 0 1 0-6.8 7c.1.34.23.67.39.98L9 17a8 8 0 1 1 7.98-7.41A5.46 5.46 0 0 0 16 9.2Zm-6 5.3a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm5.4-2.6c.2-.2.5-.2.7 0l1.75 1.75a.5.5 0 0 1 0 .7L16.1 16.1a.5.5 0 0 1-.7-.7l.9-.9h-1.55c-.97 0-1.75.78-1.75 1.75v.25a.5.5 0 0 1-1 0v-.25a2.75 2.75 0 0 1 2.75-2.75h1.54l-.9-.9a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const SubtractCircleArrowForwardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractCircleArrowForwardRegularIcon, 'SubtractCircleArrowForwardRegular');

const SubtractSquareFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm.5 6.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Z",
    fill: primaryFill
  }));
};

export const SubtractSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractSquareFilledIcon, 'SubtractSquareFilled');

const SubtractSquareRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 9.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z",
    fill: primaryFill
  }));
};

export const SubtractSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractSquareRegularIcon, 'SubtractSquareRegular');

const SubtractSquareMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 5.27c.6.34 1 .99 1 1.73v6a4 4 0 0 1-4 4H7a2 2 0 0 1-1.73-1H13a3 3 0 0 0 3-3V5.27ZM15 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5Zm-3 4a.5.5 0 0 1-.5.5h-5a.5.5 0 1 1 0-1h5c.28 0 .5.22.5.5Z",
    fill: primaryFill
  }));
};

export const SubtractSquareMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractSquareMultipleFilledIcon, 'SubtractSquareMultipleFilled');

const SubtractSquareMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 5.27V13a3 3 0 0 1-3 3H5.27c.34.6.99 1 1.73 1h6a4 4 0 0 0 4-4V7a2 2 0 0 0-1-1.73ZM11.5 9.5a.5.5 0 0 0 0-1h-5a.5.5 0 1 0 0 1h5ZM13 3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8Zm1 2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5Z",
    fill: primaryFill
  }));
};

export const SubtractSquareMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SubtractSquareMultipleRegularIcon, 'SubtractSquareMultipleRegular');

const SurfaceEarbudsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.55 14.03a5.75 5.75 0 0 0 2.9 4.24l-1.4.57a2 2 0 0 1-2.37-.66l-.27-.37a2 2 0 0 1 .06-2.44l1.08-1.34Zm5.7-5.53a4.75 4.75 0 1 1 0 9.5 4.75 4.75 0 0 1 0-9.5ZM5.75 1c.2 0 .39.01.58.03l.28.05-.14.04A3.72 3.72 0 0 0 4.54 6.6a3.65 3.65 0 0 0 5.75.56A4.75 4.75 0 1 1 5.75 1Zm5.37.46.09.1.09.12.44.65a1.5 1.5 0 0 1-.03 1.72l-.09.12-1.88 2.18a2.65 2.65 0 0 1-4.26-.18 2.72 2.72 0 0 1 1.43-4.1l2.62-.97a1.5 1.5 0 0 1 1.59.36Zm-1.14.68a.5.5 0 0 0-.2.61l.03.08.26.43.06.07a.5.5 0 0 0 .84-.5l-.04-.09-.26-.43-.05-.07a.5.5 0 0 0-.64-.1Z",
    fill: primaryFill
  }));
};

export const SurfaceEarbudsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SurfaceEarbudsFilledIcon, 'SurfaceEarbudsFilled');

const SurfaceEarbudsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.13 8.25a4.87 4.87 0 1 1-1.1 9.63l-.1.03-2.21.9c-1 .41-2.15.13-2.85-.68l-.1-.15-.28-.36a2.5 2.5 0 0 1-.04-2.91l.1-.15 1.58-1.94.17-.2a4.87 4.87 0 0 1 4.83-4.17Zm-4.8 5.72-1 1.22a1.5 1.5 0 0 0-.12 1.71l.08.12.28.37a1.5 1.5 0 0 0 1.63.55l.14-.05 1.34-.55a4.88 4.88 0 0 1-2.36-3.37Zm4.8-4.72a3.88 3.88 0 0 0-3.76 2.93l-.07.3-.03.25-.01.18v.21c0 1.78 1.18 3.28 2.81 3.74l.2.04.22.05.2.02.17.02H14.33a3.88 3.88 0 0 0-.2-7.74ZM5.88 1c.66 0 1.29.13 1.86.37l.7-.23a2.5 2.5 0 0 1 2.66.73l.12.14.12.17.29.46c.53.84.5 1.91-.05 2.74l-.1.15-.13.14-.62.67A4.88 4.88 0 1 1 5.88 1Zm-.04 1h.04A3.87 3.87 0 1 0 9.1 8.02l-.06.04-.2.13a3.44 3.44 0 0 1-4.77-1.05A3.5 3.5 0 0 1 5.61 2.1l.23-.1Zm4.58.61a1.5 1.5 0 0 0-1.53-.56l-.14.04-2.36.78a2.5 2.5 0 0 0-1.46 3.74 2.44 2.44 0 0 0 3.75.46l.16-.16L10.6 5l.1-.11a1.5 1.5 0 0 0 .15-1.6l-.07-.12-.28-.45-.08-.12Zm-.8.53.05.08.26.42a.5.5 0 0 1-.8.6l-.06-.08-.26-.43a.5.5 0 0 1 .8-.59Z",
    fill: primaryFill
  }));
};

export const SurfaceEarbudsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SurfaceEarbudsRegularIcon, 'SurfaceEarbudsRegular');

const SurfaceHubFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.26 2a.5.5 0 0 0-.5.45l-.76 8a.5.5 0 0 0 .5.55h2.42l-.91 6.43a.5.5 0 0 0 .98.14L7.36 15h3L10 17.43a.5.5 0 0 0 .98.14l.37-2.57h2.28l.37 2.57a.5.5 0 0 0 .98-.14L14.08 11h.66a.5.5 0 0 0 .5-.45l.76-8a.5.5 0 0 0-.5-.55H5.26Zm8.23 12h-1.98l.42-3h1.14l.42 3Zm-3 0H7.51l.42-3h3l-.44 3Z",
    fill: primaryFill
  }));
};

export const SurfaceHubFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SurfaceHubFilledIcon, 'SurfaceHubFilled');

const SurfaceHubRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.76 2.45a.5.5 0 0 1 .5-.45H15.5a.5.5 0 0 1 .5.55l-.76 8a.5.5 0 0 1-.5.45h-.66l.91 6.43a.5.5 0 0 1-.98.14L13.64 15h-2.28L11 17.57a.5.5 0 0 1-.98-.14l.34-2.43H7.36L7 17.57a.5.5 0 0 1-.98-.14L6.92 11H4.5a.5.5 0 0 1-.5-.55l.76-8ZM7.51 14h2.98l.43-3H7.93l-.42 3Zm4 0h1.98l-.42-3h-1.14l-.42 3Zm2.78-4 .66-7H5.71l-.66 7h9.24Z",
    fill: primaryFill
  }));
};

export const SurfaceHubRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SurfaceHubRegularIcon, 'SurfaceHubRegular');

const SwimmingPoolFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.75 4a.75.75 0 0 0-.75.75v.5a.75.75 0 0 1-1.5 0v-.5a2.25 2.25 0 0 1 4.5 0V7.5h5V4.75a.75.75 0 1 0-1.5 0v.5a.75.75 0 1 1-1.5 0v-.5a2.25 2.25 0 0 1 4.5 0v7.03c-.4.13-.91.23-1.5.22V9H8v1.23A7.16 7.16 0 0 0 6.5 10V4.75A.75.75 0 0 0 5.75 4Zm.06 8.53c-.8.09-1.35.42-1.6.61a.75.75 0 0 1-.9-1.2c.4-.31 1.2-.77 2.33-.9a6.84 6.84 0 0 1 4.24 1.05c2.93 1.7 5.3.58 6 .17a.75.75 0 1 1 .75 1.3 7.33 7.33 0 0 1-7.5-.17 5.36 5.36 0 0 0-3.32-.86Zm0 3c-.8.09-1.35.42-1.6.61a.75.75 0 0 1-.9-1.2c.4-.31 1.2-.77 2.33-.9a6.84 6.84 0 0 1 4.24 1.05c2.93 1.7 5.3.58 6 .17a.75.75 0 1 1 .75 1.3 7.33 7.33 0 0 1-7.5-.17 5.36 5.36 0 0 0-3.32-.86Z",
    fill: primaryFill
  }));
};

export const SwimmingPoolFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SwimmingPoolFilledIcon, 'SwimmingPoolFilled');

const SwimmingPoolRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 5a1 1 0 0 1 2 0v5.05c.32.03.65.1 1 .19V9h5v3c.37 0 .7-.03 1-.09V5a2 2 0 1 0-4 0v.5a.5.5 0 0 0 1 0V5a1 1 0 1 1 2 0v3H8V5a2 2 0 1 0-4 0v.5a.5.5 0 0 0 1 0V5Zm8.08 9a7.6 7.6 0 0 1-3.83-1.08c-3.42-1.97-5.32-.15-5.39-.08a.5.5 0 0 1-.71 0 .48.48 0 0 1 0-.7c.1-.1 2.48-2.46 6.6-.1a6 6 0 0 0 6.45.05c.22-.16.53-.11.7.1a.5.5 0 0 1-.1.7 6.65 6.65 0 0 1-3.72 1.1V14Zm-3.83 1.92A7.6 7.6 0 0 0 13.08 17v-.01a6.65 6.65 0 0 0 3.71-1.1.5.5 0 0 0 .11-.7.51.51 0 0 0-.7-.1 6 6 0 0 1-6.44-.04c-4.13-2.37-6.5 0-6.61.1-.2.19-.2.5 0 .7.2.19.52.18.71 0 .07-.08 1.97-1.9 5.39.07Z",
    fill: primaryFill
  }));
};

export const SwimmingPoolRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SwimmingPoolRegularIcon, 'SwimmingPoolRegular');

const SwipeDownFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 6a4 4 0 0 1-2.25 3.6V8.44a3 3 0 1 0-3.5 0V9.6A4 4 0 1 1 14 6ZM9.47 17.78c.3.3.77.3 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06l-1.22 1.22V5.75a.75.75 0 0 0-1.5 0v9.69l-1.22-1.22a.75.75 0 0 0-1.06 1.06l2.5 2.5Z",
    fill: primaryFill
  }));
};

export const SwipeDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SwipeDownFilledIcon, 'SwipeDownFilled');

const SwipeDownRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 6a4 4 0 0 1-2.5 3.7V8.6a3 3 0 1 0-3 0v1.1A4 4 0 1 1 14 6ZM9.65 17.85c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7l-2.15 2.14V5.5a.5.5 0 0 0-1 0v10.8l-2.15-2.15a.5.5 0 1 0-.7.7l3 3Z",
    fill: primaryFill
  }));
};

export const SwipeDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SwipeDownRegularIcon, 'SwipeDownRegular');

const SwipeRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6a4 4 0 0 1 3.6 2.25H8.44a3 3 0 1 0 0 3.5H9.6A4 4 0 1 1 6 6Zm9.28 7.03 2.5-2.5c.3-.3.3-.77 0-1.06l-2.5-2.5a.75.75 0 0 0-1.06 1.06l1.22 1.22H5.75a.75.75 0 1 0 0 1.5h9.69l-1.22 1.22a.75.75 0 1 0 1.06 1.06Z",
    fill: primaryFill
  }));
};

export const SwipeRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SwipeRightFilledIcon, 'SwipeRightFilled');

const SwipeRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6a4 4 0 0 1 3.7 2.5H8.6a3 3 0 1 0 0 3h1.1A4 4 0 1 1 6 6Zm8.85 7.35 3-3a.5.5 0 0 0 0-.7l-3-3a.5.5 0 1 0-.7.7l2.14 2.15H5.5a.5.5 0 0 0 0 1h10.8l-2.15 2.15a.5.5 0 0 0 .7.7Z",
    fill: primaryFill
  }));
};

export const SwipeRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SwipeRightRegularIcon, 'SwipeRightRegular');

const SwipeUpFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.53 2.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v9.69a.75.75 0 0 0 1.5 0V4.56l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5ZM6 14a4 4 0 0 1 2.25-3.6v1.16a3 3 0 1 0 3.5 0V10.4A4 4 0 1 1 6 14Z",
    fill: primaryFill
  }));
};

export const SwipeUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SwipeUpFilledIcon, 'SwipeUpFilled');

const SwipeUpRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.35 2.15a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L9.5 3.71V14.5a.5.5 0 0 0 1 0V3.7l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3ZM6 14a4 4 0 0 1 2.5-3.7v1.1a3 3 0 1 0 3 0v-1.1A4 4 0 1 1 6 14Z",
    fill: primaryFill
  }));
};

export const SwipeUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SwipeUpRegularIcon, 'SwipeUpRegular');

const SymbolsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.14 7.97c.2.2.51.2.7 0l2.56-2.55a2 2 0 1 0-2.83-2.83l-.07.08-.08-.08a2 2 0 0 0-2.83 2.83l2.55 2.55ZM2 5.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM5.5 3c-.5 0-.98.16-1.38.42L7.6 6.88A2.5 2.5 0 0 0 5.5 3ZM3 5.5A2.5 2.5 0 0 0 6.88 7.6L3.4 4.12C3.15 4.52 3 5 3 5.5Zm9.34 7.75A2.5 2.5 0 0 1 16.5 13h-1a.5.5 0 1 0 0 1h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v.55a3.49 3.49 0 0 0-5.53.7.5.5 0 0 0 .87.5Zm-.34 3.7v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 1 1 0 1h-1a2.5 2.5 0 0 0 4.17-.25.5.5 0 0 1 .86.5 3.5 3.5 0 0 1-5.53.7ZM5.5 11c.28 0 .5.23.5.5V14h2.5a.5.5 0 1 1 0 1H6v2.5a.5.5 0 0 1-1 0V15H2.5a.5.5 0 1 1 0-1H5v-2.5c0-.27.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const SymbolsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SymbolsFilledIcon, 'SymbolsFilled');

const SymbolsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.14 7.97c.2.2.51.2.7 0l2.56-2.55a2 2 0 1 0-2.83-2.83l-.07.08-.08-.08a2 2 0 0 0-2.83 2.83l2.55 2.55ZM12.3 4.71a1 1 0 1 1 1.42-1.41l.79.78.5-.5.28-.28a1 1 0 0 1 1.43 0 1 1 0 0 1 0 1.4L14.5 6.92l-2.2-2.2ZM2 5.51a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM5.5 3c-.5 0-.98.15-1.38.4L7.6 6.89A2.5 2.5 0 0 0 5.5 3ZM3 5.5a2.5 2.5 0 0 0 3.88 2.08L3.4 4.12C3.15 4.52 3 5 3 5.5Zm9.34 7.74A2.5 2.5 0 0 1 16.5 13h-1a.5.5 0 1 0 0 1h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v.55a3.49 3.49 0 0 0-5.53.7.5.5 0 0 0 .87.5Zm-.34 3.7v.55a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 1 1 0 1h-1a2.5 2.5 0 0 0 4.17-.25.5.5 0 0 1 .86.5 3.5 3.5 0 0 1-5.53.7ZM5.5 11c.28 0 .5.23.5.5V14h2.5a.5.5 0 1 1 0 1H6v2.5a.5.5 0 0 1-1 0V15H2.5a.5.5 0 1 1 0-1H5v-2.5c0-.27.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const SymbolsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SymbolsRegularIcon, 'SymbolsRegular');

const SyncOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.94 9H12.3l.67-2.36a.5.5 0 0 0-.96-.28l-2 7a.5.5 0 0 0 .96.28L12.02 10H18a8 8 0 0 1-16 0h5.98l-.96 3.36a.5.5 0 0 0 .96.28l2-7a.5.5 0 0 0-.96-.28L8.27 9h-6.2a8 8 0 0 1 15.87 0Z",
    fill: primaryFill
  }));
};

export const SyncOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyncOffFilledIcon, 'SyncOffFilled');

const SyncOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-7a7 7 0 0 0-6.93 6h5.2l.75-2.64a.5.5 0 1 1 .96.28l-2 7a.5.5 0 1 1-.96-.28L7.98 10H3a7 7 0 1 0 14 0h-4.98l-1.04 3.64a.5.5 0 1 1-.96-.28l2-7a.5.5 0 1 1 .96.28L12.31 9h4.62A7 7 0 0 0 10 3Z",
    fill: primaryFill
  }));
};

export const SyncOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyncOffRegularIcon, 'SyncOffRegular');